var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f2288;\n      }\n\n      .cls-2 {\n        fill: #2f1c6b;\n      }\n\n      .cls-3 {\n        fill: #fed442;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-5 {\n        fill: #fec633;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-7 {\n        fill: #311d6f;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-9 {\n        fill: #6327cb;\n      }\n\n      .cls-10 {\n        fill: #6a28d7;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-12 {\n        fill: #7229e6;\n      }\n\n      .cls-13 {\n        fill: #fece3c;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-15 {\n        fill: #4d25a1;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-17 {\n        fill: #6027c6;\n      }\n\n      .cls-18 {\n        fill: #fff;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-20 {\n        fill: #eba51d;\n      }\n\n      .cls-21 {\n        fill: #6528cf;\n      }\n\n      .cls-22 {\n        fill: #3b2181;\n      }\n\n      .cls-23 {\n        fill: #5a26ba;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-25 {\n        fill: #feb51f;\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-27 {\n        fill: #4f25a6;\n      }\n\n      .cls-28 {\n        fill: #cd9221;\n      }\n\n      .cls-29 {\n        fill: #c48c23;\n      }\n\n      .cls-30 {\n        fill: #fece3b;\n      }\n\n      .cls-31 {\n        fill: #fec734;\n      }\n\n      .cls-32 {\n        fill: #452492;\n      }\n\n      .cls-33 {\n        fill: #fbaf1a;\n      }\n\n      .cls-34 {\n        fill: #5426af;\n      }\n\n      .cls-35 {\n        fill: #d49620;\n      }\n\n      .cls-36 {\n        fill: #5a26b9;\n      }\n\n      .cls-37 {\n        fill: #6427cd;\n      }\n\n      .cls-38 {\n        fill: #fec42f;\n      }\n\n      .cls-39 {\n        fill: #3b2182;\n      }\n\n      .cls-40 {\n        fill: #febb25;\n      }\n\n      .cls-41 {\n        opacity: .5;\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-43 {\n        fill: #6e28df;\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-45 {\n        fill: #ca9022;\n      }\n\n      .cls-46 {\n        fill: #5d27bf;\n      }\n\n      .cls-47 {\n        fill: #6327ca;\n      }\n\n      .cls-48 {\n        fill: #4b259d;\n      }\n\n      .cls-49 {\n        mix-blend-mode: lighten;\n      }\n\n      .cls-49, .cls-50 {\n        opacity: .33;\n      }\n\n      .cls-51 {\n        fill: #feb620;\n      }\n\n      .cls-52 {\n        fill: #c98f22;\n      }\n\n      .cls-53 {\n        fill: #5326ad;\n      }\n\n      .cls-54 {\n        fill: #6427cc;\n      }\n\n      .cls-55 {\n        fill: #6c28dc;\n      }\n\n      .cls-56 {\n        fill: #5926b7;\n      }\n\n      .cls-57 {\n        fill: #5e27c2;\n      }\n\n      .cls-58 {\n        fill: #f6ac1b;\n      }\n\n      .cls-59 {\n        fill: #7029e3;\n      }\n\n      .cls-60 {\n        fill: #6f29e1;\n      }\n\n      .cls-61 {\n        fill: #fec32e;\n      }\n\n      .cls-62 {\n        fill: #5526b1;\n      }\n\n      .cls-63 {\n        fill: #482499;\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-65 {\n        fill: #e9a31d;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-67 {\n        fill: #f1a91c;\n      }\n\n      .cls-68 {\n        isolation: isolate;\n      }\n\n      .cls-69 {\n        fill: #fec22d;\n      }\n\n      .cls-70 {\n        fill: #4c25a0;\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-72 {\n        fill: #fecb38;\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-75 {\n        fill: #49259b;\n      }\n\n      .cls-76 {\n        fill: #da9a1f;\n      }\n\n      .cls-77 {\n        fill: #5d27c0;\n      }\n\n      .cls-78 {\n        fill: #5226ab;\n      }\n\n      .cls-79 {\n        fill: #6b28da;\n      }\n\n      .cls-80 {\n        fill: #3a207f;\n      }\n\n      .cls-81 {\n        fill: #49259a;\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-83 {\n        fill: #fed13f;\n      }\n\n      .cls-84 {\n        fill: #fed745;\n      }\n\n      .cls-85 {\n        fill: #5e27c1;\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-87 {\n        fill: #6628d0;\n      }\n\n      .cls-88 {\n        fill: #f0a81c;\n      }\n\n      .cls-89 {\n        fill: #dc9c1f;\n      }\n\n      .cls-90 {\n        fill: #fed543;\n      }\n\n      .cls-91 {\n        fill: #d09421;\n      }\n\n      .cls-92 {\n        fill: #fec631;\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-95 {\n        fill: #cf9321;\n      }\n\n      .cls-96 {\n        fill: #f8ad1b;\n      }\n\n      .cls-97 {\n        fill: #311d6e;\n      }\n\n      .cls-98 {\n        fill: #feb923;\n      }\n\n      .cls-99 {\n        fill: #dd9c1f;\n      }\n\n      .cls-100 {\n        fill: #5f27c3;\n      }\n\n      .cls-101 {\n        fill: #301c6c;\n      }\n\n      .cls-102 {\n        fill: #7129e5;\n      }\n\n      .cls-103 {\n        fill: #5b26bb;\n      }\n\n      .cls-104 {\n        fill: #cb9121;\n      }\n\n      .cls-105 {\n        fill: #3a2080;\n      }\n\n      .cls-106 {\n        fill: #feb721;\n      }\n\n      .cls-107 {\n        fill: #4f25a5;\n      }\n\n      .cls-108 {\n        fill: #5125a8;\n      }\n\n      .cls-109 {\n        fill: #febe28;\n      }\n\n      .cls-110 {\n        fill: #f7ac1b;\n      }\n\n      .cls-111 {\n        fill: #3c2183;\n      }\n\n      .cls-112 {\n        fill: #faae1b;\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-114 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-115 {\n        fill: #de9d1f;\n      }\n\n      .cls-116 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-117 {\n        fill: #e19e1e;\n      }\n\n      .cls-118 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-119 {\n        fill: #5726b4;\n      }\n\n      .cls-120 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-122 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-123 {\n        fill: #6227c9;\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-125 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-126 {\n        fill: #e09e1e;\n      }\n\n      .cls-127 {\n        fill: #fec12c;\n      }\n\n      .cls-128 {\n        fill: #cc9121;\n      }\n\n      .cls-129 {\n        fill: #fed847;\n      }\n\n      .cls-130 {\n        fill: #feca37;\n      }\n\n      .cls-131 {\n        fill: #febf2a;\n      }\n\n      .cls-132 {\n        fill: #6527ce;\n      }\n\n      .cls-133 {\n        fill: #462495;\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-135 {\n        fill: #febe29;\n      }\n\n      .cls-136 {\n        fill: #c38b23;\n      }\n\n      .cls-137 {\n        fill: #5826b6;\n      }\n\n      .cls-138 {\n        fill: #d59720;\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-140 {\n        fill: #c68d22;\n      }\n\n      .cls-141 {\n        fill: #6f29e0;\n      }\n\n      .cls-142 {\n        fill: #e8a31d;\n      }\n\n      .cls-143 {\n        fill: #e5a11e;\n      }\n\n      .cls-144 {\n        fill: #42238e;\n      }\n\n      .cls-145 {\n        fill: #432490;\n      }\n\n      .cls-146 {\n        fill: #fdb01a;\n      }\n\n      .cls-147 {\n        fill: #f3aa1c;\n      }\n\n      .cls-148 {\n        fill: #5f27c4;\n      }\n\n      .cls-149 {\n        fill: #d39620;\n      }\n\n      .cls-150 {\n        fill: #341e74;\n      }\n\n      .cls-151 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-152 {\n        fill: #381f7a;\n      }\n\n      .cls-153 {\n        opacity: .75;\n      }\n\n      .cls-154 {\n        fill: #6728d2;\n      }\n\n      .cls-155 {\n        fill: #fec530;\n      }\n\n      .cls-156 {\n        fill: #5125a9;\n      }\n\n      .cls-157 {\n        fill: #6227c8;\n      }\n\n      .cls-158 {\n        fill: #c88f22;\n      }\n\n      .cls-159 {\n        fill: #fed644;\n      }\n\n      .cls-160 {\n        fill: #5426ae;\n      }\n\n      .cls-161 {\n        fill: #feb41d;\n      }\n\n      .cls-162 {\n        fill: #371f79;\n      }\n\n      .cls-163 {\n        fill: #4b259e;\n      }\n\n      .cls-164 {\n        fill: #feb21b;\n      }\n\n      .cls-165 {\n        fill: #361f77;\n      }\n\n      .cls-166 {\n        fill: #6828d4;\n      }\n\n      .cls-167 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-168 {\n        fill: #c78e22;\n      }\n\n      .cls-169 {\n        fill: #6b28d9;\n      }\n\n      .cls-170 {\n        fill: #fedb4a;\n      }\n\n      .cls-171 {\n        fill: #fed03e;\n      }\n\n      .cls-172 {\n        fill: #e4a01e;\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-174 {\n        fill: #4a259c;\n      }\n\n      .cls-175 {\n        fill: #381f7b;\n      }\n\n      .cls-176 {\n        fill: #fed341;\n      }\n\n      .cls-177 {\n        fill: #6628d1;\n      }\n\n      .cls-178 {\n        fill: #fec02b;\n      }\n\n      .cls-179 {\n        fill: #6d28dd;\n      }\n\n      .cls-180 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-181 {\n        fill: #7229e7;\n      }\n\n      .cls-182 {\n        fill: #f5ab1b;\n      }\n\n      .cls-183 {\n        fill: #6928d6;\n      }\n\n      .cls-184 {\n        fill: #e39f1e;\n      }\n\n      .cls-185 {\n        fill: #5826b5;\n      }\n\n      .cls-186 {\n        fill: #fec835;\n      }\n\n      .cls-187 {\n        fill: #4d25a2;\n      }\n\n      .cls-188 {\n        fill: #5b26bc;\n      }\n\n      .cls-189 {\n        fill: #3e2286;\n      }\n\n      .cls-190 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-191 {\n        fill: #e7a21d;\n      }\n\n      .cls-192 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-193 {\n        fill: #5926b8;\n      }\n\n      .cls-194 {\n        fill: #f4ab1b;\n      }\n\n      .cls-195 {\n        fill: #6928d5;\n      }\n\n      .cls-196 {\n        fill: #d89920;\n      }\n\n      .cls-197 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-198 {\n        fill: #d79820;\n      }\n\n      .cls-199 {\n        fill: #472497;\n      }\n\n      .cls-200 {\n        fill: #41238c;\n      }\n\n      .cls-201 {\n        fill: #e29f1e;\n      }\n\n      .cls-202 {\n        fill: #40228a;\n      }\n\n      .cls-203 {\n        fill: #feb822;\n      }\n\n      .cls-204 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-205 {\n        fill: #ffc727;\n      }\n\n      .cls-206 {\n        fill: #db9b1f;\n      }\n\n      .cls-207 {\n        fill: #482498;\n      }\n\n      .cls-208 {\n        fill: #c58d22;\n      }\n\n      .cls-209 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-210 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-211 {\n        fill: #4e25a3;\n      }\n\n      .cls-212 {\n        fill: #5726b3;\n      }\n\n      .cls-213 {\n        fill: #c18a23;\n      }\n\n      .cls-214 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-215 {\n        fill: #feb11a;\n      }\n\n      .cls-216 {\n        fill: #6e28de;\n      }\n\n      .cls-217 {\n        fill: #eaa41d;\n      }\n\n      .cls-218 {\n        fill: none;\n      }\n\n      .cls-219 {\n        fill: #d99a1f;\n      }\n\n      .cls-220 {\n        fill: #5c27be;\n      }\n\n      .cls-221 {\n        fill: #5626b2;\n      }\n\n      .cls-222 {\n        fill: #fed240;\n      }\n\n      .cls-223 {\n        fill: #eea71c;\n      }\n\n      .cls-224 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-225 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-226 {\n        fill: #42238d;\n      }\n\n      .cls-227 {\n        fill: #f2a91c;\n      }\n\n      .cls-228 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-229 {\n        fill: #fcb01a;\n      }\n\n      .cls-230 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-231 {\n        fill: #462494;\n      }\n\n      .cls-232 {\n        fill: #febd27;\n      }\n\n      .cls-233 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-234 {\n        fill: #feb51e;\n      }\n\n      .cls-235 {\n        fill: #fecf3d;\n      }\n\n      .cls-236 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-237 {\n        fill: #321d71;\n      }\n\n      .cls-238 {\n        fill: #7029e2;\n      }\n\n      .cls-239 {\n        fill: #fed746;\n      }\n\n      .cls-240 {\n        fill: #4c259f;\n      }\n\n      .cls-241 {\n        fill: #5225aa;\n      }\n\n      .cls-242 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-243 {\n        fill: #351e76;\n      }\n\n      .cls-244 {\n        fill: #3e2287;\n      }\n\n      .cls-245 {\n        fill: #efa71c;\n      }\n\n      .cls-246 {\n        fill: #4e25a4;\n      }\n\n      .cls-247 {\n        fill: #472496;\n      }\n\n      .cls-248 {\n        fill: #301c6d;\n      }\n\n      .cls-249 {\n        fill: #321d70;\n      }\n\n      .cls-250 {\n        fill: #eca51d;\n      }\n\n      .cls-251 {\n        fill: #6027c5;\n      }\n\n      .cls-252 {\n        fill: #febc26;\n      }\n\n      .cls-253 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-254 {\n        fill: #3f2289;\n      }\n\n      .cls-255 {\n        fill: #341e73;\n      }\n\n      .cls-256 {\n        fill: #6c28db;\n      }\n\n      .cls-257 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-258 {\n        fill: #6828d3;\n      }\n\n      .cls-259 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-260 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-261 {\n        fill: #feb31c;\n      }\n\n      .cls-262 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-263 {\n        fill: #5526b0;\n      }\n\n      .cls-264 {\n        fill: #7329e8;\n      }\n\n      .cls-265 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-266 {\n        fill: #d29520;\n      }\n\n      .cls-267 {\n        fill: #d69820;\n      }\n\n      .cls-268 {\n        fill: #feda49;\n      }\n\n      .cls-269 {\n        fill: #5025a7;\n      }\n\n      .cls-270 {\n        fill: #fecc39;\n      }\n\n      .cls-271 {\n        fill: #fec936;\n      }\n\n      .cls-272 {\n        fill: #39207c;\n      }\n\n      .cls-273 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-274 {\n        fill: #39207d;\n      }\n\n      .cls-275 {\n        fill: #ce9221;\n      }\n\n      .cls-276 {\n        fill: #43248f;\n      }\n\n      .cls-277 {\n        fill: #fed948;\n      }\n\n      .cls-278 {\n        fill: #452493;\n      }\n\n      .cls-279 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-280 {\n        fill: #351e75;\n      }\n\n      .cls-281 {\n        fill: #c28b23;\n      }\n\n      .cls-282 {\n        fill: #fecd3a;\n      }\n\n      .cls-283 {\n        fill: #feba24;\n      }\n\n      .cls-284 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-285 {\n        fill: #6127c7;\n      }\n\n      .cls-286 {\n        fill: #7129e4;\n      }\n\n      .cls-287 {\n        fill: #6a28d8;\n      }\n\n      .cls-288 {\n        mix-blend-mode: multiply;\n        opacity: .59;\n      }\n\n      .cls-289 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-290 {\n        fill: #41238b;\n      }\n\n      .cls-291 {\n        fill: #d19421;\n      }\n\n      .cls-292 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-293 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-294 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-295 {\n        fill: #e6a11e;\n      }\n\n      .cls-296 {\n        fill: #331e72;\n      }\n\n      .cls-297 {\n        fill: #5326ac;\n      }\n\n      .cls-298 {\n        fill: #f9ae1b;\n      }\n\n      .cls-299 {\n        fill: #3d2184;\n      }\n\n      .cls-300 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-301 {\n        fill: #eda61d;\n      }\n\n      .cls-302 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-303 {\n        fill: #3d2185;\n      }\n\n      .cls-304 {\n        fill: #361f78;\n      }\n\n      .cls-305 {\n        fill: #442491;\n      }\n\n      .cls-306 {\n        clip-path: url(#clippath-35);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m106.15,63.58l.71,2.85c1.07,4.31-3.96,9.01-11.69,10.92s-14.37.11-15.44-4.19l-.71-2.85,27.13-6.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m106.15,63.58l.71,2.85c1.07,4.31-3.96,9.01-11.69,10.92s-14.37.11-15.44-4.19l-.71-2.85,27.13-6.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 92.59,
    cy: 66.97,
    rx: 12.38,
    ry: 6.19,
    transform: "translate(-13.4 24.26) rotate(-13.93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m88.53,75.3c-4.98,0-8.73-1.81-9.51-4.96-1.07-4.31,3.96-9.01,11.69-10.92,7.73-1.92,14.37-.12,15.44,4.19s-3.96,9.01-11.69,10.92c-2.09.52-4.09.76-5.93.76Zm8.05-13.43c-1.55,0-3.28.2-5.1.65-5.99,1.49-9.88,4.95-9.36,7.06.52,2.1,5.58,3.35,11.58,1.86,5.99-1.49,9.88-4.95,9.36-7.06-.36-1.47-2.93-2.51-6.47-2.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 92.59,
    cy: 66.97,
    rx: 12.38,
    ry: 6.19,
    transform: "translate(-13.4 24.26) rotate(-13.93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m104.06,38.6l-69.32,50.55,41.37,1.28,69.3-14.39s-5.88-23.79-6.51-24.35-34.85-13.1-34.85-13.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m105.99,47.67c-9.36,14.4-32.65,27.31-60.51,39.72l35.78-.02,60.13-12.48s-4.84-17.78-5.38-18.18-30.02-9.04-30.02-9.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m110.73,55.42c-7.76,10.88-24.06,20.64-45.3,29.73h26.79s45.01-9.36,45.01-9.36c0,0-3.63-13.31-4.03-13.61s-22.47-6.77-22.47-6.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m29.52,27.54l1.1,2.13c1.66,3.22-1.44,7.9-7.21,10.88-5.78,2.99-11.39,2.81-13.05-.4l-1.1-2.13,20.26-10.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m29.52,27.54l1.1,2.13c1.66,3.22-1.44,7.9-7.21,10.88-5.78,2.99-11.39,2.81-13.05-.4l-1.1-2.13,20.26-10.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 19.4,
    cy: 32.8,
    rx: 10.1,
    ry: 5.05,
    transform: "translate(-12.9 12.58) rotate(-27.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m14.58,40.57c-2.49,0-4.44-.85-5.31-2.53-1.66-3.22,1.44-7.9,7.21-10.88s11.39-2.81,13.05.4c.86,1.66.47,3.75-1.09,5.9-1.37,1.88-3.55,3.66-6.12,4.99-2.75,1.42-5.47,2.13-7.74,2.13Zm9.69-12.93c-1.79,0-4.16.57-6.59,1.83-4.47,2.31-6.91,5.8-6.09,7.37.81,1.57,5.07,1.6,9.54-.71,4.47-2.31,6.91-5.8,6.1-7.37-.37-.72-1.45-1.11-2.95-1.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 19.4,
    cy: 32.8,
    rx: 10.1,
    ry: 5.05,
    transform: "translate(-12.9 12.58) rotate(-27.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m23.13,8.11L-22.32,61.36l33.07-6.81,52.28-24.54s-9.17-17.77-9.77-18.09-30.14-3.8-30.14-3.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m26.38,14.94c-4.7,13.2-20.74,27.86-40.51,42.98l28.4-6.79,45.36-21.29s-7.21-13.19-7.71-13.41-25.54-1.49-25.54-1.49Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m31.61,20.19c-4.1,10.11-15.19,20.94-30.33,32.18l21.26-5.08,33.96-15.94s-5.4-9.88-5.77-10.04-19.12-1.11-19.12-1.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m94.44,11.88l.84,1.21c1.27,1.83-.25,4.94-3.55,7.22s-6.74,2.62-8.01.78l-.84-1.21,11.56-8.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m94.44,11.88l.84,1.21c1.27,1.83-.25,4.94-3.55,7.22s-6.74,2.62-8.01.78l-.84-1.21,11.56-8.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 88.67,
    cy: 15.89,
    rx: 6.23,
    ry: 3.11,
    transform: "translate(6.73 53.32) rotate(-34.71)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m85.55,21.07c-1.2,0-2.12-.4-2.66-1.17-.66-.95-.58-2.26.2-3.69.69-1.26,1.88-2.51,3.35-3.53,1.47-1.02,3.06-1.69,4.48-1.89,1.62-.23,2.87.16,3.53,1.11.66.95.58,2.26-.2,3.69-.69,1.26-1.88,2.51-3.35,3.53-1.47,1.02-3.06,1.69-4.48,1.89-.3.04-.59.06-.87.06Zm6.23-8.75c-.2,0-.41.02-.63.05-1.18.17-2.53.75-3.79,1.62-1.27.88-2.28,1.94-2.85,2.98-.46.85-.57,1.6-.29,2,.28.41,1.02.57,1.98.43,1.18-.17,2.53-.75,3.79-1.62,1.27-.88,2.28-1.94,2.85-2.98.46-.85.57-1.6.29-2h0c-.22-.31-.7-.48-1.35-.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 88.67,
    cy: 15.89,
    rx: 6.23,
    ry: 3.11,
    transform: "translate(6.73 53.32) rotate(-34.71)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m89,.51l-23.57,36.13,19.68-6.78,30.01-19.13S108.11.6,107.72.45s-18.72.06-18.72.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m91.53,4.43c-1.83,8.44-10.48,18.67-21.36,29.47l16.82-6.39,26.04-16.6s-5.45-7.49-5.77-7.59-15.73,1.11-15.73,1.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m95.14,7.22c-1.71,6.5-7.63,14-15.99,22.06l12.59-4.79,19.49-12.42s-4.08-5.61-4.32-5.68-11.77.83-11.77.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m76.8,30.76l-1.71.63c-2.59.95-5.84-1.84-7.55-6.49s-1.05-8.88,1.55-9.83l1.71-.63,6,16.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m76.8,30.76l-1.71.63c-2.59.95-5.84-1.84-7.55-6.49s-1.05-8.88,1.55-9.83l1.71-.63,6,16.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 73.78,
    cy: 22.61,
    rx: 3.85,
    ry: 7.7,
    transform: "translate(-3.27 26.86) rotate(-20.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m75.73,30.95c-1.07,0-2.21-.54-3.31-1.57-1.29-1.22-2.43-3.03-3.19-5.1-1.71-4.65-1.05-8.88,1.55-9.83,2.59-.95,5.84,1.84,7.55,6.49,1.71,4.65,1.05,8.88-1.55,9.83-.34.12-.69.19-1.05.19Zm-3.9-14.71c-.13,0-.25.02-.37.06-1.27.47-1.69,3.68-.37,7.28.66,1.79,1.61,3.33,2.69,4.34.87.82,1.73,1.18,2.31.97h0c1.27-.47,1.69-3.68.37-7.28-1.21-3.28-3.31-5.37-4.63-5.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 73.78,
    cy: 22.61,
    rx: 3.85,
    ry: 7.7,
    transform: "translate(-3.27 26.86) rotate(-20.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m92.11,27.78L56.14-11.66l2.01,25.67,13.6,41.88s14.32-5.25,14.61-5.67,5.74-22.44,5.74-22.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m86.63,29.58c-9.54-4.81-19.11-18.34-28.67-34.73l2.44,22.13,11.8,36.34s10.67-4.2,10.88-4.56,3.55-19.18,3.55-19.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m82.16,33.04c-7.26-4.06-14.4-13.48-21.46-26l1.83,16.57,8.83,27.2s7.98-3.15,8.14-3.41,2.66-14.36,2.66-14.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m31.83,79.26l-2.12,3.27c-3.21,4.94-11.77,3.93-19.91-2.35-8.14-6.28-11.85-14.75-8.64-19.69l2.12-3.27,28.56,22.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m31.83,79.26l-2.12,3.27c-3.21,4.94-11.77,3.93-19.91-2.35-8.14-6.28-11.85-14.75-8.64-19.69l2.12-3.27,28.56,22.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 17.53,
    cy: 68.27,
    rx: 8.18,
    ry: 16,
    transform: "translate(-46.39 38.57) rotate(-50.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m25.32,82.31c-4.01,0-9.03-2-13.55-5.49C3.7,70.58-.02,62.22,3.13,57.37c1.04-1.59,2.71-2.63,4.84-2.99,4.24-.72,10.1,1.33,15.31,5.35,8.08,6.24,11.79,14.59,8.64,19.44h0c-1.04,1.6-2.71,2.63-4.84,2.99-.56.1-1.15.14-1.77.14Zm-15.51-23.9c-.4,0-.78.03-1.13.09-.96.16-1.65.55-2.04,1.15-1.62,2.49,1.33,8.95,7.69,13.87,4.25,3.28,8.98,5.07,12.06,4.54.96-.16,1.65-.55,2.04-1.15h0c1.62-2.49-1.33-8.95-7.69-13.87-3.76-2.9-7.89-4.63-10.93-4.63Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-218",
    cx: 17.53,
    cy: 68.27,
    rx: 8.18,
    ry: 16,
    transform: "translate(-46.39 38.57) rotate(-50.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m53.81,54.86L-50.77,28.26l32.59,43.88,70.28,58.8s17.75-27.27,17.77-28.4-16.05-47.67-16.05-47.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m46.78,64.93c-21.3,3.16-52.58-9.41-87.11-27.16l29.26,36.96,60.97,51.01s12.9-20.84,12.84-21.74-15.96-39.07-15.96-39.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m43.31,76.73c-16.66,1.67-39.24-6.48-65.21-20.33L0,84.07l45.64,38.19s9.66-15.6,9.61-16.28-11.95-29.25-11.95-29.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m99.16,45.13c-.12-2.84-.62-5.13-1.52-7.09-2.61-5.74-8.33-9.04-15.68-9.04-5.36,0-9.7,1.56-12.72,4.38v-12.65h-12.25c-4.5,0-7.88,2-9.27,5.22,0-.06-.02-.12-.02-.19,0-.07-.02-.15-.03-.22,0-.07-.02-.15-.03-.22-.45-4.05-4.02-7.02-8.67-7.06h-.02c-2.9,0-5.39,1.14-6.98,2.97h-14.93v40.16h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.06c-.2,1.35-.31,2.92-.31,4.69,0,1.47.03,2.63.1,3.64.08,1.16.19,2.15.34,3.01.16.95.42,1.87.75,2.72.4.98.86,1.77,1.42,2.46.31.39.67.74,1.05,1.07.03.03.06.05.09.08.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.06.04.08.07.01,0,.02.02.04.03.01,0,.02.02.03.03.02.02.05.04.07.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06s.05.04.08.06c.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.06.05.08.07.28.24.58.46.9.66.6.36,1.26.63,1.97.83.63.17,1.35.3,2.12.38.72.07,1.55.11,2.43.11l30.52.07c3.56,0,5.98-.92,7.53-2.27.02-.02.04-.03.05-.05.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.02-.02.05-.04.07-.06,2.19-1.8,3.16-4.21,3.23-6.54.09-2.37-.6-4.45-1.9-6,.74-1.41,1.1-3.16,1.02-5.15-.02-.47-.07-.92-.14-1.36.02-.03.04-.06.06-.09.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.99-1.42,1.7-3.03,2.1-4.81.45-1.02.42-5.32.42-5.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m80.66,93.42c-2.18,1.89-5.26,2.86-9.15,2.86l-30.52-.07c-.96,0-1.87-.04-2.68-.13-.9-.09-1.75-.24-2.52-.45-.93-.25-1.8-.62-2.59-1.09-.46-.28-.87-.59-1.26-.92,0,0-.05-.04-.09-.07,0,0-.04-.03-.08-.07,0,0-.55-.45-.55-.45l-.44-.36s-.15-.13-.15-.13c0,0-.05-.04-.09-.08,0,0-.84-.69-.84-.69l-.31-.25s-.63-.52-.63-.52l-.7-.58-.44-.36s-.15-.13-.15-.13c0,0-2.26-1.86-2.26-1.86l-1-.82c-.47-.41-.93-.87-1.33-1.37-.72-.88-1.3-1.89-1.79-3.09-.41-1.03-.71-2.11-.9-3.24-.17-.93-.29-2.01-.37-3.27-.07-1.06-.11-2.27-.11-3.8,0-.85.02-1.67.07-2.45h-.03v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11V18.75h16.37c2.08-1.9,4.94-2.97,8.02-2.97,4.19.03,7.77,2.01,9.7,5.07,2.17-1.67,5.05-2.6,8.35-2.6h14.74v10.44c2.92-1.44,6.38-2.18,10.23-2.18,8.36,0,14.9,3.83,17.94,10.5,1.04,2.24,1.61,4.87,1.75,8.01v.09c.03,2.91-.15,4.93-.51,6.04-.47,2.01-1.29,3.87-2.45,5.53l-7.08,10.1c.02.21.03.42.04.63.08,1.76-.15,3.45-.67,4.94,1.1,1.84,1.65,4.06,1.56,6.4-.1,3.28-1.57,6.25-4.14,8.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m99.16,45.13c-.12-2.84-.62-5.13-1.52-7.09-2.61-5.74-8.33-9.04-15.68-9.04-5.36,0-9.7,1.56-12.72,4.38v-12.65h-12.25c-4.5,0-7.88,2-9.27,5.22,0-.06-.02-.12-.02-.19,0-.07-.02-.15-.03-.22,0-.07-.02-.15-.03-.22-.45-4.05-4.02-7.02-8.67-7.06h-.02c-2.9,0-5.39,1.14-6.98,2.97h-14.93v40.16h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.11v.13h.06c-.2,1.35-.31,2.92-.31,4.69,0,1.47.03,2.63.1,3.64.08,1.16.19,2.15.34,3.01.16.95.42,1.87.75,2.72.4.98.86,1.77,1.42,2.46.31.39.67.74,1.05,1.07.03.03.06.05.09.08.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.06.04.08.07.01,0,.02.02.04.03.01,0,.02.02.03.03.02.02.05.04.07.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06s.05.04.08.06c.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.02.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.03.02.05.04.08.06.02.02.05.04.08.06.03.02.06.05.08.07.28.24.58.46.9.66.6.36,1.26.63,1.97.83.63.17,1.35.3,2.12.38.72.07,1.55.11,2.43.11l30.52.07c3.56,0,5.98-.92,7.53-2.27.02-.02.04-.03.05-.05.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.03-.02.05-.04.08-.06.02-.02.05-.04.07-.06,2.19-1.8,3.16-4.21,3.23-6.54.09-2.37-.6-4.45-1.9-6,.74-1.41,1.1-3.16,1.02-5.15-.02-.47-.07-.92-.14-1.36.02-.03.04-.06.06-.09.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.03-.05.07-.1.1-.14.99-1.42,1.7-3.03,2.1-4.81.45-1.02.42-5.32.42-5.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m41,92.89c-.86,0-1.65-.04-2.35-.11-.73-.07-1.4-.19-1.99-.35-.64-.17-1.23-.42-1.76-.74-.27-.16-.53-.36-.78-.57l-7.71-6.33c-.4-.34-.72-.67-.99-1-.51-.62-.93-1.36-1.29-2.25-.31-.79-.55-1.64-.7-2.54-.15-.84-.26-1.79-.33-2.93-.07-1-.1-2.14-.1-3.58,0-1.71.1-3.24.3-4.56l.14-.95h-.19v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11v-.13h-.11V22.07h14.48l.25-.29c1.48-1.71,3.79-2.68,6.35-2.68,4.23.03,7.46,2.63,7.87,6.32l.08.63.36,3.07,1.23-2.83c1.28-2.96,4.46-4.72,8.51-4.72h11.42v13.73l1.4-1.31c2.91-2.72,7.11-4.16,12.15-4.16,7.01,0,12.44,3.12,14.92,8.55.86,1.86,1.33,4.07,1.45,6.78.02,1.95-.11,4.41-.35,4.94l-.03.08-.02.08c-.37,1.65-1.03,3.16-1.97,4.51l-7.82,11.16.06.34c.08.47.12.87.13,1.25.08,1.8-.24,3.44-.92,4.73l-.26.49.36.43c1.2,1.43,1.79,3.3,1.71,5.43-.07,2.33-1.12,4.44-2.93,5.93l-7.73,6.31c-1.61,1.4-4.03,2.11-7.04,2.11h0l-30.52-.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m29.87,58.09h-9.51V24.56h9.51v33.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m117.25-108.69L-75.75,74.98,31.97,125.11h184.4S206.65-1.94,205.15-5.4c-1.5-3.46-87.9-103.29-87.9-103.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m120.14-60.58C92.29,2.69,28.4,43.72-47.31,77.34l93.46,37.64h159.98s-8.44-95.4-9.74-98S120.14-60.58,120.14-60.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m130.68-16.23C107.83,30.84,62.94,63.23,5.33,87.01l69.96,28.18h119.76s-6.32-71.42-7.29-73.36c-.97-1.94-57.09-58.06-57.09-58.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m43.69,58.09h-9.53v-25.33h9.53v25.33Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m117.25-108.69L-75.75,74.98,31.97,125.11h184.4S206.65-1.94,205.15-5.4c-1.5-3.46-87.9-103.29-87.9-103.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m120.14-60.58C92.29,2.69,28.4,43.72-47.31,77.34l93.46,37.64h159.98s-8.44-95.4-9.74-98S120.14-60.58,120.14-60.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m130.68-16.23C107.83,30.84,62.94,63.23,5.33,87.01l69.96,28.18h119.76s-6.32-71.42-7.29-73.36c-.97-1.94-57.09-58.06-57.09-58.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m50.34,58.09v-17.91h-3.73v-7.41h3.73v-3.29c0-3.22,2.44-5.41,6.65-5.41h8.93v6.54h-5.13c-1.31,0-1.75.6-1.75,1.4v.76h6.88v7.41h-6.88v17.91h-8.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m117.25-108.69L-75.75,74.98,31.97,125.11h184.4S206.65-1.94,205.15-5.4c-1.5-3.46-87.9-103.29-87.9-103.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m120.14-60.58C92.29,2.69,28.4,43.72-47.31,77.34l93.46,37.64h159.98s-8.44-95.4-9.74-98S120.14-60.58,120.14-60.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m130.68-16.23C107.83,30.84,62.94,63.23,5.33,87.01l69.96,28.18h119.76s-6.32-71.42-7.29-73.36c-.97-1.94-57.09-58.06-57.09-58.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m94.63,39.44c1.01,2.19,1.29,4.83,1.24,7.69h-18.37c.44,2.9,2.14,4.4,4.44,4.4,1.89,0,3.52-.85,4.03-3.04l9.74-.02c-.73,6.71-6.73,10.06-13.77,10.06-8.5,0-14.09-4.44-14.09-13.1s5.6-13.1,14.11-13.1c6.26,0,10.66,2.72,12.66,7.11Zm-8.52,3.2c-.05-.23-.09-.46-.16-.67-.58-1.93-2-2.92-3.98-2.92-2.14,0-3.64,1.2-4.26,3.59h8.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m117.25-108.69L-75.75,74.98,31.97,125.11h184.4S206.65-1.94,205.15-5.4c-1.5-3.46-87.9-103.29-87.9-103.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m120.14-60.58C92.29,2.69,28.4,43.72-47.31,77.34l93.46,37.64h159.98s-8.44-95.4-9.74-98S120.14-60.58,120.14-60.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m130.68-16.23C107.83,30.84,62.94,63.23,5.33,87.01l69.96,28.18h119.76s-6.32-71.42-7.29-73.36c-.97-1.94-57.09-58.06-57.09-58.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m38.95,21.59c3.29.02,5.43,2.07,5.43,4.6s-2.14,4.63-5.43,4.63-5.5-2.07-5.5-4.63,2.16-4.6,5.5-4.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m117.25-108.69L-75.75,74.98,31.97,125.11h184.4S206.65-1.94,205.15-5.4c-1.5-3.46-87.9-103.29-87.9-103.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m120.14-60.58C92.29,2.69,28.4,43.72-47.31,77.34l93.46,37.64h159.98s-8.44-95.4-9.74-98S120.14-60.58,120.14-60.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "m130.68-16.23C107.83,30.84,62.94,63.23,5.33,87.01l69.96,28.18h119.76s-6.32-71.42-7.29-73.36c-.97-1.94-57.09-58.06-57.09-58.06Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 0,
    width: 107,
    height: 107
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "79.01 70.31 81.24 79.27 79.01 79.27 79.01 70.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "79.01 68.6 79.06 68.59 81.71 79.27 81.24 79.27 79.01 70.31 79.01 68.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "79.06 68.59 79.5 68.48 82.18 79.27 81.71 79.27 79.06 68.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "79.5 68.48 79.95 68.37 82.65 79.27 82.18 79.27 79.5 68.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "79.95 68.37 80.39 68.26 83.12 79.27 82.65 79.27 79.95 68.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "80.39 68.26 80.84 68.15 83.6 79.27 83.12 79.27 80.39 68.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "80.84 68.15 81.28 68.04 84.07 79.27 83.6 79.27 80.84 68.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "81.28 68.04 81.73 67.93 84.54 79.27 84.07 79.27 81.28 68.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "81.73 67.93 82.17 67.82 85.01 79.27 84.54 79.27 81.73 67.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "82.17 67.82 82.62 67.71 85.49 79.27 85.01 79.27 82.17 67.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "82.62 67.71 83.06 67.6 85.96 79.27 85.49 79.27 82.62 67.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "83.06 67.6 83.51 67.49 86.43 79.27 85.96 79.27 83.06 67.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "83.51 67.49 83.95 67.38 86.9 79.27 86.43 79.27 83.51 67.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "83.95 67.38 84.4 67.27 87.37 79.27 86.9 79.27 83.95 67.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "84.4 67.27 84.84 67.16 87.85 79.27 87.37 79.27 84.4 67.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "84.84 67.16 85.29 67.05 88.32 79.27 87.85 79.27 84.84 67.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "85.29 67.05 85.73 66.94 88.79 79.27 88.32 79.27 85.29 67.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "85.73 66.94 86.18 66.82 89.26 79.27 88.79 79.27 85.73 66.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "86.18 66.82 86.62 66.71 89.73 79.27 89.26 79.27 86.18 66.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "86.62 66.71 87.07 66.6 90.21 79.27 89.73 79.27 86.62 66.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "87.07 66.6 87.51 66.49 90.68 79.27 90.21 79.27 87.07 66.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "87.51 66.49 87.95 66.38 91.15 79.27 90.68 79.27 87.51 66.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "87.95 66.38 88.4 66.27 91.62 79.27 91.15 79.27 87.95 66.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "88.4 66.27 88.84 66.16 92.1 79.27 91.62 79.27 88.4 66.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "88.84 66.16 89.29 66.05 92.57 79.27 92.1 79.27 88.84 66.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "89.29 66.05 89.73 65.94 93.04 79.27 92.57 79.27 89.29 66.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "89.73 65.94 90.18 65.83 93.51 79.27 93.04 79.27 89.73 65.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "90.18 65.83 90.62 65.72 93.98 79.27 93.51 79.27 90.18 65.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "90.62 65.72 91.07 65.61 94.45 79.24 94.32 79.27 93.98 79.27 90.62 65.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 92.75,
    y: 65.35,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.69 24.51) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 93.2,
    y: 65.24,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.65 24.62) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 93.64,
    y: 65.13,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.61 24.72) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 94.09,
    y: 65.02,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.57 24.83) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 94.53,
    y: 64.91,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.53 24.93) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 94.98,
    y: 64.8,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.49 25.03) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 95.42,
    y: 64.69,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.45 25.14) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 95.87,
    y: 64.58,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.41 25.24) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 96.31,
    y: 64.47,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.37 25.34) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 96.76,
    y: 64.36,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.33 25.45) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 97.2,
    y: 64.25,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.29 25.55) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 97.65,
    y: 64.14,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.25 25.66) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 98.09,
    y: 64.03,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.21 25.76) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 98.53,
    y: 63.91,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.17 25.86) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 98.98,
    y: 63.8,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.13 25.97) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 99.42,
    y: 63.69,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.09 26.07) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 99.87,
    y: 63.58,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.05 26.18) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 100.31,
    y: 63.47,
    width: 0.46,
    height: 14.04,
    transform: "translate(-14.01 26.28) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "99.08 63.62 99.25 63.58 99.54 63.58 102.9 77.14 102.46 77.25 99.08 63.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "100.01 63.58 103.35 77.03 102.9 77.14 99.54 63.58 100.01 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "100.48 63.58 103.79 76.92 103.35 77.03 100.01 63.58 100.48 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "100.95 63.58 104.24 76.81 103.79 76.92 100.48 63.58 100.95 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "101.43 63.58 104.68 76.7 104.24 76.81 100.95 63.58 101.43 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "101.9 63.58 105.13 76.59 104.68 76.7 101.43 63.58 101.9 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "102.37 63.58 105.57 76.48 105.13 76.59 101.9 63.58 102.37 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "102.84 63.58 106.01 76.37 105.57 76.48 102.37 63.58 102.84 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "103.31 63.58 106.46 76.26 106.01 76.37 102.84 63.58 103.31 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "103.79 63.58 106.9 76.15 106.46 76.26 103.31 63.58 103.79 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "104.26 63.58 107.35 76.04 106.9 76.15 103.79 63.58 104.26 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "104.73 63.58 107.79 75.93 107.35 76.04 104.26 63.58 104.73 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "105.2 63.58 107.92 74.54 107.92 75.9 107.79 75.93 104.73 63.58 105.2 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "105.68 63.58 107.92 72.64 107.92 74.54 105.2 63.58 105.68 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "106.15 63.58 107.92 70.74 107.92 72.64 105.68 63.58 106.15 63.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "107.92 70.74 106.15 63.58 107.92 63.58 107.92 70.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 75.23,
    y: 69.68,
    width: 0.64,
    height: 15.79,
    transform: "translate(-16.45 20.47) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 76.36,
    y: 69.4,
    width: 0.64,
    height: 15.79,
    transform: "translate(-16.35 20.73) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 77.49,
    y: 69.12,
    width: 0.64,
    height: 15.79,
    transform: "translate(-16.25 21) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 78.61,
    y: 68.84,
    width: 0.64,
    height: 15.79,
    transform: "translate(-16.15 21.26) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 79.74,
    y: 68.56,
    width: 0.64,
    height: 15.79,
    transform: "translate(-16.05 21.52) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 80.87,
    y: 68.28,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.95 21.79) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 81.99,
    y: 68.01,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.85 22.05) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 83.12,
    y: 67.73,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.75 22.31) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 84.24,
    y: 67.45,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.65 22.57) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 85.37,
    y: 67.17,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.55 22.84) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 86.5,
    y: 66.89,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.45 23.1) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 87.62,
    y: 66.61,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.35 23.36) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 88.75,
    y: 66.33,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.25 23.63) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 89.87,
    y: 66.05,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.15 23.89) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 91,
    y: 65.77,
    width: 0.64,
    height: 15.79,
    transform: "translate(-15.05 24.15) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 92.13,
    y: 65.49,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.95 24.42) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 93.25,
    y: 65.21,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.85 24.68) rotate(-13.93)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 94.38,
    y: 64.93,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.75 24.94) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 95.5,
    y: 64.65,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.65 25.2) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 96.63,
    y: 64.37,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.55 25.47) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 97.75,
    y: 64.1,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.45 25.73) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 98.88,
    y: 63.82,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.35 25.99) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 100.01,
    y: 63.54,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.25 26.25) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 101.13,
    y: 63.26,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.15 26.52) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 102.26,
    y: 62.98,
    width: 0.64,
    height: 15.79,
    transform: "translate(-14.05 26.78) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 103.39,
    y: 62.7,
    width: 0.64,
    height: 15.79,
    transform: "translate(-13.95 27.04) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 104.51,
    y: 62.42,
    width: 0.64,
    height: 15.79,
    transform: "translate(-13.85 27.31) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 105.64,
    y: 62.14,
    width: 0.64,
    height: 15.79,
    transform: "translate(-13.74 27.57) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 106.76,
    y: 61.86,
    width: 0.64,
    height: 15.79,
    transform: "translate(-13.64 27.83) rotate(-13.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 107.89,
    y: 61.58,
    width: 0.64,
    height: 15.79,
    transform: "translate(-13.54 28.1) rotate(-13.93)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "79.75 66.64 81.73 74.63 79.75 74.63 79.75 66.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "79.75 64.49 82.26 74.63 81.73 74.63 79.75 66.64 79.75 64.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "79.75 62.35 82.79 74.63 82.26 74.63 79.75 64.49 79.75 62.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "79.75 62.07 80.18 61.96 83.32 74.63 82.79 74.63 79.75 62.35 79.75 62.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "80.18 61.96 80.68 61.84 83.86 74.63 83.32 74.63 80.18 61.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "80.68 61.84 81.18 61.71 84.39 74.63 83.86 74.63 80.68 61.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "81.18 61.71 81.68 61.59 84.92 74.63 84.39 74.63 81.18 61.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "81.68 61.59 82.19 61.47 85.45 74.63 84.92 74.63 81.68 61.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "82.19 61.47 82.69 61.34 85.98 74.63 85.45 74.63 82.19 61.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.69 61.34 83.19 61.22 86.51 74.63 85.98 74.63 82.69 61.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "83.19 61.22 83.69 61.09 87.05 74.63 86.51 74.63 83.19 61.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "83.69 61.09 84.19 60.97 87.58 74.63 87.05 74.63 83.69 61.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "84.19 60.97 84.69 60.84 88.11 74.63 87.58 74.63 84.19 60.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "84.69 60.84 85.19 60.72 88.64 74.63 88.11 74.63 84.69 60.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "85.19 60.72 85.69 60.6 89.17 74.63 88.64 74.63 85.19 60.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "85.69 60.6 86.19 60.47 89.7 74.63 89.17 74.63 85.69 60.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "86.19 60.47 86.69 60.35 90.23 74.63 89.7 74.63 86.19 60.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "86.69 60.35 87.19 60.22 90.77 74.63 90.23 74.63 86.69 60.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "87.19 60.22 87.69 60.1 91.3 74.63 90.77 74.63 87.19 60.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "87.69 60.1 88.19 59.97 91.83 74.63 91.3 74.63 87.69 60.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "88.19 59.97 88.69 59.85 92.36 74.63 91.83 74.63 88.19 59.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "88.69 59.85 89.2 59.73 92.89 74.63 92.36 74.63 88.69 59.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "89.2 59.73 89.7 59.6 93.42 74.63 92.89 74.63 89.2 59.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "89.7 59.6 90.2 59.48 93.96 74.63 93.42 74.63 89.7 59.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "90.2 59.48 90.7 59.35 94.48 74.59 94.34 74.63 93.96 74.63 90.2 59.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "90.7 59.35 90.84 59.32 91.22 59.32 94.98 74.47 94.48 74.59 90.7 59.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "91.75 59.32 95.48 74.35 94.98 74.47 91.22 59.32 91.75 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "92.28 59.32 95.98 74.22 95.48 74.35 91.75 59.32 92.28 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "92.82 59.32 96.48 74.1 95.98 74.22 92.28 59.32 92.82 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "93.35 59.32 96.98 73.97 96.48 74.1 92.82 59.32 93.35 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "93.88 59.32 97.48 73.85 96.98 73.97 93.35 59.32 93.88 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "94.41 59.32 97.98 73.72 97.48 73.85 93.88 59.32 94.41 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "94.94 59.32 98.48 73.6 97.98 73.72 94.41 59.32 94.94 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "95.47 59.32 98.99 73.48 98.48 73.6 94.94 59.32 95.47 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "96 59.32 99.49 73.35 98.99 73.48 95.47 59.32 96 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "96.54 59.32 99.99 73.23 99.49 73.35 96 59.32 96.54 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "97.07 59.32 100.49 73.1 99.99 73.23 96.54 59.32 97.07 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "97.6 59.32 100.99 72.98 100.49 73.1 97.07 59.32 97.6 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "98.13 59.32 101.49 72.85 100.99 72.98 97.6 59.32 98.13 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "98.66 59.32 101.99 72.73 101.49 72.85 98.13 59.32 98.66 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "99.19 59.32 102.49 72.61 101.99 72.73 98.66 59.32 99.19 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "99.73 59.32 102.99 72.48 102.49 72.61 99.19 59.32 99.73 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "100.26 59.32 103.49 72.36 102.99 72.48 99.73 59.32 100.26 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "100.79 59.32 103.99 72.23 103.49 72.36 100.26 59.32 100.79 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "101.32 59.32 104.49 72.11 103.99 72.23 100.79 59.32 101.32 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "101.85 59.32 104.99 71.99 104.49 72.11 101.32 59.32 101.85 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "102.38 59.32 105.43 71.6 105.43 71.88 104.99 71.99 101.85 59.32 102.38 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "102.92 59.32 105.43 69.45 105.43 71.6 102.38 59.32 102.92 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "103.45 59.32 105.43 67.31 105.43 69.45 102.92 59.32 103.45 59.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "105.43 67.31 103.45 59.32 105.43 59.32 105.43 67.31"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "81.6 71.05 82.06 72.92 81.6 72.92 81.6 71.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "81.6 68.63 82.66 72.92 82.06 72.92 81.6 71.05 81.6 68.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "81.6 66.21 83.26 72.92 82.66 72.92 81.6 68.63 81.6 66.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "81.6 63.79 83.86 72.92 83.26 72.92 81.6 66.21 81.6 63.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "81.6 63.26 82.04 63.15 84.46 72.92 83.86 72.92 81.6 63.79 81.6 63.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "82.04 63.15 82.6 63.01 85.06 72.92 84.46 72.92 82.04 63.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "82.6 63.01 83.17 62.87 85.66 72.92 85.06 72.92 82.6 63.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "83.17 62.87 83.73 62.73 86.26 72.92 85.66 72.92 83.17 62.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "83.73 62.73 84.3 62.59 86.86 72.92 86.26 72.92 83.73 62.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "84.3 62.59 84.86 62.45 87.46 72.92 86.86 72.92 84.3 62.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "84.86 62.45 85.43 62.31 88.06 72.92 87.46 72.92 84.86 62.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "85.43 62.31 85.99 62.16 88.66 72.92 88.06 72.92 85.43 62.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "85.99 62.16 86.56 62.02 89.26 72.92 88.66 72.92 85.99 62.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "86.56 62.02 87.12 61.88 89.86 72.92 89.26 72.92 86.56 62.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "87.12 61.88 87.21 61.86 87.72 61.86 90.46 72.92 89.86 72.92 87.12 61.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "88.32 61.86 91.06 72.92 90.46 72.92 87.72 61.86 88.32 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "88.92 61.86 91.66 72.92 91.06 72.92 88.32 61.86 88.92 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "89.52 61.86 92.26 72.92 91.66 72.92 88.92 61.86 89.52 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "90.12 61.86 92.86 72.92 92.26 72.92 89.52 61.86 90.12 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "90.72 61.86 93.46 72.92 92.86 72.92 90.12 61.86 90.72 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "91.32 61.86 94.06 72.92 93.46 72.92 90.72 61.86 91.32 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "91.92 61.86 94.66 72.9 94.6 72.92 94.06 72.92 91.32 61.86 91.92 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "92.52 61.86 95.22 72.76 94.66 72.9 91.92 61.86 92.52 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "93.12 61.86 95.79 72.62 95.22 72.76 92.52 61.86 93.12 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "93.72 61.86 96.36 72.48 95.79 72.62 93.12 61.86 93.72 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "94.32 61.86 96.92 72.34 96.36 72.48 93.72 61.86 94.32 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "94.92 61.86 97.49 72.2 96.92 72.34 94.32 61.86 94.92 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "95.52 61.86 98.05 72.06 97.49 72.2 94.92 61.86 95.52 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "96.12 61.86 98.62 71.92 98.05 72.06 95.52 61.86 96.12 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "96.72 61.86 99.18 71.78 98.62 71.92 96.12 61.86 96.72 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "97.32 61.86 99.75 71.64 99.18 71.78 96.72 61.86 97.32 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "97.92 61.86 100.31 71.5 99.75 71.64 97.32 61.86 97.92 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "98.52 61.86 100.88 71.36 100.31 71.5 97.92 61.86 98.52 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "99.12 61.86 101.44 71.22 100.88 71.36 98.52 61.86 99.12 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "99.72 61.86 102.01 71.08 101.44 71.22 99.12 61.86 99.72 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "100.32 61.86 102.57 70.94 102.01 71.08 99.72 61.86 100.32 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "100.92 61.86 103.14 70.8 102.57 70.94 100.32 61.86 100.92 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "101.52 61.86 103.58 70.16 103.58 70.69 103.14 70.8 100.92 61.86 101.52 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "102.12 61.86 103.58 67.74 103.58 70.16 101.52 61.86 102.12 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "102.72 61.86 103.58 65.32 103.58 67.74 102.12 61.86 102.72 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "103.32 61.86 103.58 62.9 103.58 65.32 102.72 61.86 103.32 61.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "103.58 62.9 103.32 61.86 103.58 61.86 103.58 62.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "77.95 66.03 80.25 75.3 77.95 75.3 77.95 66.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "77.95 63.61 80.85 75.3 80.25 75.3 77.95 66.03 77.95 63.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "77.95 61.19 81.45 75.3 80.85 75.3 77.95 63.61 77.95 61.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "77.95 60.87 78.44 60.75 82.05 75.3 81.45 75.3 77.95 61.19 77.95 60.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "78.44 60.75 79.01 60.61 82.65 75.3 82.05 75.3 78.44 60.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "79.01 60.61 79.57 60.47 83.25 75.3 82.65 75.3 79.01 60.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "79.57 60.47 80.14 60.33 83.85 75.3 83.25 75.3 79.57 60.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "80.14 60.33 80.7 60.19 84.45 75.3 83.85 75.3 80.14 60.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "80.7 60.19 81.27 60.05 85.05 75.3 84.45 75.3 80.7 60.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "81.27 60.05 81.83 59.91 85.65 75.3 85.05 75.3 81.27 60.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "81.83 59.91 82.4 59.77 86.25 75.3 85.65 75.3 81.83 59.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "82.4 59.77 82.96 59.63 86.85 75.3 86.25 75.3 82.4 59.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "82.96 59.63 83.53 59.49 87.45 75.3 86.85 75.3 82.96 59.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "83.53 59.49 84.1 59.35 88.05 75.3 87.45 75.3 83.53 59.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "84.1 59.35 84.66 59.21 88.65 75.3 88.05 75.3 84.1 59.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "84.66 59.21 85.23 59.07 89.25 75.3 88.65 75.3 84.66 59.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "85.23 59.07 85.79 58.93 89.85 75.3 89.25 75.3 85.23 59.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "85.79 58.93 86.36 58.79 90.45 75.3 89.85 75.3 85.79 58.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "86.36 58.79 86.92 58.65 91.05 75.3 90.45 75.3 86.36 58.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "86.92 58.65 87.49 58.51 91.65 75.3 91.05 75.3 86.92 58.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "87.49 58.51 88.05 58.36 92.25 75.3 91.65 75.3 87.49 58.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "88.05 58.36 88.62 58.22 92.85 75.3 92.25 75.3 88.05 58.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "88.62 58.22 89.18 58.08 93.45 75.3 92.85 75.3 88.62 58.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "89.18 58.08 89.75 57.94 94.05 75.3 93.45 75.3 89.18 58.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "89.75 57.94 90.31 57.8 94.65 75.3 94.05 75.3 89.75 57.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "90.31 57.8 90.88 57.66 95.25 75.3 94.65 75.3 90.31 57.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "90.88 57.66 91.44 57.52 95.85 75.3 95.25 75.3 90.88 57.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "91.44 57.52 91.55 57.5 92.04 57.5 96.45 75.3 95.85 75.3 91.44 57.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "92.64 57.5 97.05 75.3 96.45 75.3 92.04 57.5 92.64 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "93.24 57.5 97.65 75.3 97.05 75.3 92.64 57.5 93.24 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "93.84 57.5 98.25 75.3 97.65 75.3 93.24 57.5 93.84 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "94.44 57.5 98.82 75.16 98.28 75.3 98.25 75.3 93.84 57.5 94.44 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "95.04 57.5 99.39 75.02 98.82 75.16 94.44 57.5 95.04 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "95.64 57.5 99.95 74.88 99.39 75.02 95.04 57.5 95.64 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.24 57.5 100.52 74.74 99.95 74.88 95.64 57.5 96.24 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "96.84 57.5 101.08 74.6 100.52 74.74 96.24 57.5 96.84 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "97.44 57.5 101.65 74.46 101.08 74.6 96.84 57.5 97.44 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "98.04 57.5 102.21 74.32 101.65 74.46 97.44 57.5 98.04 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "98.64 57.5 102.78 74.18 102.21 74.32 98.04 57.5 98.64 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "99.24 57.5 103.34 74.04 102.78 74.18 98.64 57.5 99.24 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "99.84 57.5 103.91 73.9 103.34 74.04 99.24 57.5 99.84 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "100.44 57.5 104.47 73.76 103.91 73.9 99.84 57.5 100.44 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "101.04 57.5 105.04 73.62 104.47 73.76 100.44 57.5 101.04 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "101.64 57.5 105.6 73.48 105.04 73.62 101.04 57.5 101.64 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "102.24 57.5 106.17 73.34 105.6 73.48 101.64 57.5 102.24 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "102.84 57.5 106.73 73.2 106.17 73.34 102.24 57.5 102.84 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "103.44 57.5 107.22 72.76 107.22 73.08 106.73 73.2 102.84 57.5 103.44 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "104.04 57.5 107.22 70.34 107.22 72.76 103.44 57.5 104.04 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "104.64 57.5 107.22 67.92 107.22 70.34 104.04 57.5 104.64 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "107.22 67.92 104.64 57.5 107.22 57.5 107.22 67.92"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m97.33,68.3c-.17-.14-.36-.26-.55-.39-.17-.12-.34-.11-.65,0-.4.15-.77.3-1.15.44-.76.28-1.52.47-2.33.54-1,.09-1.59-.14-2.02-.51l2.6-.65c.2-.05.35-.18.33-.28l-.1-.41c-.03-.1-.21-.14-.42-.09l-2.84.71-.08-.33,2.84-.71c.2-.05.35-.18.33-.28l-.1-.41c-.03-.1-.21-.14-.42-.09l-2.49.62h0c.21-.43.59-.81,1.26-1.12.8-.37,1.65-.58,2.53-.71.42-.06.82-.1,1.25-.15.31-.04.46-.12.56-.3.11-.19.2-.39.29-.58.09-.19,0-.27-.33-.28-.08,0-.16,0-.24,0-1.27.07-2.52.28-3.77.7-.87.3-1.69.66-2.35,1.12-.82.58-1.3,1.19-1.52,1.83l-.02.07-1.28.32c-.2.05-.35.18-.33.28l.1.41c.03.1.21.14.42.09l1-.25.08.33-1,.25c-.2.05-.35.18-.33.28l.1.41c.03.1.21.14.42.09l1.21-.3c.13.13.24.26.39.38.8.59,1.97.86,3.58.73,1.33-.11,2.64-.44,3.87-.93.32-.13.64-.27.94-.42.33-.16.38-.3.23-.42h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "34.74 89.15 34.96 90.44 34.74 90.44 34.74 89.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "34.74 75.15 37.31 90.44 34.96 90.44 34.74 89.15 34.74 75.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "34.74 61.15 39.66 90.44 37.31 90.44 34.74 75.15 34.74 61.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "34.74 48.56 34.98 48.52 42.01 90.44 39.66 90.44 34.74 61.15 34.74 48.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "34.98 48.52 37.26 48.14 44.37 90.44 42.01 90.44 34.98 48.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "37.26 48.14 39.55 47.75 46.72 90.44 44.37 90.44 37.26 48.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "39.55 47.75 41.84 47.37 49.07 90.44 46.72 90.44 39.55 47.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "41.84 47.37 44.12 46.98 51.42 90.44 49.07 90.44 41.84 47.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "44.12 46.98 46.41 46.6 53.77 90.44 51.42 90.44 44.12 46.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46.41 46.6 48.7 46.22 56.12 90.44 53.77 90.44 46.41 46.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "48.7 46.22 50.98 45.83 58.47 90.44 56.12 90.44 48.7 46.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "50.98 45.83 53.27 45.45 60.83 90.44 58.47 90.44 50.98 45.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "53.27 45.45 55.56 45.06 63.18 90.44 60.83 90.44 53.27 45.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "55.56 45.06 57.85 44.68 65.53 90.44 63.18 90.44 55.56 45.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "57.85 44.68 60.13 44.3 67.88 90.44 65.53 90.44 57.85 44.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "60.13 44.3 62.42 43.91 70.23 90.44 67.88 90.44 60.13 44.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "62.42 43.91 64.71 43.53 72.58 90.44 70.23 90.44 62.42 43.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "64.71 43.53 66.99 43.14 74.93 90.44 72.58 90.44 64.71 43.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "66.99 43.14 69.28 42.76 77.29 90.44 74.93 90.44 66.99 43.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "69.28 42.76 71.57 42.38 79.64 90.44 77.29 90.44 69.28 42.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "71.57 42.38 73.85 41.99 81.99 90.44 79.64 90.44 71.57 42.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "73.85 41.99 76.14 41.61 84.34 90.44 81.99 90.44 73.85 41.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "76.14 41.61 78.43 41.22 86.68 90.35 86.13 90.44 84.34 90.44 76.14 41.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 82.54,
    y: 40.69,
    width: 2.32,
    height: 49.81,
    transform: "translate(-9.71 14.76) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84.82,
    y: 40.3,
    width: 2.32,
    height: 49.81,
    transform: "translate(-9.61 15.14) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 87.11,
    y: 39.92,
    width: 2.32,
    height: 49.81,
    transform: "translate(-9.52 15.51) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 89.4,
    y: 39.54,
    width: 2.32,
    height: 49.81,
    transform: "translate(-9.42 15.89) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 91.68,
    y: 39.15,
    width: 2.32,
    height: 49.81,
    transform: "translate(-9.33 16.26) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 93.97,
    y: 38.77,
    width: 2.32,
    height: 49.81,
    transform: "translate(-9.23 16.63) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "92.15 38.92 94.04 38.6 94.45 38.6 102.68 87.66 100.4 88.04 92.15 38.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "96.8 38.6 104.97 87.27 102.68 87.66 94.45 38.6 96.8 38.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "99.15 38.6 107.26 86.89 104.97 87.27 96.8 38.6 99.15 38.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "101.5 38.6 109.55 86.51 107.26 86.89 99.15 38.6 101.5 38.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "103.85 38.6 111.83 86.12 109.55 86.51 101.5 38.6 103.85 38.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "106.21 38.6 114.12 85.74 111.83 86.12 103.85 38.6 106.21 38.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "108.56 38.6 116.41 85.35 114.12 85.74 106.21 38.6 108.56 38.6"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "45.48 87.39 45.48 87.39 45.48 87.39 45.48 87.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "45.48 75.23 47.52 87.39 45.48 87.39 45.48 87.39 45.48 75.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "45.48 63.07 49.56 87.39 47.52 87.39 45.48 75.23 45.48 63.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "45.48 56.15 46.33 56.01 51.6 87.39 49.56 87.39 45.48 63.07 45.48 56.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "46.33 56.01 48.32 55.67 53.64 87.39 51.6 87.39 46.33 56.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "48.32 55.67 50.3 55.34 55.68 87.39 53.64 87.39 48.32 55.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "50.3 55.34 52.29 55.01 57.73 87.39 55.68 87.39 50.3 55.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "52.29 55.01 54.28 54.67 59.77 87.39 57.73 87.39 52.29 55.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "54.28 54.67 56.26 54.34 61.81 87.39 59.77 87.39 54.28 54.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "56.26 54.34 58.25 54.01 63.85 87.39 61.81 87.39 56.26 54.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "58.25 54.01 60.23 53.67 65.89 87.39 63.85 87.39 58.25 54.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "60.23 53.67 62.22 53.34 67.94 87.39 65.89 87.39 60.23 53.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "62.22 53.34 64.2 53.01 69.98 87.39 67.94 87.39 62.22 53.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "64.2 53.01 66.19 52.67 72.02 87.39 69.98 87.39 64.2 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "66.19 52.67 68.18 52.34 74.06 87.39 72.02 87.39 66.19 52.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "68.18 52.34 70.16 52.01 76.1 87.39 74.06 87.39 68.18 52.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "70.16 52.01 72.15 51.67 78.15 87.39 76.1 87.39 70.16 52.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "72.15 51.67 74.13 51.34 80.19 87.39 78.15 87.39 72.15 51.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "74.13 51.34 76.12 51.01 82.23 87.39 80.19 87.39 74.13 51.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "76.12 51.01 78.11 50.67 84.27 87.39 82.23 87.39 76.12 51.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "78.11 50.67 80.09 50.34 86.31 87.39 84.27 87.39 78.11 50.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "80.09 50.34 82.08 50.01 88.35 87.39 86.31 87.39 80.09 50.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "82.08 50.01 84.06 49.67 90.4 87.39 88.35 87.39 82.08 50.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "84.06 49.67 86.05 49.34 92.4 87.18 91.18 87.39 90.4 87.39 84.06 49.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 89.21,
    y: 48.91,
    width: 2.01,
    height: 38.38,
    transform: "translate(-10.03 15.88) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 91.2,
    y: 48.57,
    width: 2.01,
    height: 38.38,
    transform: "translate(-9.95 16.2) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 93.18,
    y: 48.24,
    width: 2.01,
    height: 38.38,
    transform: "translate(-9.87 16.53) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 95.17,
    y: 47.91,
    width: 2.01,
    height: 38.38,
    transform: "translate(-9.78 16.85) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "93.99 48.01 95.96 47.67 95.98 47.67 102.33 85.52 100.35 85.85 93.99 48.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "98.02 47.67 104.32 85.18 102.33 85.52 95.98 47.67 98.02 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "100.06 47.67 106.3 84.85 104.32 85.18 98.02 47.67 100.06 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "102.1 47.67 108.29 84.52 106.3 84.85 100.06 47.67 102.1 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "104.15 47.67 110.28 84.18 108.29 84.52 102.1 47.67 104.15 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "106.19 47.67 112.26 83.85 110.28 84.18 104.15 47.67 106.19 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "108.23 47.67 114.25 83.52 112.26 83.85 106.19 47.67 108.23 47.67"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "65.43 76.05 66.96 85.15 65.43 85.15 65.43 76.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "65.43 66.95 68.49 85.15 66.96 85.15 65.43 76.05 65.43 66.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "65.43 61.34 66 61.25 70.01 85.15 68.49 85.15 65.43 66.95 65.43 61.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "66 61.25 67.49 61 71.54 85.15 70.01 85.15 66 61.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "67.49 61 68.97 60.75 73.07 85.15 71.54 85.15 67.49 61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "68.97 60.75 70.46 60.5 74.6 85.15 73.07 85.15 68.97 60.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "70.46 60.5 71.95 60.25 76.13 85.15 74.6 85.15 70.46 60.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "71.95 60.25 73.43 60 77.66 85.15 76.13 85.15 71.95 60.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "73.43 60 74.92 59.75 79.19 85.15 77.66 85.15 73.43 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "74.92 59.75 76.41 59.5 80.71 85.15 79.19 85.15 74.92 59.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "76.41 59.5 77.89 59.25 82.24 85.15 80.71 85.15 76.41 59.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "77.89 59.25 79.38 59 83.77 85.15 82.24 85.15 77.89 59.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "79.38 59 80.87 58.75 85.3 85.15 83.77 85.15 79.38 59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "80.87 58.75 82.35 58.5 86.83 85.15 85.3 85.15 80.87 58.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "82.35 58.5 83.84 58.25 88.36 85.15 86.83 85.15 82.35 58.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "83.84 58.25 85.33 58 89.89 85.15 88.36 85.15 83.84 58.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "85.33 58 86.81 57.75 91.41 85.15 89.89 85.15 85.33 58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "86.81 57.75 88.3 57.5 92.94 85.15 91.41 85.15 86.81 57.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "88.3 57.5 89.79 57.25 94.47 85.15 92.94 85.15 88.3 57.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "89.79 57.25 91.27 57 96 85.15 94.47 85.15 89.79 57.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "91.27 57 92.76 56.75 97.53 85.15 96 85.15 91.27 57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "92.76 56.75 94.25 56.51 99.06 85.15 97.53 85.15 92.76 56.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "94.25 56.51 95.73 56.26 100.58 85.15 99.06 85.15 94.25 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.73 56.26 97.22 56.01 102.11 85.15 100.58 85.15 95.73 56.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "97.22 56.01 98.71 55.76 103.6 84.91 102.16 85.15 102.11 85.15 97.22 56.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 101.14,
    y: 55.43,
    width: 1.51,
    height: 29.56,
    transform: "translate(-10.22 17.84) rotate(-9.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "100.19 55.51 100.7 55.42 101.71 55.42 106.57 84.41 105.09 84.66 100.19 55.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "103.24 55.42 108.06 84.16 106.57 84.41 101.71 55.42 103.24 55.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "104.76 55.42 109.55 83.91 108.06 84.16 103.24 55.42 104.76 55.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "106.29 55.42 111.03 83.66 109.55 83.91 104.76 55.42 106.29 55.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "107.82 55.42 112.52 83.41 111.03 83.66 106.29 55.42 107.82 55.42"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "9.25 38.02 12.11 43.54 9.25 43.54 9.25 38.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "9.25 37.2 12.53 43.54 12.11 43.54 9.25 38.02 9.25 37.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "9.25 36.39 12.95 43.54 12.53 43.54 9.25 37.2 9.25 36.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "9.25 36.15 9.49 36.03 13.37 43.54 12.95 43.54 9.25 36.39 9.25 36.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "9.49 36.03 9.82 35.86 13.79 43.54 13.37 43.54 9.49 36.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "9.82 35.86 10.15 35.68 14.21 43.54 13.79 43.54 9.82 35.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "10.15 35.68 10.48 35.51 14.63 43.54 14.21 43.54 10.15 35.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "10.48 35.51 10.82 35.34 15.05 43.54 14.63 43.54 10.48 35.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "10.82 35.34 11.15 35.17 15.48 43.54 15.05 43.54 10.82 35.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "11.15 35.17 11.48 35 15.9 43.54 15.48 43.54 11.15 35.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "11.48 35 11.81 34.82 16.32 43.54 15.9 43.54 11.48 35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "11.81 34.82 12.14 34.65 16.74 43.54 16.32 43.54 11.81 34.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "12.14 34.65 12.48 34.48 17.16 43.54 16.74 43.54 12.14 34.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "12.48 34.48 12.81 34.31 17.58 43.54 17.16 43.54 12.48 34.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "12.81 34.31 13.14 34.14 18 43.54 17.58 43.54 12.81 34.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "13.14 34.14 13.47 33.97 18.42 43.54 18 43.54 13.14 34.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "13.47 33.97 13.8 33.79 18.84 43.54 18.42 43.54 13.47 33.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "13.8 33.79 14.14 33.62 19.26 43.54 18.84 43.54 13.8 33.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "14.14 33.62 14.47 33.45 19.69 43.54 19.26 43.54 14.14 33.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "14.47 33.45 14.8 33.28 20.11 43.54 19.69 43.54 14.47 33.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "14.8 33.28 15.13 33.11 20.53 43.54 20.11 43.54 14.8 33.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "15.13 33.11 15.47 32.93 20.95 43.54 20.53 43.54 15.13 33.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "15.47 32.93 15.8 32.76 21.34 43.48 21.24 43.54 20.95 43.54 15.47 32.93"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 18.55,
    y: 32,
    width: 0.37,
    height: 12.07,
    transform: "translate(-15.38 12.86) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 18.88,
    y: 31.83,
    width: 0.37,
    height: 12.07,
    transform: "translate(-15.26 12.99) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 19.21,
    y: 31.66,
    width: 0.37,
    height: 12.07,
    transform: "translate(-15.15 13.13) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 19.55,
    y: 31.49,
    width: 0.37,
    height: 12.07,
    transform: "translate(-15.03 13.26) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 19.88,
    y: 31.32,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.92 13.39) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 20.21,
    y: 31.14,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.8 13.53) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 20.54,
    y: 30.97,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.68 13.66) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 20.87,
    y: 30.8,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.57 13.79) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 21.21,
    y: 30.63,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.45 13.93) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 21.54,
    y: 30.46,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.34 14.06) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 21.87,
    y: 30.28,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.22 14.19) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 22.2,
    y: 30.11,
    width: 0.37,
    height: 12.07,
    transform: "translate(-14.1 14.33) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 22.54,
    y: 29.94,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.99 14.46) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 22.87,
    y: 29.77,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.87 14.59) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 23.2,
    y: 29.6,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.76 14.73) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 23.53,
    y: 29.43,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.64 14.86) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 23.86,
    y: 29.25,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.52 14.99) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 24.2,
    y: 29.08,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.41 15.13) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 24.53,
    y: 28.91,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.29 15.26) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 24.86,
    y: 28.74,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.18 15.39) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 25.19,
    y: 28.57,
    width: 0.37,
    height: 12.07,
    transform: "translate(-13.06 15.53) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 25.53,
    y: 28.39,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.94 15.66) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 25.86,
    y: 28.22,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.83 15.79) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 26.19,
    y: 28.05,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.71 15.93) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 26.52,
    y: 27.88,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.59 16.06) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 26.85,
    y: 27.71,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.48 16.19) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 27.19,
    y: 27.54,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.36 16.33) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 27.52,
    y: 27.36,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.25 16.46) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 27.85,
    y: 27.19,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.13 16.59) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 28.18,
    y: 27.02,
    width: 0.37,
    height: 12.07,
    transform: "translate(-12.01 16.73) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "25.76 27.61 25.9 27.54 26.15 27.54 31.64 38.16 31.31 38.33 25.76 27.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "26.57 27.54 31.97 37.98 31.64 38.16 26.15 27.54 26.57 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "26.99 27.54 32.28 37.76 32.28 37.83 31.97 37.98 26.57 27.54 26.99 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "27.41 27.54 32.28 36.95 32.28 37.76 26.99 27.54 27.41 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "27.83 27.54 32.28 36.14 32.28 36.95 27.41 27.54 27.83 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.25 27.54 32.28 35.32 32.28 36.14 27.83 27.54 28.25 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "28.67 27.54 32.28 34.51 32.28 35.32 28.25 27.54 28.67 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "29.09 27.54 32.28 33.69 32.28 34.51 28.67 27.54 29.09 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "29.52 27.54 32.28 32.88 32.28 33.69 29.09 27.54 29.52 27.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "32.28 32.88 29.52 27.54 32.28 27.54 32.28 32.88"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 7.62,
    y: 38,
    width: 0.52,
    height: 12.89,
    transform: "translate(-19.54 8.59) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 8.46,
    y: 37.56,
    width: 0.52,
    height: 12.89,
    transform: "translate(-19.24 8.93) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 9.3,
    y: 37.13,
    width: 0.52,
    height: 12.89,
    transform: "translate(-18.95 9.26) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 10.15,
    y: 36.69,
    width: 0.52,
    height: 12.89,
    transform: "translate(-18.65 9.6) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 10.99,
    y: 36.26,
    width: 0.52,
    height: 12.89,
    transform: "translate(-18.36 9.94) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 11.83,
    y: 35.82,
    width: 0.52,
    height: 12.89,
    transform: "translate(-18.07 10.28) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 12.67,
    y: 35.39,
    width: 0.52,
    height: 12.89,
    transform: "translate(-17.77 10.62) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 13.51,
    y: 34.95,
    width: 0.52,
    height: 12.89,
    transform: "translate(-17.48 10.95) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 14.35,
    y: 34.52,
    width: 0.52,
    height: 12.89,
    transform: "translate(-17.18 11.29) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 15.19,
    y: 34.08,
    width: 0.52,
    height: 12.89,
    transform: "translate(-16.89 11.63) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 16.03,
    y: 33.65,
    width: 0.52,
    height: 12.89,
    transform: "translate(-16.6 11.97) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 16.87,
    y: 33.21,
    width: 0.52,
    height: 12.89,
    transform: "translate(-16.3 12.3) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 17.71,
    y: 32.78,
    width: 0.52,
    height: 12.89,
    transform: "translate(-16.01 12.64) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 18.56,
    y: 32.34,
    width: 0.52,
    height: 12.89,
    transform: "translate(-15.72 12.98) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 19.4,
    y: 31.91,
    width: 0.52,
    height: 12.89,
    transform: "translate(-15.42 13.32) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 20.24,
    y: 31.47,
    width: 0.52,
    height: 12.89,
    transform: "translate(-15.13 13.65) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 21.08,
    y: 31.04,
    width: 0.52,
    height: 12.89,
    transform: "translate(-14.83 13.99) rotate(-27.35)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 21.92,
    y: 30.6,
    width: 0.52,
    height: 12.89,
    transform: "translate(-14.54 14.33) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 22.76,
    y: 30.17,
    width: 0.52,
    height: 12.89,
    transform: "translate(-14.25 14.67) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 23.6,
    y: 29.73,
    width: 0.52,
    height: 12.89,
    transform: "translate(-13.95 15) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 24.44,
    y: 29.3,
    width: 0.52,
    height: 12.89,
    transform: "translate(-13.66 15.34) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 25.28,
    y: 28.86,
    width: 0.52,
    height: 12.89,
    transform: "translate(-13.37 15.68) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 26.12,
    y: 28.43,
    width: 0.52,
    height: 12.89,
    transform: "translate(-13.07 16.02) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 26.96,
    y: 27.99,
    width: 0.52,
    height: 12.89,
    transform: "translate(-12.78 16.36) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 27.8,
    y: 27.56,
    width: 0.52,
    height: 12.89,
    transform: "translate(-12.48 16.69) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 28.64,
    y: 27.12,
    width: 0.52,
    height: 12.89,
    transform: "translate(-12.19 17.03) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 29.49,
    y: 26.69,
    width: 0.52,
    height: 12.89,
    transform: "translate(-11.9 17.37) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 30.33,
    y: 26.25,
    width: 0.52,
    height: 12.89,
    transform: "translate(-11.6 17.71) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 31.17,
    y: 25.82,
    width: 0.52,
    height: 12.89,
    transform: "translate(-11.31 18.04) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 32.01,
    y: 25.38,
    width: 0.52,
    height: 12.89,
    transform: "translate(-11.01 18.38) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 32.85,
    y: 24.95,
    width: 0.52,
    height: 12.89,
    transform: "translate(-10.72 18.72) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 33.69,
    y: 24.51,
    width: 0.52,
    height: 12.89,
    transform: "translate(-10.43 19.06) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 34.53,
    y: 24.08,
    width: 0.52,
    height: 12.89,
    transform: "translate(-10.13 19.4) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 35.37,
    y: 23.64,
    width: 0.52,
    height: 12.89,
    transform: "translate(-9.84 19.73) rotate(-27.35)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "9.14 34.96 11.7 39.92 9.14 39.92 9.14 34.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "9.14 34.04 12.18 39.92 11.7 39.92 9.14 34.96 9.14 34.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "9.14 33.13 12.65 39.92 12.18 39.92 9.14 34.04 9.14 33.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "9.14 32.21 13.12 39.92 12.65 39.92 9.14 33.13 9.14 32.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "9.14 31.3 13.6 39.92 13.12 39.92 9.14 32.21 9.14 31.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "9.14 30.55 9.21 30.51 14.07 39.92 13.6 39.92 9.14 31.3 9.14 30.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "9.21 30.51 9.58 30.32 14.55 39.92 14.07 39.92 9.21 30.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "9.58 30.32 9.96 30.12 15.02 39.92 14.55 39.92 9.58 30.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "9.96 30.12 10.33 29.93 15.49 39.92 15.02 39.92 9.96 30.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.33 29.93 10.7 29.74 15.97 39.92 15.49 39.92 10.33 29.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "10.7 29.74 11.08 29.54 16.44 39.92 15.97 39.92 10.7 29.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "11.08 29.54 11.45 29.35 16.92 39.92 16.44 39.92 11.08 29.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "11.45 29.35 11.82 29.16 17.39 39.92 16.92 39.92 11.45 29.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "11.82 29.16 12.2 28.96 17.86 39.92 17.39 39.92 11.82 29.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "12.2 28.96 12.57 28.77 18.34 39.92 17.86 39.92 12.2 28.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "12.57 28.77 12.95 28.58 18.81 39.92 18.34 39.92 12.57 28.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "12.95 28.58 13.32 28.38 19.29 39.92 18.81 39.92 12.95 28.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "13.32 28.38 13.69 28.19 19.76 39.92 19.29 39.92 13.32 28.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "13.69 28.19 14.07 28 20.23 39.92 19.76 39.92 13.69 28.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "14.07 28 14.44 27.8 20.61 39.73 20.24 39.92 20.23 39.92 14.07 28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 17.5,
    y: 26.96,
    width: 0.42,
    height: 13.42,
    transform: "translate(-13.49 11.9) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 17.88,
    y: 26.76,
    width: 0.42,
    height: 13.42,
    transform: "translate(-13.36 12.05) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 18.25,
    y: 26.57,
    width: 0.42,
    height: 13.42,
    transform: "translate(-13.23 12.2) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 18.62,
    y: 26.38,
    width: 0.42,
    height: 13.42,
    transform: "translate(-13.1 12.35) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19,
    y: 26.18,
    width: 0.42,
    height: 13.42,
    transform: "translate(-12.96 12.5) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 19.37,
    y: 25.99,
    width: 0.42,
    height: 13.42,
    transform: "translate(-12.83 12.65) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 19.75,
    y: 25.8,
    width: 0.42,
    height: 13.42,
    transform: "translate(-12.7 12.8) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 20.12,
    y: 25.6,
    width: 0.42,
    height: 13.42,
    transform: "translate(-12.57 12.95) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 20.49,
    y: 25.41,
    width: 0.42,
    height: 13.42,
    transform: "translate(-12.44 13.1) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 20.87,
    y: 25.21,
    width: 0.42,
    height: 13.42,
    transform: "translate(-12.31 13.25) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "18.18 25.87 18.55 25.68 18.56 25.68 24.72 37.6 24.35 37.79 18.18 25.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "19.03 25.68 25.1 37.4 24.72 37.6 18.56 25.68 19.03 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "19.5 25.68 25.47 37.21 25.1 37.4 19.03 25.68 19.5 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "19.98 25.68 25.84 37.02 25.47 37.21 19.5 25.68 19.98 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "20.45 25.68 26.22 36.82 25.84 37.02 19.98 25.68 20.45 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "20.93 25.68 26.59 36.63 26.22 36.82 20.45 25.68 20.93 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "21.4 25.68 26.97 36.44 26.59 36.63 20.93 25.68 21.4 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "21.87 25.68 27.34 36.24 26.97 36.44 21.4 25.68 21.87 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "22.35 25.68 27.71 36.05 27.34 36.24 21.87 25.68 22.35 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "22.82 25.68 28.09 35.86 27.71 36.05 22.35 25.68 22.82 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "23.3 25.68 28.46 35.66 28.09 35.86 22.82 25.68 23.3 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "23.77 25.68 28.84 35.47 28.46 35.66 23.3 25.68 23.77 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "24.24 25.68 29.21 35.28 28.84 35.47 23.77 25.68 24.24 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "24.72 25.68 29.58 35.08 29.21 35.28 24.24 25.68 24.72 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "25.19 25.68 29.65 34.3 29.65 35.05 29.58 35.08 24.72 25.68 25.19 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "25.67 25.68 29.65 33.38 29.65 34.3 25.19 25.68 25.67 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "26.14 25.68 29.65 32.47 29.65 33.38 25.67 25.68 26.14 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "26.61 25.68 29.65 31.55 29.65 32.47 26.14 25.68 26.61 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "27.09 25.68 29.65 30.63 29.65 31.55 26.61 25.68 27.09 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "29.65 30.63 27.09 25.68 29.65 25.68 29.65 30.63"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "10.77 37.84 11.08 38.44 10.77 38.44 10.77 37.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "10.77 36.8 11.61 38.44 11.08 38.44 10.77 37.84 10.77 36.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "10.77 35.77 12.15 38.44 11.61 38.44 10.77 36.8 10.77 35.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "10.77 34.73 12.68 38.44 12.15 38.44 10.77 35.77 10.77 34.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "10.77 33.7 13.22 38.44 12.68 38.44 10.77 34.73 10.77 33.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "10.77 32.66 13.75 38.44 13.22 38.44 10.77 33.7 10.77 32.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "10.77 31.63 14.29 38.44 13.75 38.44 10.77 32.66 10.77 31.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "10.77 31.17 11 31.05 14.82 38.44 14.29 38.44 10.77 31.63 10.77 31.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "11 31.05 11.42 30.83 15.36 38.44 14.82 38.44 11 31.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "11.42 30.83 11.84 30.61 15.89 38.44 15.36 38.44 11.42 30.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "11.84 30.61 12.27 30.39 16.43 38.44 15.89 38.44 11.84 30.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "12.27 30.39 12.69 30.18 16.96 38.44 16.43 38.44 12.27 30.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "12.69 30.18 13.11 29.96 17.5 38.44 16.96 38.44 12.69 30.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "13.11 29.96 13.53 29.74 18.03 38.44 17.5 38.44 13.11 29.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "13.53 29.74 13.96 29.52 18.57 38.44 18.03 38.44 13.53 29.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "13.96 29.52 14.38 29.3 19.1 38.44 18.57 38.44 13.96 29.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "14.38 29.3 14.8 29.08 19.64 38.44 19.1 38.44 14.38 29.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "14.8 29.08 15.22 28.87 20.17 38.44 19.64 38.44 14.8 29.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "15.22 28.87 15.64 28.65 20.61 38.26 20.26 38.44 20.17 38.44 15.22 28.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.1,
    y: 27.93,
    width: 0.48,
    height: 10.82,
    transform: "translate(-13.27 12.15) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 18.52,
    y: 27.72,
    width: 0.48,
    height: 10.82,
    transform: "translate(-13.12 12.32) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 18.95,
    y: 27.5,
    width: 0.48,
    height: 10.82,
    transform: "translate(-12.97 12.49) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19.37,
    y: 27.28,
    width: 0.48,
    height: 10.82,
    transform: "translate(-12.83 12.66) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "17.33 27.77 17.59 27.64 17.8 27.64 22.72 37.17 22.3 37.38 17.33 27.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "18.33 27.64 23.15 36.95 22.72 37.17 17.8 27.64 18.33 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "18.87 27.64 23.57 36.73 23.15 36.95 18.33 27.64 18.87 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "19.4 27.64 23.99 36.51 23.57 36.73 18.87 27.64 19.4 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "19.94 27.64 24.41 36.29 23.99 36.51 19.4 27.64 19.94 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "20.47 27.64 24.84 36.07 24.41 36.29 19.94 27.64 20.47 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "21.01 27.64 25.26 35.86 24.84 36.07 20.47 27.64 21.01 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "21.54 27.64 25.68 35.64 25.26 35.86 21.01 27.64 21.54 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "22.08 27.64 26.1 35.42 25.68 35.64 21.54 27.64 22.08 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "22.61 27.64 26.52 35.2 26.1 35.42 22.08 27.64 22.61 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "23.15 27.64 26.95 34.98 26.52 35.2 22.61 27.64 23.15 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "23.69 27.64 27.37 34.76 26.95 34.98 23.15 27.64 23.69 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "24.22 27.64 27.79 34.54 27.37 34.76 23.69 27.64 24.22 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "24.76 27.64 28.03 33.97 28.03 34.42 27.79 34.54 24.22 27.64 24.76 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.29 27.64 28.03 32.93 28.03 33.97 24.76 27.64 25.29 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "25.83 27.64 28.03 31.9 28.03 32.93 25.29 27.64 25.83 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "26.36 27.64 28.03 30.86 28.03 31.9 25.83 27.64 26.36 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "26.9 27.64 28.03 29.83 28.03 30.86 26.36 27.64 26.9 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "27.43 27.64 28.03 28.79 28.03 29.83 26.9 27.64 27.43 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "27.97 27.64 28.03 27.76 28.03 28.79 27.43 27.64 27.97 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "28.03 27.76 27.97 27.64 28.03 27.64 28.03 27.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "7.6 34.82 10.57 40.57 7.6 40.57 7.6 34.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "7.6 33.79 11.11 40.57 10.57 40.57 7.6 34.82 7.6 33.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "7.6 32.75 11.64 40.57 11.11 40.57 7.6 33.79 7.6 32.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "7.6 31.72 12.18 40.57 11.64 40.57 7.6 32.75 7.6 31.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "7.6 30.68 12.71 40.57 12.18 40.57 7.6 31.72 7.6 30.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "7.6 29.87 7.69 29.83 13.25 40.57 12.71 40.57 7.6 30.68 7.6 29.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "7.69 29.83 8.11 29.61 13.79 40.57 13.25 40.57 7.69 29.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "8.11 29.61 8.54 29.39 14.32 40.57 13.79 40.57 8.11 29.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "8.54 29.39 8.96 29.17 14.86 40.57 14.32 40.57 8.54 29.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "8.96 29.17 9.38 28.95 15.39 40.57 14.86 40.57 8.96 29.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "9.38 28.95 9.8 28.73 15.93 40.57 15.39 40.57 9.38 28.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "9.8 28.73 10.23 28.52 16.46 40.57 15.93 40.57 9.8 28.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "10.23 28.52 10.65 28.3 17 40.57 16.46 40.57 10.23 28.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "10.65 28.3 11.07 28.08 17.53 40.57 17 40.57 10.65 28.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "11.07 28.08 11.49 27.86 18.07 40.57 17.53 40.57 11.07 28.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "11.49 27.86 11.91 27.64 18.6 40.57 18.07 40.57 11.49 27.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "11.91 27.64 12.34 27.42 19.14 40.57 18.6 40.57 11.91 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "12.34 27.42 12.76 27.21 19.67 40.57 19.14 40.57 12.34 27.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "12.76 27.21 13.18 26.99 20.21 40.57 19.67 40.57 12.76 27.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "13.18 26.99 13.6 26.77 20.74 40.57 20.21 40.57 13.18 26.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "13.6 26.77 14.02 26.55 21.28 40.57 20.74 40.57 13.6 26.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "14.02 26.55 14.45 26.33 21.81 40.57 21.81 40.57 21.28 40.57 14.02 26.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.1,
    y: 25.33,
    width: 0.48,
    height: 16.03,
    transform: "translate(-13.27 12.15) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 18.52,
    y: 25.11,
    width: 0.48,
    height: 16.03,
    transform: "translate(-13.12 12.32) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 18.95,
    y: 24.89,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.97 12.49) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 19.37,
    y: 24.67,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.83 12.66) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 19.79,
    y: 24.45,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.68 12.83) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 20.21,
    y: 24.24,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.53 13) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 20.64,
    y: 24.02,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.38 13.17) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 21.06,
    y: 23.8,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.24 13.34) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 21.48,
    y: 23.58,
    width: 0.48,
    height: 16.03,
    transform: "translate(-12.09 13.51) rotate(-27.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "18.25 24.37 18.64 24.17 18.68 24.17 26.03 38.39 25.61 38.61 18.25 24.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "19.21 24.17 26.45 38.17 26.03 38.39 18.68 24.17 19.21 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "19.75 24.17 26.88 37.95 26.45 38.17 19.21 24.17 19.75 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "20.28 24.17 27.3 37.73 26.88 37.95 19.75 24.17 20.28 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "20.82 24.17 27.72 37.51 27.3 37.73 20.28 24.17 20.82 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "21.35 24.17 28.14 37.3 27.72 37.51 20.82 24.17 21.35 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "21.89 24.17 28.57 37.08 28.14 37.3 21.35 24.17 21.89 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "22.42 24.17 28.99 36.86 28.57 37.08 21.89 24.17 22.42 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "22.96 24.17 29.41 36.64 28.99 36.86 22.42 24.17 22.96 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.49 24.17 29.83 36.42 29.41 36.64 22.96 24.17 23.49 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "24.03 24.17 30.25 36.2 29.83 36.42 23.49 24.17 24.03 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "24.56 24.17 30.39 35.42 30.39 36.14 30.25 36.2 24.03 24.17 24.56 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "25.1 24.17 30.39 34.39 30.39 35.42 24.56 24.17 25.1 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "25.63 24.17 30.39 33.35 30.39 34.39 25.1 24.17 25.63 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "26.17 24.17 30.39 32.32 30.39 33.35 25.63 24.17 26.17 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "26.7 24.17 30.39 31.29 30.39 32.32 26.17 24.17 26.7 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "27.24 24.17 30.39 30.25 30.39 31.29 26.7 24.17 27.24 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "27.77 24.17 30.39 29.22 30.39 30.25 27.24 24.17 27.77 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "30.39 29.22 27.77 24.17 30.39 24.17 30.39 29.22"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m23.41,32.95c-.16-.07-.33-.14-.51-.2-.15-.06-.29-.02-.52.13-.29.19-.56.39-.83.57-.55.36-1.12.66-1.75.87-.78.26-1.29.19-1.7-.02l1.94-1.01c.15-.08.25-.21.21-.28l-.16-.31c-.04-.08-.2-.07-.35,0l-2.12,1.1-.13-.25,2.12-1.1c.15-.08.25-.21.21-.28l-.16-.31c-.04-.08-.2-.07-.35,0l-1.86.96h0c.09-.38.32-.75.79-1.13.56-.45,1.2-.77,1.87-1.04.32-.13.64-.23.96-.36.24-.09.34-.19.39-.34.05-.18.08-.35.12-.52.04-.17-.06-.22-.31-.16-.06.01-.13.03-.19.04-.99.29-1.94.7-2.86,1.27-.64.4-1.22.84-1.65,1.34-.54.62-.81,1.19-.86,1.74v.06s-.96.5-.96.5c-.15.08-.25.21-.21.28l.16.31c.04.08.2.07.35,0l.75-.39.13.25-.75.39c-.15.08-.25.21-.21.28l.16.31c.04.08.2.07.35,0l.9-.47c.13.08.24.16.38.23.75.32,1.73.31,2.98-.1,1.04-.34,2.01-.85,2.9-1.47.23-.16.46-.33.67-.51.24-.19.24-.31.1-.38h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "-17.75 23.61 -16.01 22.88 .08 60.86 -1.08 61.36 -1.77 61.36 -17.75 23.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: -8.04,
    y: 20.87,
    width: 1.89,
    height: 41.26,
    transform: "translate(-16.74 .52) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -6.3,
    y: 20.14,
    width: 1.89,
    height: 41.26,
    transform: "translate(-16.32 1.14) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: -4.55,
    y: 19.4,
    width: 1.89,
    height: 41.26,
    transform: "translate(-15.89 1.76) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -2.81,
    y: 18.66,
    width: 1.89,
    height: 41.26,
    transform: "translate(-15.47 2.38) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: -1.07,
    y: 17.92,
    width: 1.89,
    height: 41.26,
    transform: "translate(-15.04 3) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 0.67,
    y: 17.18,
    width: 1.89,
    height: 41.26,
    transform: "translate(-14.62 3.62) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 2.42,
    y: 16.45,
    width: 1.89,
    height: 41.26,
    transform: "translate(-14.19 4.25) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 4.16,
    y: 15.71,
    width: 1.89,
    height: 41.26,
    transform: "translate(-13.76 4.87) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 5.9,
    y: 14.97,
    width: 1.89,
    height: 41.26,
    transform: "translate(-13.34 5.49) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 7.64,
    y: 14.23,
    width: 1.89,
    height: 41.26,
    transform: "translate(-12.91 6.11) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 9.39,
    y: 13.49,
    width: 1.89,
    height: 41.26,
    transform: "translate(-12.49 6.73) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 11.13,
    y: 12.76,
    width: 1.89,
    height: 41.26,
    transform: "translate(-12.06 7.35) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12.87,
    y: 12.02,
    width: 1.89,
    height: 41.26,
    transform: "translate(-11.64 7.97) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 14.61,
    y: 11.28,
    width: 1.89,
    height: 41.26,
    transform: "translate(-11.21 8.59) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 16.36,
    y: 10.54,
    width: 1.89,
    height: 41.26,
    transform: "translate(-10.78 9.21) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.1,
    y: 9.81,
    width: 1.89,
    height: 41.26,
    transform: "translate(-10.36 9.84) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 19.84,
    y: 9.07,
    width: 1.89,
    height: 41.26,
    transform: "translate(-9.93 10.46) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 21.58,
    y: 8.33,
    width: 1.89,
    height: 41.26,
    transform: "translate(-9.51 11.08) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 23.33,
    y: 7.59,
    width: 1.89,
    height: 41.26,
    transform: "translate(-9.08 11.7) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 25.07,
    y: 6.85,
    width: 1.89,
    height: 41.26,
    transform: "translate(-8.66 12.32) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "18.84 8.12 18.87 8.11 20.89 8.11 36.67 45.37 34.93 46.11 18.84 8.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "22.95 8.11 38.42 44.63 36.67 45.37 20.89 8.11 22.95 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "25 8.11 40.16 43.89 38.42 44.63 22.95 8.11 25 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "27.06 8.11 41.9 43.16 40.16 43.89 25 8.11 27.06 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "29.11 8.11 43.64 42.42 41.9 43.16 27.06 8.11 29.11 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "31.17 8.11 45.39 41.68 43.64 42.42 29.11 8.11 31.17 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "33.22 8.11 47.13 40.94 45.39 41.68 31.17 8.11 33.22 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "35.28 8.11 48.87 40.21 47.13 40.94 33.22 8.11 35.28 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "37.33 8.11 50.61 39.47 48.87 40.21 35.28 8.11 37.33 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "39.39 8.11 52.36 38.73 50.61 39.47 37.33 8.11 39.39 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "41.44 8.11 54.1 37.99 52.36 38.73 39.39 8.11 41.44 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "43.5 8.11 55.84 37.25 54.1 37.99 41.44 8.11 43.5 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "45.55 8.11 57.58 36.52 55.84 37.25 43.5 8.11 45.55 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "47.61 8.11 59.33 35.78 57.58 36.52 45.55 8.11 47.61 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "49.66 8.11 61.07 35.04 59.33 35.78 47.61 8.11 49.66 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "51.72 8.11 62.81 34.3 61.07 35.04 49.66 8.11 51.72 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "53.77 8.11 63.04 30 63.04 34.2 62.81 34.3 51.72 8.11 53.77 8.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "63.04 30 53.77 8.11 63.04 8.11 63.04 30"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "-13.46 30.01 -11.95 29.37 .14 57.92 -1.64 57.92 -13.46 30.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "-11.95 29.37 -10.44 28.73 1.93 57.92 .14 57.92 -11.95 29.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "-10.44 28.73 -8.92 28.09 3.53 57.48 2.49 57.92 1.93 57.92 -10.44 28.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: -2.76,
    y: 26.5,
    width: 1.64,
    height: 31.92,
    transform: "translate(-16.71 2.6) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: -1.25,
    y: 25.86,
    width: 1.64,
    height: 31.92,
    transform: "translate(-16.34 3.14) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 0.26,
    y: 25.22,
    width: 1.64,
    height: 31.92,
    transform: "translate(-15.97 3.68) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 1.78,
    y: 24.58,
    width: 1.64,
    height: 31.92,
    transform: "translate(-15.6 4.22) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 3.29,
    y: 23.94,
    width: 1.64,
    height: 31.92,
    transform: "translate(-15.23 4.76) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 4.8,
    y: 23.3,
    width: 1.64,
    height: 31.92,
    transform: "translate(-14.86 5.3) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 6.31,
    y: 22.66,
    width: 1.64,
    height: 31.92,
    transform: "translate(-14.49 5.84) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 7.83,
    y: 22.02,
    width: 1.64,
    height: 31.92,
    transform: "translate(-14.12 6.38) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 9.34,
    y: 21.38,
    width: 1.64,
    height: 31.92,
    transform: "translate(-13.76 6.92) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 10.85,
    y: 20.74,
    width: 1.64,
    height: 31.92,
    transform: "translate(-13.39 7.46) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 12.37,
    y: 20.1,
    width: 1.64,
    height: 31.92,
    transform: "translate(-13.02 8) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 13.88,
    y: 19.45,
    width: 1.64,
    height: 31.92,
    transform: "translate(-12.65 8.54) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 15.39,
    y: 18.81,
    width: 1.64,
    height: 31.92,
    transform: "translate(-12.28 9.08) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 16.91,
    y: 18.17,
    width: 1.64,
    height: 31.92,
    transform: "translate(-11.91 9.61) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 18.42,
    y: 17.53,
    width: 1.64,
    height: 31.92,
    transform: "translate(-11.54 10.15) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 19.93,
    y: 16.89,
    width: 1.64,
    height: 31.92,
    transform: "translate(-11.17 10.69) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 21.45,
    y: 16.25,
    width: 1.64,
    height: 31.92,
    transform: "translate(-10.8 11.23) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 22.96,
    y: 15.61,
    width: 1.64,
    height: 31.92,
    transform: "translate(-10.43 11.77) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 24.47,
    y: 14.97,
    width: 1.64,
    height: 31.92,
    transform: "translate(-10.06 12.31) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 25.98,
    y: 14.33,
    width: 1.64,
    height: 31.92,
    transform: "translate(-9.69 12.85) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "21.34 15.27 22.12 14.94 22.98 14.94 35.3 44.03 33.79 44.67 21.34 15.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "24.77 14.94 36.81 43.39 35.3 44.03 22.98 14.94 24.77 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "26.55 14.94 38.33 42.75 36.81 43.39 24.77 14.94 26.55 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "28.34 14.94 39.84 42.11 38.33 42.75 26.55 14.94 28.34 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "30.12 14.94 41.35 41.47 39.84 42.11 28.34 14.94 30.12 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "31.9 14.94 42.87 40.83 41.35 41.47 30.12 14.94 31.9 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "33.69 14.94 44.38 40.18 42.87 40.83 31.9 14.94 33.69 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "35.47 14.94 45.89 39.54 44.38 40.18 33.69 14.94 35.47 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "37.26 14.94 47.4 38.9 45.89 39.54 35.47 14.94 37.26 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "39.04 14.94 48.92 38.26 47.4 38.9 37.26 14.94 39.04 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "40.83 14.94 50.43 37.62 48.92 38.26 39.04 14.94 40.83 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "42.61 14.94 51.94 36.98 50.43 37.62 40.83 14.94 42.61 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.4 14.94 53.46 36.34 51.94 36.98 42.61 14.94 44.4 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "46.18 14.94 54.97 35.7 53.46 36.34 44.4 14.94 46.18 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "47.96 14.94 56.48 35.06 54.97 35.7 46.18 14.94 47.96 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "49.75 14.94 58 34.42 56.48 35.06 47.96 14.94 49.75 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "51.53 14.94 59.51 33.78 58 34.42 49.75 14.94 51.53 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "53.32 14.94 59.63 29.84 59.63 33.73 59.51 33.78 51.53 14.94 53.32 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "59.63 29.84 53.32 14.94 59.63 14.94 59.63 29.84"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1.28 49.21 2.62 52.37 1.28 52.37 1.28 49.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "1.28 46.06 3.95 52.37 2.62 52.37 1.28 49.21 1.28 46.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "1.28 42.9 5.29 52.37 3.95 52.37 1.28 46.06 1.28 42.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "1.28 39.75 6.62 52.37 5.29 52.37 1.28 42.9 1.28 39.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "1.28 36.6 7.96 52.37 6.62 52.37 1.28 39.75 1.28 36.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "1.28 33.44 9.3 52.37 7.96 52.37 1.28 36.6 1.28 33.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "1.28 31.23 1.62 31.09 10.63 52.37 9.3 52.37 1.28 33.44 1.28 31.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "1.62 31.09 2.75 30.61 11.97 52.37 10.63 52.37 1.62 31.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2.75 30.61 3.89 30.13 13.3 52.37 11.97 52.37 2.75 30.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "3.89 30.13 5.02 29.65 14.64 52.37 13.3 52.37 3.89 30.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "5.02 29.65 6.15 29.17 15.79 51.94 14.79 52.37 14.64 52.37 5.02 29.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 10.92,
    y: 27.95,
    width: 1.23,
    height: 24.73,
    transform: "translate(-14.81 7.69) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 12.06,
    y: 27.47,
    width: 1.23,
    height: 24.73,
    transform: "translate(-14.53 8.09) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 13.19,
    y: 26.99,
    width: 1.23,
    height: 24.73,
    transform: "translate(-14.25 8.5) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 14.32,
    y: 26.51,
    width: 1.23,
    height: 24.73,
    transform: "translate(-13.98 8.9) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.45,
    y: 26.03,
    width: 1.23,
    height: 24.73,
    transform: "translate(-13.7 9.31) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 16.59,
    y: 25.55,
    width: 1.23,
    height: 24.73,
    transform: "translate(-13.42 9.71) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 17.72,
    y: 25.07,
    width: 1.23,
    height: 24.73,
    transform: "translate(-13.15 10.11) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 18.85,
    y: 24.59,
    width: 1.23,
    height: 24.73,
    transform: "translate(-12.87 10.52) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 19.99,
    y: 24.11,
    width: 1.23,
    height: 24.73,
    transform: "translate(-12.59 10.92) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 21.12,
    y: 23.63,
    width: 1.23,
    height: 24.73,
    transform: "translate(-12.32 11.32) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 22.25,
    y: 23.15,
    width: 1.23,
    height: 24.73,
    transform: "translate(-12.04 11.73) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 23.38,
    y: 22.67,
    width: 1.23,
    height: 24.73,
    transform: "translate(-11.76 12.13) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 24.52,
    y: 22.19,
    width: 1.23,
    height: 24.73,
    transform: "translate(-11.49 12.53) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 25.65,
    y: 21.71,
    width: 1.23,
    height: 24.73,
    transform: "translate(-11.21 12.94) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 26.78,
    y: 21.24,
    width: 1.23,
    height: 24.73,
    transform: "translate(-10.93 13.34) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.91,
    y: 20.76,
    width: 1.23,
    height: 24.73,
    transform: "translate(-10.66 13.75) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 29.05,
    y: 20.28,
    width: 1.23,
    height: 24.73,
    transform: "translate(-10.38 14.15) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 30.18,
    y: 19.8,
    width: 1.23,
    height: 24.73,
    transform: "translate(-10.1 14.55) rotate(-22.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "26.54 20.54 27.35 20.19 27.73 20.19 37.32 42.83 36.18 43.31 26.54 20.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "29.07 20.19 38.45 42.35 37.32 42.83 27.73 20.19 29.07 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "30.4 20.19 39.58 41.87 38.45 42.35 29.07 20.19 30.4 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "31.74 20.19 40.71 41.39 39.58 41.87 30.4 20.19 31.74 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "33.07 20.19 41.85 40.91 40.71 41.39 31.74 20.19 33.07 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "34.41 20.19 42.98 40.43 41.85 40.91 33.07 20.19 34.41 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "35.74 20.19 44.11 39.95 42.98 40.43 34.41 20.19 35.74 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "37.08 20.19 45.24 39.47 44.11 39.95 35.74 20.19 37.08 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "38.42 20.19 46.38 38.99 45.24 39.47 37.08 20.19 38.42 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "39.75 20.19 47.51 38.51 46.38 38.99 38.42 20.19 39.75 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "41.09 20.19 48.64 38.03 47.51 38.51 39.75 20.19 41.09 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "42.42 20.19 49.77 37.56 48.64 38.03 41.09 20.19 42.42 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "43.76 20.19 50.91 37.08 49.77 37.56 42.42 20.19 43.76 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "45.09 20.19 52.04 36.6 50.91 37.08 43.76 20.19 45.09 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "46.43 20.19 53.17 36.12 52.04 36.6 45.09 20.19 46.43 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "47.77 20.19 54.31 35.64 53.17 36.12 46.43 20.19 47.77 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "49.1 20.19 55.44 35.16 54.31 35.64 47.77 20.19 49.1 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "50.44 20.19 56.5 34.5 56.5 34.71 55.44 35.16 49.1 20.19 50.44 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "51.77 20.19 56.5 31.35 56.5 34.5 50.44 20.19 51.77 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "56.5 31.35 51.77 20.19 56.5 20.19 56.5 31.35"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "82.89 19.88 85 22.93 82.89 22.93 82.89 19.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "82.89 19.48 85.28 22.93 85 22.93 82.89 19.88 82.89 19.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "82.89 19.07 85.56 22.93 85.28 22.93 82.89 19.48 82.89 19.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "82.89 18.67 85.84 22.93 85.56 22.93 82.89 19.07 82.89 18.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "82.89 18.26 86.12 22.93 85.84 22.93 82.89 18.67 82.89 18.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "82.89 17.86 82.89 17.86 86.4 22.93 86.12 22.93 82.89 18.26 82.89 17.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "82.89 17.86 83.08 17.73 86.68 22.93 86.4 22.93 82.89 17.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "83.08 17.73 83.27 17.6 86.96 22.93 86.68 22.93 83.08 17.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "83.27 17.6 83.46 17.47 87.24 22.93 86.96 22.93 83.27 17.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "83.46 17.47 83.65 17.34 87.52 22.93 87.24 22.93 83.46 17.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "83.65 17.34 83.83 17.21 87.8 22.93 87.52 22.93 83.65 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "83.83 17.21 84.02 17.07 88.08 22.93 87.8 22.93 83.83 17.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "84.02 17.07 84.21 16.94 88.36 22.93 88.08 22.93 84.02 17.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "84.21 16.94 84.4 16.81 88.64 22.93 88.36 22.93 84.21 16.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "84.4 16.81 84.59 16.68 88.92 22.93 88.64 22.93 84.4 16.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "84.59 16.68 84.78 16.55 89.2 22.93 88.92 22.93 84.59 16.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "84.78 16.55 84.97 16.42 89.48 22.93 89.2 22.93 84.78 16.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "84.97 16.42 85.16 16.29 89.76 22.93 89.48 22.93 84.97 16.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "85.16 16.29 85.35 16.16 90.04 22.93 89.76 22.93 85.16 16.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "85.35 16.16 85.54 16.02 90.32 22.93 90.04 22.93 85.35 16.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "85.54 16.02 85.73 15.89 90.6 22.93 90.32 22.93 85.54 16.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "85.73 15.89 85.92 15.76 90.88 22.92 90.87 22.93 90.6 22.93 85.73 15.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 88.38,
    y: 14.92,
    width: 0.23,
    height: 8.71,
    transform: "translate(4.77 53.82) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 88.57,
    y: 14.79,
    width: 0.23,
    height: 8.71,
    transform: "translate(4.88 53.91) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 88.76,
    y: 14.66,
    width: 0.23,
    height: 8.71,
    transform: "translate(4.99 53.99) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 88.95,
    y: 14.53,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.1 54.08) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 89.14,
    y: 14.4,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.21 54.16) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 89.33,
    y: 14.27,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.32 54.25) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 89.51,
    y: 14.13,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.42 54.33) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 89.7,
    y: 14,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.53 54.42) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 89.89,
    y: 13.87,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.64 54.5) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 90.08,
    y: 13.74,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.75 54.59) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 90.27,
    y: 13.61,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.86 54.67) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 90.46,
    y: 13.48,
    width: 0.23,
    height: 8.71,
    transform: "translate(5.97 54.75) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 90.65,
    y: 13.35,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.07 54.84) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 90.84,
    y: 13.22,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.18 54.92) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 91.03,
    y: 13.08,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.29 55.01) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 91.22,
    y: 12.95,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.4 55.09) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 91.41,
    y: 12.82,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.51 55.18) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 91.6,
    y: 12.69,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.62 55.26) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 91.79,
    y: 12.56,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.72 55.35) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 91.98,
    y: 12.43,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.83 55.43) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 92.17,
    y: 12.3,
    width: 0.23,
    height: 8.71,
    transform: "translate(6.94 55.52) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 92.36,
    y: 12.17,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.05 55.6) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 92.55,
    y: 12.03,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.16 55.68) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 92.74,
    y: 11.9,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.27 55.77) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 92.92,
    y: 11.77,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.38 55.85) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 93.11,
    y: 11.64,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.48 55.94) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 93.3,
    y: 11.51,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.59 56.02) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 93.49,
    y: 11.38,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.7 56.11) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 93.68,
    y: 11.25,
    width: 0.23,
    height: 8.71,
    transform: "translate(7.81 56.19) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "91.41 11.96 91.53 11.88 91.64 11.88 96.55 18.97 96.55 18.99 96.37 19.12 91.41 11.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "91.92 11.88 96.55 18.57 96.55 18.97 91.64 11.88 91.92 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "92.2 11.88 96.55 18.16 96.55 18.57 91.92 11.88 92.2 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "92.48 11.88 96.55 17.76 96.55 18.16 92.2 11.88 92.48 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "92.76 11.88 96.55 17.35 96.55 17.76 92.48 11.88 92.76 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "93.04 11.88 96.55 16.95 96.55 17.35 92.76 11.88 93.04 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "93.32 11.88 96.55 16.54 96.55 16.95 93.04 11.88 93.32 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "93.6 11.88 96.55 16.14 96.55 16.54 93.32 11.88 93.6 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "93.88 11.88 96.55 15.73 96.55 16.14 93.6 11.88 93.88 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "94.16 11.88 96.55 15.33 96.55 15.73 93.88 11.88 94.16 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "94.44 11.88 96.55 14.92 96.55 15.33 94.16 11.88 94.44 11.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "96.55 14.92 94.44 11.88 96.55 11.88 96.55 14.92"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 82.39,
    y: 19.95,
    width: 0.32,
    height: 7.94,
    transform: "translate(1.07 51.27) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 82.87,
    y: 19.61,
    width: 0.32,
    height: 7.94,
    transform: "translate(1.35 51.48) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 83.35,
    y: 19.28,
    width: 0.32,
    height: 7.94,
    transform: "translate(1.62 51.7) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 83.83,
    y: 18.95,
    width: 0.32,
    height: 7.94,
    transform: "translate(1.9 51.91) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 84.31,
    y: 18.62,
    width: 0.32,
    height: 7.94,
    transform: "translate(2.17 52.12) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 84.79,
    y: 18.28,
    width: 0.32,
    height: 7.94,
    transform: "translate(2.45 52.34) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 85.27,
    y: 17.95,
    width: 0.32,
    height: 7.94,
    transform: "translate(2.72 52.55) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 85.75,
    y: 17.62,
    width: 0.32,
    height: 7.94,
    transform: "translate(3 52.77) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 86.23,
    y: 17.29,
    width: 0.32,
    height: 7.94,
    transform: "translate(3.27 52.98) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 86.71,
    y: 16.96,
    width: 0.32,
    height: 7.94,
    transform: "translate(3.55 53.19) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 87.19,
    y: 16.62,
    width: 0.32,
    height: 7.94,
    transform: "translate(3.82 53.41) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 87.67,
    y: 16.29,
    width: 0.32,
    height: 7.94,
    transform: "translate(4.09 53.62) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 88.15,
    y: 15.96,
    width: 0.32,
    height: 7.94,
    transform: "translate(4.37 53.84) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 88.63,
    y: 15.63,
    width: 0.32,
    height: 7.94,
    transform: "translate(4.64 54.05) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 89.11,
    y: 15.29,
    width: 0.32,
    height: 7.94,
    transform: "translate(4.92 54.26) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 89.59,
    y: 14.96,
    width: 0.32,
    height: 7.94,
    transform: "translate(5.19 54.48) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 90.07,
    y: 14.63,
    width: 0.32,
    height: 7.94,
    transform: "translate(5.47 54.69) rotate(-34.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 90.55,
    y: 14.3,
    width: 0.32,
    height: 7.94,
    transform: "translate(5.74 54.91) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 91.03,
    y: 13.97,
    width: 0.32,
    height: 7.94,
    transform: "translate(6.02 55.12) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 91.51,
    y: 13.63,
    width: 0.32,
    height: 7.94,
    transform: "translate(6.29 55.33) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 91.99,
    y: 13.3,
    width: 0.32,
    height: 7.94,
    transform: "translate(6.56 55.55) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 92.47,
    y: 12.97,
    width: 0.32,
    height: 7.94,
    transform: "translate(6.84 55.76) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 92.94,
    y: 12.64,
    width: 0.32,
    height: 7.94,
    transform: "translate(7.11 55.98) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 93.42,
    y: 12.3,
    width: 0.32,
    height: 7.94,
    transform: "translate(7.39 56.19) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 93.9,
    y: 11.97,
    width: 0.32,
    height: 7.94,
    transform: "translate(7.66 56.4) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 94.38,
    y: 11.64,
    width: 0.32,
    height: 7.94,
    transform: "translate(7.94 56.62) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 94.86,
    y: 11.31,
    width: 0.32,
    height: 7.94,
    transform: "translate(8.21 56.83) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 95.34,
    y: 10.98,
    width: 0.32,
    height: 7.94,
    transform: "translate(8.49 57.05) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 95.82,
    y: 10.64,
    width: 0.32,
    height: 7.94,
    transform: "translate(8.76 57.26) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 96.3,
    y: 10.31,
    width: 0.32,
    height: 7.94,
    transform: "translate(9.04 57.47) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 96.78,
    y: 9.98,
    width: 0.32,
    height: 7.94,
    transform: "translate(9.31 57.69) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 97.26,
    y: 9.65,
    width: 0.32,
    height: 7.94,
    transform: "translate(9.59 57.9) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 97.74,
    y: 9.31,
    width: 0.32,
    height: 7.94,
    transform: "translate(9.86 58.12) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 98.22,
    y: 8.98,
    width: 0.32,
    height: 7.94,
    transform: "translate(10.13 58.33) rotate(-34.71)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-259"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "82.57 18.02 84.53 20.85 82.57 20.85 82.57 18.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "82.57 17.57 84.85 20.85 84.53 20.85 82.57 18.02 82.57 17.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "82.57 17.11 85.16 20.85 84.85 20.85 82.57 17.57 82.57 17.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "82.57 16.66 85.48 20.85 85.16 20.85 82.57 17.11 82.57 16.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "82.57 16.2 85.8 20.85 85.48 20.85 82.57 16.66 82.57 16.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "82.57 15.75 86.11 20.85 85.8 20.85 82.57 16.2 82.57 15.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "82.57 15.29 86.43 20.85 86.11 20.85 82.57 15.75 82.57 15.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "82.57 14.83 86.74 20.85 86.43 20.85 82.57 15.29 82.57 14.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "82.57 14.38 87.06 20.85 86.74 20.85 82.57 14.83 82.57 14.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.57 14.31 82.75 14.18 87.37 20.85 87.06 20.85 82.57 14.38 82.57 14.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "82.75 14.18 82.97 14.04 87.69 20.85 87.37 20.85 82.75 14.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "82.97 14.04 83.18 13.89 88 20.85 87.69 20.85 82.97 14.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "83.18 13.89 83.39 13.74 88.32 20.85 88 20.85 83.18 13.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "83.39 13.74 83.61 13.59 88.64 20.85 88.32 20.85 83.39 13.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "83.61 13.59 83.82 13.45 88.95 20.85 88.64 20.85 83.61 13.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "83.82 13.45 84.03 13.3 89.27 20.85 88.95 20.85 83.82 13.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "84.03 13.3 84.25 13.15 89.58 20.85 89.27 20.85 84.03 13.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "84.25 13.15 84.46 13 89.9 20.85 89.9 20.85 89.58 20.85 84.25 13.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 87.16,
    y: 12.08,
    width: 0.26,
    height: 9.55,
    transform: "translate(5.94 52.71) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 87.37,
    y: 11.93,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.06 52.8) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 87.58,
    y: 11.78,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.18 52.9) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 87.8,
    y: 11.64,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.31 52.99) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 88.01,
    y: 11.49,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.43 53.09) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 88.22,
    y: 11.34,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.55 53.18) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 88.44,
    y: 11.19,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.67 53.28) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 88.65,
    y: 11.04,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.79 53.37) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 88.86,
    y: 10.9,
    width: 0.26,
    height: 9.55,
    transform: "translate(6.92 53.47) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.08,
    y: 10.75,
    width: 0.26,
    height: 9.55,
    transform: "translate(7.04 53.56) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 89.29,
    y: 10.6,
    width: 0.26,
    height: 9.55,
    transform: "translate(7.16 53.66) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 89.5,
    y: 10.45,
    width: 0.26,
    height: 9.55,
    transform: "translate(7.28 53.75) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 89.72,
    y: 10.31,
    width: 0.26,
    height: 9.55,
    transform: "translate(7.4 53.85) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 89.93,
    y: 10.16,
    width: 0.26,
    height: 9.55,
    transform: "translate(7.53 53.94) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "87.45 10.93 87.45 10.93 87.76 10.93 93.1 18.63 92.88 18.78 87.45 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "88.08 10.93 93.31 18.49 93.1 18.63 87.76 10.93 88.08 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "88.39 10.93 93.52 18.34 93.31 18.49 88.08 10.93 88.39 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "88.71 10.93 93.74 18.19 93.52 18.34 88.39 10.93 88.71 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "89.02 10.93 93.95 18.04 93.74 18.19 88.71 10.93 89.02 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "89.34 10.93 94.16 17.89 93.95 18.04 89.02 10.93 89.34 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "89.65 10.93 94.38 17.75 94.16 17.89 89.34 10.93 89.65 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "89.97 10.93 94.59 17.6 94.38 17.75 89.65 10.93 89.97 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "90.29 10.93 94.77 17.4 94.77 17.47 94.59 17.6 89.97 10.93 90.29 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "90.6 10.93 94.77 16.95 94.77 17.4 90.29 10.93 90.6 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "90.92 10.93 94.77 16.49 94.77 16.95 90.6 10.93 90.92 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "91.23 10.93 94.77 16.04 94.77 16.49 90.92 10.93 91.23 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "91.55 10.93 94.77 15.58 94.77 16.04 91.23 10.93 91.55 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "91.86 10.93 94.77 15.13 94.77 15.58 91.55 10.93 91.86 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "92.18 10.93 94.77 14.67 94.77 15.13 91.86 10.93 92.18 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "92.5 10.93 94.77 14.21 94.77 14.67 92.18 10.93 92.5 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "92.81 10.93 94.77 13.76 94.77 14.21 92.5 10.93 92.81 10.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "94.77 13.76 92.81 10.93 94.77 10.93 94.77 13.76"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "83.93 19.33 84.08 19.55 83.93 19.55 83.93 19.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "83.93 18.82 84.44 19.55 84.08 19.55 83.93 19.33 83.93 18.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "83.93 18.3 84.79 19.55 84.44 19.55 83.93 18.82 83.93 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "83.93 17.79 85.15 19.55 84.79 19.55 83.93 18.3 83.93 17.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "83.93 17.28 85.51 19.55 85.15 19.55 83.93 17.79 83.93 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "83.93 16.76 85.86 19.55 85.51 19.55 83.93 17.28 83.93 16.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "83.93 16.25 86.22 19.55 85.86 19.55 83.93 16.76 83.93 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "83.93 15.73 86.57 19.55 86.22 19.55 83.93 16.25 83.93 15.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "83.93 15.22 86.93 19.55 86.57 19.55 83.93 15.73 83.93 15.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "83.93 14.7 87.29 19.55 86.93 19.55 83.93 15.22 83.93 14.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "83.93 14.35 84 14.3 87.64 19.55 87.29 19.55 83.93 14.7 83.93 14.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "84 14.3 84.24 14.13 88 19.55 87.64 19.55 84 14.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "84.24 14.13 84.48 13.96 88.36 19.55 88 19.55 84.24 14.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "84.48 13.96 84.73 13.8 88.71 19.55 88.36 19.55 84.48 13.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "84.73 13.8 84.97 13.63 89.07 19.55 88.71 19.55 84.73 13.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "84.97 13.63 85.21 13.46 89.43 19.55 89.07 19.55 84.97 13.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "85.21 13.46 85.45 13.29 89.78 19.55 89.43 19.55 85.21 13.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "85.45 13.29 85.69 13.13 90.14 19.55 89.78 19.55 85.45 13.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "85.69 13.13 85.93 12.96 90.45 19.49 90.36 19.55 90.14 19.55 85.69 13.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 88.16,
    y: 12.17,
    width: 0.29,
    height: 7.94,
    transform: "translate(6.53 53.16) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 88.41,
    y: 12,
    width: 0.29,
    height: 7.94,
    transform: "translate(6.66 53.27) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 88.65,
    y: 11.84,
    width: 0.29,
    height: 7.94,
    transform: "translate(6.8 53.38) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "86.65 12.46 86.85 12.32 86.91 12.32 91.41 18.82 91.17 18.99 86.65 12.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "87.27 12.32 91.66 18.65 91.41 18.82 86.91 12.32 87.27 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "87.62 12.32 91.9 18.49 91.66 18.65 87.27 12.32 87.62 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "87.98 12.32 92.14 18.32 91.9 18.49 87.62 12.32 87.98 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "88.34 12.32 92.38 18.15 92.14 18.32 87.98 12.32 88.34 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "88.69 12.32 92.62 17.99 92.38 18.15 88.34 12.32 88.69 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "89.05 12.32 92.86 17.82 92.62 17.99 88.69 12.32 89.05 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "89.41 12.32 93.1 17.65 92.86 17.82 89.05 12.32 89.41 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "89.76 12.32 93.34 17.49 93.1 17.65 89.41 12.32 89.76 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "90.12 12.32 93.41 17.08 93.41 17.44 93.34 17.49 89.76 12.32 90.12 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "90.47 12.32 93.41 16.56 93.41 17.08 90.12 12.32 90.47 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "90.83 12.32 93.41 16.05 93.41 16.56 90.47 12.32 90.83 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "91.19 12.32 93.41 15.54 93.41 16.05 90.83 12.32 91.19 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "91.54 12.32 93.41 15.02 93.41 15.54 91.19 12.32 91.54 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "91.9 12.32 93.41 14.51 93.41 15.02 91.54 12.32 91.9 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "92.26 12.32 93.41 13.99 93.41 14.51 91.9 12.32 92.26 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "92.61 12.32 93.41 13.48 93.41 13.99 92.26 12.32 92.61 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "92.97 12.32 93.41 12.96 93.41 13.48 92.61 12.32 92.97 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "93.32 12.32 93.41 12.45 93.41 12.96 92.97 12.32 93.32 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "93.41 12.45 93.32 12.32 93.41 12.32 93.41 12.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "82.24 18.95 83.71 21.07 82.24 21.07 82.24 18.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "82.24 18.43 84.06 21.07 83.71 21.07 82.24 18.95 82.24 18.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "82.24 17.92 84.42 21.07 84.06 21.07 82.24 18.43 82.24 17.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "82.24 17.4 84.78 21.07 84.42 21.07 82.24 17.92 82.24 17.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "82.24 16.89 85.13 21.07 84.78 21.07 82.24 17.4 82.24 16.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "82.24 16.38 85.49 21.07 85.13 21.07 82.24 16.89 82.24 16.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "82.24 15.86 85.84 21.07 85.49 21.07 82.24 16.38 82.24 15.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "82.24 15.35 86.2 21.07 85.84 21.07 82.24 15.86 82.24 15.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "82.24 14.83 86.56 21.07 86.2 21.07 82.24 15.35 82.24 14.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "82.24 14.32 86.91 21.07 86.56 21.07 82.24 14.83 82.24 14.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "82.24 13.8 87.27 21.07 86.91 21.07 82.24 14.32 82.24 13.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "82.24 13.57 82.37 13.48 87.63 21.07 87.27 21.07 82.24 13.8 82.24 13.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "82.37 13.48 82.61 13.31 87.98 21.07 87.63 21.07 82.37 13.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "82.61 13.31 82.85 13.14 88.34 21.07 87.98 21.07 82.61 13.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "82.85 13.14 83.09 12.98 88.7 21.07 88.34 21.07 82.85 13.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "83.09 12.98 83.33 12.81 89.05 21.07 88.7 21.07 83.09 12.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "83.33 12.81 83.57 12.64 89.41 21.07 89.05 21.07 83.33 12.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "83.57 12.64 83.81 12.48 89.76 21.07 89.41 21.07 83.57 12.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "83.81 12.48 84.05 12.31 90.12 21.07 89.76 21.07 83.81 12.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "84.05 12.31 84.29 12.14 90.48 21.07 90.12 21.07 84.05 12.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "84.29 12.14 84.53 11.98 90.83 21.07 90.48 21.07 84.29 12.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "84.53 11.98 84.77 11.81 91.13 20.98 90.99 21.07 90.83 21.07 84.53 11.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 87.92,
    y: 10.73,
    width: 0.29,
    height: 11.15,
    transform: "translate(6.39 53.06) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 88.16,
    y: 10.57,
    width: 0.29,
    height: 11.15,
    transform: "translate(6.53 53.16) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 88.41,
    y: 10.4,
    width: 0.29,
    height: 11.15,
    transform: "translate(6.66 53.27) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 88.65,
    y: 10.23,
    width: 0.29,
    height: 11.15,
    transform: "translate(6.8 53.38) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 88.89,
    y: 10.07,
    width: 0.29,
    height: 11.15,
    transform: "translate(6.94 53.48) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 89.13,
    y: 9.9,
    width: 0.29,
    height: 11.15,
    transform: "translate(7.08 53.59) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 89.37,
    y: 9.73,
    width: 0.29,
    height: 11.15,
    transform: "translate(7.21 53.7) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "86.46 10.64 86.59 10.55 86.75 10.55 93.05 19.64 92.81 19.81 86.46 10.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "87.11 10.55 93.29 19.47 93.05 19.64 86.75 10.55 87.11 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "87.46 10.55 93.53 19.31 93.29 19.47 87.11 10.55 87.46 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "87.82 10.55 93.77 19.14 93.53 19.31 87.46 10.55 87.82 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "88.18 10.55 94.01 18.97 93.77 19.14 87.82 10.55 88.18 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "88.53 10.55 94.25 18.81 94.01 18.97 88.18 10.55 88.53 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "88.89 10.55 94.5 18.64 94.25 18.81 88.53 10.55 88.89 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "89.25 10.55 94.74 18.47 94.5 18.64 88.89 10.55 89.25 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "89.6 10.55 94.98 18.31 94.74 18.47 89.25 10.55 89.6 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "89.96 10.55 95.11 17.98 95.11 18.22 94.98 18.31 89.6 10.55 89.96 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "90.31 10.55 95.11 17.46 95.11 17.98 89.96 10.55 90.31 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.67 10.55 95.11 16.95 95.11 17.46 90.31 10.55 90.67 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "91.03 10.55 95.11 16.44 95.11 16.95 90.67 10.55 91.03 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "91.38 10.55 95.11 15.92 95.11 16.44 91.03 10.55 91.38 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "91.74 10.55 95.11 15.41 95.11 15.92 91.38 10.55 91.74 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "92.1 10.55 95.11 14.89 95.11 15.41 91.74 10.55 92.1 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "92.45 10.55 95.11 14.38 95.11 14.89 92.1 10.55 92.45 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "92.81 10.55 95.11 13.86 95.11 14.38 92.45 10.55 92.81 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "93.16 10.55 95.11 13.35 95.11 13.86 92.81 10.55 93.16 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "93.52 10.55 95.11 12.84 95.11 13.35 93.16 10.55 93.52 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "95.11 12.84 93.52 10.55 95.11 10.55 95.11 12.84"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m91.14,15.67c-.1-.03-.21-.06-.33-.08-.1-.02-.18,0-.31.12-.16.14-.31.28-.46.41-.31.27-.63.49-1,.67-.46.22-.77.22-1.04.12l1.11-.77c.09-.06.13-.15.1-.19l-.12-.17s-.13-.03-.21.03l-1.21.84-.1-.14,1.21-.84c.09-.06.13-.15.1-.19l-.12-.17s-.13-.03-.21.03l-1.06.74h0c.03-.24.14-.48.4-.75.31-.32.67-.57,1.06-.78.19-.1.37-.19.56-.29.14-.07.2-.14.21-.24.02-.11.02-.22.03-.33,0-.11-.05-.13-.2-.08-.04.01-.07.03-.11.04-.58.26-1.13.58-1.65,1-.36.3-.68.61-.9.95-.28.42-.4.79-.39,1.13v.04s-.54.38-.54.38c-.09.06-.13.15-.1.19l.12.17s.13.03.21-.03l.43-.3.1.14-.43.3c-.09.06-.13.15-.1.19l.12.17s.13.03.21-.03l.51-.36c.08.04.16.08.25.11.48.14,1.08.05,1.81-.29.61-.29,1.16-.68,1.66-1.13.13-.12.25-.24.37-.37.13-.14.12-.21.03-.24h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "65.44 36.64 65.44 36.64 65.44 36.64 65.44 36.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "65.44 34.33 66.79 36.64 65.44 36.64 65.44 36.64 65.44 34.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "65.44 32.02 68.14 36.64 66.79 36.64 65.44 34.33 65.44 32.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "65.44 29.71 69.49 36.64 68.14 36.64 65.44 32.02 65.44 29.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "65.44 27.4 70.84 36.64 69.49 36.64 65.44 29.71 65.44 27.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "65.44 25.09 72.19 36.64 70.84 36.64 65.44 27.4 65.44 25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "65.44 22.78 73.54 36.64 72.19 36.64 65.44 25.09 65.44 22.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "65.44 20.47 74.89 36.64 73.54 36.64 65.44 22.78 65.44 20.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "65.44 18.16 76.24 36.64 74.89 36.64 65.44 20.47 65.44 18.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "65.44 15.85 77.39 36.3 76.81 36.64 76.24 36.64 65.44 18.16 65.44 15.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "65.44 13.54 78.4 35.71 77.39 36.3 65.44 15.85 65.44 13.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "65.44 12.36 65.93 12.07 79.41 35.12 78.4 35.71 65.44 13.54 65.44 12.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 72.59,
    y: 9.95,
    width: 1.17,
    height: 26.7,
    transform: "translate(-1.76 40.12) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 73.6,
    y: 9.37,
    width: 1.17,
    height: 26.7,
    transform: "translate(-1.32 40.55) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 74.6,
    y: 8.78,
    width: 1.17,
    height: 26.7,
    transform: "translate(-.89 40.97) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 75.61,
    y: 8.19,
    width: 1.17,
    height: 26.7,
    transform: "translate(-.45 41.4) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 76.62,
    y: 7.6,
    width: 1.17,
    height: 26.7,
    transform: "translate(-.02 41.83) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 77.62,
    y: 7.01,
    width: 1.17,
    height: 26.7,
    transform: "translate(.42 42.26) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 78.63,
    y: 6.42,
    width: 1.17,
    height: 26.7,
    transform: "translate(.85 42.68) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 79.64,
    y: 5.83,
    width: 1.17,
    height: 26.7,
    transform: "translate(1.29 43.11) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 80.64,
    y: 5.25,
    width: 1.17,
    height: 26.7,
    transform: "translate(1.72 43.54) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 81.65,
    y: 4.66,
    width: 1.17,
    height: 26.7,
    transform: "translate(2.15 43.97) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 82.66,
    y: 4.07,
    width: 1.17,
    height: 26.7,
    transform: "translate(2.59 44.39) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 83.66,
    y: 3.48,
    width: 1.17,
    height: 26.7,
    transform: "translate(3.02 44.82) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84.67,
    y: 2.89,
    width: 1.17,
    height: 26.7,
    transform: "translate(3.46 45.25) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 85.68,
    y: 2.3,
    width: 1.17,
    height: 26.7,
    transform: "translate(3.89 45.68) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 86.68,
    y: 1.71,
    width: 1.17,
    height: 26.7,
    transform: "translate(4.33 46.1) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 87.69,
    y: 1.13,
    width: 1.17,
    height: 26.7,
    transform: "translate(4.76 46.53) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 88.7,
    y: 0.54,
    width: 1.17,
    height: 26.7,
    transform: "translate(5.2 46.96) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 89.7,
    y: -0.05,
    width: 1.17,
    height: 26.7,
    transform: "translate(5.63 47.39) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 90.71,
    y: -0.64,
    width: 1.17,
    height: 26.7,
    transform: "translate(6.07 47.82) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 91.71,
    y: -1.23,
    width: 1.17,
    height: 26.7,
    transform: "translate(6.5 48.24) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "86.06 .3 86.07 .3 87.41 .3 100.55 22.76 99.54 23.35 86.06 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "88.76 .3 101.55 22.17 100.55 22.76 87.41 .3 88.76 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "90.12 .3 102.56 21.58 101.55 22.17 88.76 .3 90.12 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "91.47 .3 103.57 21 102.56 21.58 90.12 .3 91.47 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "92.82 .3 104.57 20.41 103.57 21 91.47 .3 92.82 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "94.17 .3 105.58 19.82 104.57 20.41 92.82 .3 94.17 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "95.52 .3 106.59 19.23 105.58 19.82 94.17 .3 95.52 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "96.87 .3 107.59 18.64 106.59 19.23 95.52 .3 96.87 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "98.22 .3 108.6 18.05 107.59 18.64 96.87 .3 98.22 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "99.57 .3 109.61 17.46 108.6 18.05 98.22 .3 99.57 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "100.92 .3 110.61 16.88 109.61 17.46 99.57 .3 100.92 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "102.27 .3 111.62 16.29 110.61 16.88 100.92 .3 102.27 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "103.62 .3 112.63 15.7 111.62 16.29 102.27 .3 103.62 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "104.97 .3 113.63 15.11 112.63 15.7 103.62 .3 104.97 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "106.32 .3 114.64 14.52 113.63 15.11 104.97 .3 106.32 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "107.67 .3 115.13 13.04 115.13 14.24 114.64 14.52 106.32 .3 107.67 .3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m70.17,31.89l1.17,2.01-1.17-2.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "70.17 29.88 72.51 33.9 71.34 33.9 70.17 31.89 70.17 29.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "70.17 27.88 73.68 33.9 72.51 33.9 70.17 29.88 70.17 27.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "70.17 25.87 74.86 33.9 73.68 33.9 70.17 27.88 70.17 25.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "70.17 23.86 76.03 33.9 74.86 33.9 70.17 25.87 70.17 23.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "70.17 21.86 77.2 33.9 76.03 33.9 70.17 23.86 70.17 21.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "70.17 19.85 78.38 33.9 77.2 33.9 70.17 21.86 70.17 19.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "70.17 17.85 79.5 33.8 79.34 33.9 78.38 33.9 70.17 19.85 70.17 17.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "70.17 15.84 80.37 33.29 79.5 33.8 70.17 17.85 70.17 15.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "70.17 14.99 70.67 14.7 81.24 32.78 80.37 33.29 70.17 15.84 70.17 14.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 75.89,
    y: 13.01,
    width: 1.01,
    height: 20.95,
    transform: "translate(-1.41 41.77) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 76.76,
    y: 12.5,
    width: 1.01,
    height: 20.95,
    transform: "translate(-1.03 42.14) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 77.64,
    y: 11.99,
    width: 1.01,
    height: 20.95,
    transform: "translate(-.65 42.51) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 78.51,
    y: 11.48,
    width: 1.01,
    height: 20.95,
    transform: "translate(-.28 42.88) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 79.39,
    y: 10.97,
    width: 1.01,
    height: 20.95,
    transform: "translate(.1 43.26) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 80.26,
    y: 10.46,
    width: 1.01,
    height: 20.95,
    transform: "translate(.48 43.63) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 81.13,
    y: 9.95,
    width: 1.01,
    height: 20.95,
    transform: "translate(.86 44) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 82.01,
    y: 9.43,
    width: 1.01,
    height: 20.95,
    transform: "translate(1.23 44.37) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 82.88,
    y: 8.92,
    width: 1.01,
    height: 20.95,
    transform: "translate(1.61 44.74) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 83.76,
    y: 8.41,
    width: 1.01,
    height: 20.95,
    transform: "translate(1.99 45.11) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 84.63,
    y: 7.9,
    width: 1.01,
    height: 20.95,
    transform: "translate(2.37 45.48) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 85.5,
    y: 7.39,
    width: 1.01,
    height: 20.95,
    transform: "translate(2.74 45.85) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 86.38,
    y: 6.88,
    width: 1.01,
    height: 20.95,
    transform: "translate(3.12 46.23) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87.25,
    y: 6.37,
    width: 1.01,
    height: 20.95,
    transform: "translate(3.5 46.6) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 88.13,
    y: 5.86,
    width: 1.01,
    height: 20.95,
    transform: "translate(3.88 46.97) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 89,
    y: 5.35,
    width: 1.01,
    height: 20.95,
    transform: "translate(4.25 47.34) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.87,
    y: 4.83,
    width: 1.01,
    height: 20.95,
    transform: "translate(4.63 47.71) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 90.75,
    y: 4.32,
    width: 1.01,
    height: 20.95,
    transform: "translate(5.01 48.08) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 91.62,
    y: 3.81,
    width: 1.01,
    height: 20.95,
    transform: "translate(5.39 48.45) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 92.5,
    y: 3.3,
    width: 1.01,
    height: 20.95,
    transform: "translate(5.76 48.82) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 93.37,
    y: 2.79,
    width: 1.01,
    height: 20.95,
    transform: "translate(6.14 49.2) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 94.24,
    y: 2.28,
    width: 1.01,
    height: 20.95,
    transform: "translate(6.52 49.57) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "89.9 3.46 90.29 3.23 90.94 3.23 101.35 21.03 100.47 21.54 89.9 3.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "92.11 3.23 102.22 20.52 101.35 21.03 90.94 3.23 92.11 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "93.29 3.23 103.1 20.01 102.22 20.52 92.11 3.23 93.29 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "94.46 3.23 103.97 19.49 103.1 20.01 93.29 3.23 94.46 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "95.63 3.23 104.85 18.98 103.97 19.49 94.46 3.23 95.63 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "96.81 3.23 105.72 18.47 104.85 18.98 95.63 3.23 96.81 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "97.98 3.23 106.59 17.96 105.72 18.47 96.81 3.23 97.98 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "99.15 3.23 107.47 17.45 106.59 17.96 97.98 3.23 99.15 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "100.32 3.23 108.34 16.94 107.47 17.45 99.15 3.23 100.32 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "101.5 3.23 109.22 16.43 108.34 16.94 100.32 3.23 101.5 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "102.67 3.23 110.09 15.92 109.22 16.43 101.5 3.23 102.67 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "103.84 3.23 110.96 15.41 110.09 15.92 102.67 3.23 103.84 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "105.02 3.23 111.84 14.89 110.96 15.41 103.84 3.23 105.02 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "106.19 3.23 112.71 14.38 111.84 14.89 105.02 3.23 106.19 3.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "107.36 3.23 113.03 12.91 113.03 14.2 112.71 14.38 106.19 3.23 107.36 3.23"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "79.15 27.78 80.02 29.28 79.15 29.28 79.15 27.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "79.15 26.28 80.9 29.28 80.02 29.28 79.15 27.78 79.15 26.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "79.15 24.78 81.78 29.28 80.9 29.28 79.15 26.28 79.15 24.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "79.15 23.28 82.66 29.28 81.78 29.28 79.15 24.78 79.15 23.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "79.15 21.77 83.54 29.28 82.66 29.28 79.15 23.28 79.15 21.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "79.15 20.27 84.42 29.28 83.54 29.28 79.15 21.77 79.15 20.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "79.15 18.77 85.29 29.28 84.42 29.28 79.15 20.27 79.15 18.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "79.15 17.27 86.17 29.28 85.29 29.28 79.15 18.77 79.15 17.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.15 15.77 87 29.19 86.84 29.28 86.17 29.28 79.15 17.27 79.15 15.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "79.15 14.65 79.31 14.55 87.65 28.81 87 29.19 79.15 15.77 79.15 14.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 83.43,
    y: 13.23,
    width: 0.76,
    height: 16.52,
    transform: "translate(.61 45.24) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 84.09,
    y: 12.85,
    width: 0.76,
    height: 16.52,
    transform: "translate(.89 45.52) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 84.74,
    y: 12.47,
    width: 0.76,
    height: 16.52,
    transform: "translate(1.18 45.8) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 85.39,
    y: 12.08,
    width: 0.76,
    height: 16.52,
    transform: "translate(1.46 46.07) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 86.05,
    y: 11.7,
    width: 0.76,
    height: 16.52,
    transform: "translate(1.74 46.35) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 86.7,
    y: 11.32,
    width: 0.76,
    height: 16.52,
    transform: "translate(2.02 46.63) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 87.36,
    y: 10.94,
    width: 0.76,
    height: 16.52,
    transform: "translate(2.31 46.91) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 88.01,
    y: 10.55,
    width: 0.76,
    height: 16.52,
    transform: "translate(2.59 47.19) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 88.67,
    y: 10.17,
    width: 0.76,
    height: 16.52,
    transform: "translate(2.87 47.46) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 89.32,
    y: 9.79,
    width: 0.76,
    height: 16.52,
    transform: "translate(3.16 47.74) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 89.97,
    y: 9.41,
    width: 0.76,
    height: 16.52,
    transform: "translate(3.44 48.02) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 90.63,
    y: 9.02,
    width: 0.76,
    height: 16.52,
    transform: "translate(3.72 48.3) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 91.28,
    y: 8.64,
    width: 0.76,
    height: 16.52,
    transform: "translate(4 48.58) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 91.94,
    y: 8.26,
    width: 0.76,
    height: 16.52,
    transform: "translate(4.29 48.85) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 92.59,
    y: 7.88,
    width: 0.76,
    height: 16.52,
    transform: "translate(4.57 49.13) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 93.25,
    y: 7.49,
    width: 0.76,
    height: 16.52,
    transform: "translate(4.85 49.41) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 93.9,
    y: 7.11,
    width: 0.76,
    height: 16.52,
    transform: "translate(5.13 49.69) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 94.55,
    y: 6.73,
    width: 0.76,
    height: 16.52,
    transform: "translate(5.42 49.97) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 95.21,
    y: 6.35,
    width: 0.76,
    height: 16.52,
    transform: "translate(5.7 50.24) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 95.86,
    y: 5.96,
    width: 0.76,
    height: 16.52,
    transform: "translate(5.98 50.52) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 96.52,
    y: 5.58,
    width: 0.76,
    height: 16.52,
    transform: "translate(6.26 50.8) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "93.06 6.52 93.39 6.33 93.82 6.33 102.05 20.39 101.39 20.78 93.06 6.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "94.7 6.33 102.7 20.01 102.05 20.39 93.82 6.33 94.7 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "95.58 6.33 103.36 19.63 102.7 20.01 94.7 6.33 95.58 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "96.46 6.33 104.01 19.25 103.36 19.63 95.58 6.33 96.46 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "97.33 6.33 104.66 18.86 104.01 19.25 96.46 6.33 97.33 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "98.21 6.33 105.32 18.48 104.66 18.86 97.33 6.33 98.21 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "99.09 6.33 105.97 18.1 105.32 18.48 98.21 6.33 99.09 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "99.97 6.33 106.63 17.72 105.97 18.1 99.09 6.33 99.97 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "100.85 6.33 107.28 17.33 106.63 17.72 99.97 6.33 100.85 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "101.72 6.33 107.94 16.95 107.28 17.33 100.85 6.33 101.72 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "102.6 6.33 108.59 16.57 107.94 16.95 101.72 6.33 102.6 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "103.48 6.33 109.24 16.18 108.59 16.57 102.6 6.33 103.48 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "104.36 6.33 109.9 15.8 109.24 16.18 103.48 6.33 104.36 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "105.24 6.33 110.55 15.42 109.9 15.8 104.36 6.33 105.24 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "106.11 6.33 111.21 15.04 110.55 15.42 105.24 6.33 106.11 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "106.99 6.33 111.23 13.58 111.23 15.02 111.21 15.04 106.11 6.33 106.99 6.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "107.87 6.33 111.23 12.07 111.23 13.58 106.99 6.33 107.87 6.33"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "70.8 14.44 65.83 16.26 65.83 14.44 70.8 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "71.62 14.44 65.83 16.57 65.83 16.26 70.8 14.44 71.62 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "72.45 14.44 65.83 16.87 65.83 16.57 71.62 14.44 72.45 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "72.57 14.44 72.65 14.67 65.83 17.18 65.83 16.87 72.45 14.44 72.57 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "72.65 14.67 72.75 14.93 65.83 17.48 65.83 17.18 72.65 14.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "72.75 14.93 72.85 15.2 65.83 17.78 65.83 17.48 72.75 14.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "72.85 15.2 72.95 15.47 65.83 18.09 65.83 17.78 72.85 15.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "72.95 15.47 73.04 15.74 65.83 18.39 65.83 18.09 72.95 15.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "73.04 15.74 73.14 16.01 65.83 18.7 65.83 18.39 73.04 15.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "73.14 16.01 73.24 16.27 65.83 19 65.83 18.7 73.14 16.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "73.24 16.27 73.34 16.54 65.83 19.3 65.83 19 73.24 16.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "73.34 16.54 73.44 16.81 65.83 19.61 65.83 19.3 73.34 16.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "73.44 16.81 73.54 17.08 65.83 19.91 65.83 19.61 73.44 16.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "73.54 17.08 73.64 17.34 65.83 20.21 65.83 19.91 73.54 17.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "73.64 17.34 73.73 17.61 65.83 20.52 65.83 20.21 73.64 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "73.73 17.61 73.83 17.88 65.83 20.82 65.83 20.52 73.73 17.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "73.83 17.88 73.93 18.15 65.83 21.13 65.83 20.82 73.83 17.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "73.93 18.15 74.03 18.41 65.83 21.43 65.83 21.13 73.93 18.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "74.03 18.41 74.13 18.68 65.83 21.73 65.83 21.43 74.03 18.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "74.13 18.68 74.23 18.95 65.83 22.04 65.83 21.73 74.13 18.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "74.23 18.95 74.32 19.22 65.83 22.34 65.83 22.04 74.23 18.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "74.32 19.22 74.42 19.48 65.83 22.64 65.83 22.34 74.32 19.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "74.42 19.48 74.52 19.75 65.83 22.95 65.83 22.64 74.42 19.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "74.52 19.75 74.62 20.02 65.83 23.25 65.83 22.95 74.52 19.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "74.62 20.02 74.72 20.29 65.83 23.56 65.83 23.25 74.62 20.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "74.72 20.29 74.82 20.55 65.83 23.86 65.83 23.56 74.72 20.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "74.82 20.55 74.91 20.82 65.83 24.16 65.83 23.86 74.82 20.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "74.91 20.82 75.01 21.09 65.83 24.47 65.83 24.16 74.91 20.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "75.01 21.09 75.11 21.36 65.83 24.77 65.83 24.47 75.01 21.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "75.11 21.36 75.21 21.62 65.83 25.07 65.83 25.06 65.83 24.77 75.11 21.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 65.58,
    y: 23.34,
    width: 9.99,
    height: 0.29,
    transform: "translate(-3.77 25.8) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 65.67,
    y: 23.61,
    width: 9.99,
    height: 0.29,
    transform: "translate(-3.85 25.85) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 65.77,
    y: 23.88,
    width: 9.99,
    height: 0.29,
    transform: "translate(-3.94 25.9) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 65.87,
    y: 24.14,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.03 25.95) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 65.97,
    y: 24.41,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.11 26) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 66.07,
    y: 24.68,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.2 26.05) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 66.17,
    y: 24.95,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.29 26.1) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 66.26,
    y: 25.21,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.37 26.15) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 66.36,
    y: 25.48,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.46 26.2) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 66.46,
    y: 25.75,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.55 26.25) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 66.56,
    y: 26.02,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.63 26.31) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 66.66,
    y: 26.28,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.72 26.36) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 66.76,
    y: 26.55,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.8 26.41) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 66.86,
    y: 26.82,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.89 26.46) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 66.95,
    y: 27.09,
    width: 9.99,
    height: 0.29,
    transform: "translate(-4.98 26.51) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 67.05,
    y: 27.35,
    width: 9.99,
    height: 0.29,
    transform: "translate(-5.06 26.56) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "76.78 25.91 76.8 25.95 76.8 26.2 67.51 29.62 67.41 29.35 76.78 25.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "76.8 26.51 67.6 29.89 67.51 29.62 76.8 26.2 76.8 26.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "76.8 26.81 67.7 30.16 67.6 29.89 76.8 26.51 76.8 26.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "76.8 27.12 67.8 30.43 67.7 30.16 76.8 26.81 76.8 27.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "76.8 27.42 67.9 30.69 67.8 30.43 76.8 27.12 76.8 27.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "76.8 27.72 68 30.96 67.9 30.69 76.8 27.42 76.8 27.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "76.8 28.03 68.1 31.23 68 30.96 76.8 27.72 76.8 28.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "76.8 28.33 68.2 31.5 68.1 31.23 76.8 28.03 76.8 28.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "76.8 28.63 68.29 31.76 68.2 31.5 76.8 28.33 76.8 28.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "76.8 28.94 68.39 32.03 68.29 31.76 76.8 28.63 76.8 28.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "76.8 29.24 68.49 32.3 68.39 32.03 76.8 28.94 76.8 29.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "76.8 29.55 69.19 32.34 68.51 32.34 68.49 32.3 76.8 29.24 76.8 29.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "76.8 29.85 70.02 32.34 69.19 32.34 76.8 29.55 76.8 29.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "76.8 30.15 70.84 32.34 70.02 32.34 76.8 29.85 76.8 30.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "76.8 30.46 71.67 32.34 70.84 32.34 76.8 30.15 76.8 30.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "76.8 30.76 72.5 32.34 71.67 32.34 76.8 30.46 76.8 30.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "72.5 32.34 76.8 30.76 76.8 32.34 72.5 32.34"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 65.87,
    y: 7.88,
    width: 0.4,
    height: 9.83,
    transform: "translate(55.27 -53.63) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 66.12,
    y: 8.56,
    width: 0.4,
    height: 9.83,
    transform: "translate(56.07 -53.42) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 66.37,
    y: 9.23,
    width: 0.4,
    height: 9.83,
    transform: "translate(56.87 -53.21) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 66.62,
    y: 9.91,
    width: 0.4,
    height: 9.83,
    transform: "translate(57.67 -53) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 66.87,
    y: 10.59,
    width: 0.4,
    height: 9.83,
    transform: "translate(58.47 -52.79) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 67.12,
    y: 11.27,
    width: 0.4,
    height: 9.83,
    transform: "translate(59.27 -52.58) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 67.37,
    y: 11.94,
    width: 0.4,
    height: 9.83,
    transform: "translate(60.06 -52.37) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 67.62,
    y: 12.62,
    width: 0.4,
    height: 9.83,
    transform: "translate(60.86 -52.16) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 67.86,
    y: 13.3,
    width: 0.4,
    height: 9.83,
    transform: "translate(61.66 -51.95) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 68.11,
    y: 13.98,
    width: 0.4,
    height: 9.83,
    transform: "translate(62.46 -51.74) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 68.36,
    y: 14.65,
    width: 0.4,
    height: 9.83,
    transform: "translate(63.26 -51.54) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 68.61,
    y: 15.33,
    width: 0.4,
    height: 9.83,
    transform: "translate(64.06 -51.33) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 68.86,
    y: 16.01,
    width: 0.4,
    height: 9.83,
    transform: "translate(64.86 -51.12) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 69.11,
    y: 16.69,
    width: 0.4,
    height: 9.83,
    transform: "translate(65.66 -50.91) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 69.36,
    y: 17.36,
    width: 0.4,
    height: 9.83,
    transform: "translate(66.46 -50.7) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 69.61,
    y: 18.04,
    width: 0.4,
    height: 9.83,
    transform: "translate(67.26 -50.49) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 69.86,
    y: 18.72,
    width: 0.4,
    height: 9.83,
    transform: "translate(68.05 -50.28) rotate(69.81)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 70.11,
    y: 19.39,
    width: 0.4,
    height: 9.83,
    transform: "translate(68.85 -50.07) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 70.36,
    y: 20.07,
    width: 0.4,
    height: 9.83,
    transform: "translate(69.65 -49.86) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 70.6,
    y: 20.75,
    width: 0.4,
    height: 9.83,
    transform: "translate(70.45 -49.65) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 70.85,
    y: 21.43,
    width: 0.4,
    height: 9.83,
    transform: "translate(71.25 -49.44) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 71.1,
    y: 22.1,
    width: 0.4,
    height: 9.83,
    transform: "translate(72.05 -49.23) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 71.35,
    y: 22.78,
    width: 0.4,
    height: 9.83,
    transform: "translate(72.85 -49.02) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 71.6,
    y: 23.46,
    width: 0.4,
    height: 9.83,
    transform: "translate(73.65 -48.81) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 71.85,
    y: 24.14,
    width: 0.4,
    height: 9.83,
    transform: "translate(74.44 -48.6) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 72.1,
    y: 24.81,
    width: 0.4,
    height: 9.83,
    transform: "translate(75.24 -48.39) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 72.35,
    y: 25.49,
    width: 0.4,
    height: 9.83,
    transform: "translate(76.04 -48.18) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 72.6,
    y: 26.17,
    width: 0.4,
    height: 9.83,
    transform: "translate(76.84 -47.97) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 72.85,
    y: 26.85,
    width: 0.4,
    height: 9.83,
    transform: "translate(77.64 -47.76) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 73.1,
    y: 27.52,
    width: 0.4,
    height: 9.83,
    transform: "translate(78.44 -47.55) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 73.35,
    y: 28.2,
    width: 0.4,
    height: 9.83,
    transform: "translate(79.24 -47.34) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 73.59,
    y: 28.88,
    width: 0.4,
    height: 9.83,
    transform: "translate(80.04 -47.13) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 73.84,
    y: 29.56,
    width: 0.4,
    height: 9.83,
    transform: "translate(80.84 -46.92) rotate(69.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 74.09,
    y: 30.23,
    width: 0.4,
    height: 9.83,
    transform: "translate(81.64 -46.71) rotate(69.81)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "73.12 14.64 68.7 16.27 68.7 14.64 73.12 14.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "74.05 14.64 68.7 16.61 68.7 16.27 73.12 14.64 74.05 14.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "74.98 14.64 68.7 16.95 68.7 16.61 74.05 14.64 74.98 14.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "75.91 14.64 68.7 17.29 68.7 16.95 74.98 14.64 75.91 14.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "76.73 14.64 76.74 14.68 68.7 17.64 68.7 17.29 75.91 14.64 76.73 14.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "76.74 14.68 76.85 14.98 68.7 17.98 68.7 17.64 76.74 14.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "76.85 14.98 76.96 15.28 68.7 18.32 68.7 17.98 76.85 14.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "76.96 15.28 77.07 15.58 68.7 18.66 68.7 18.32 76.96 15.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "77.07 15.58 77.18 15.88 68.7 19 68.7 18.66 77.07 15.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.18 15.88 77.29 16.18 68.7 19.35 68.7 19 77.18 15.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "77.29 16.18 77.41 16.49 68.7 19.69 68.7 19.35 77.29 16.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "77.41 16.49 77.52 16.79 68.7 20.03 68.7 19.69 77.41 16.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "77.52 16.79 77.63 17.09 68.7 20.37 68.7 20.03 77.52 16.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "77.63 17.09 77.74 17.39 68.7 20.71 68.7 20.37 77.63 17.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "77.74 17.39 77.85 17.69 68.7 21.06 68.7 20.71 77.74 17.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "77.85 17.69 77.96 17.99 68.7 21.4 68.7 21.06 77.85 17.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "77.96 17.99 78.07 18.29 68.7 21.74 68.7 21.4 77.96 17.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "78.07 18.29 78.18 18.59 68.7 22.08 68.7 21.74 78.07 18.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "78.18 18.59 78.29 18.9 68.7 22.42 68.7 22.08 78.18 18.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "78.29 18.9 78.4 19.2 68.7 22.77 68.7 22.42 78.29 18.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "78.4 19.2 78.51 19.5 68.7 23.11 68.7 22.77 78.4 19.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "78.51 19.5 78.62 19.8 68.7 23.45 68.7 23.11 78.51 19.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "78.62 19.8 78.73 20.1 68.7 23.79 68.7 23.45 78.62 19.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "78.73 20.1 78.85 20.4 68.7 24.13 68.7 23.79 78.73 20.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.85 20.4 78.87 20.46 78.87 20.74 68.7 24.48 68.7 24.13 78.85 20.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "78.87 21.08 68.72 24.81 68.7 24.75 68.7 24.48 78.87 20.74 78.87 21.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "78.87 21.42 68.83 25.11 68.72 24.81 78.87 21.08 78.87 21.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "78.87 21.76 68.94 25.41 68.83 25.11 78.87 21.42 78.87 21.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "78.87 22.1 69.05 25.71 68.94 25.41 78.87 21.76 78.87 22.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "78.87 22.45 69.16 26.01 69.05 25.71 78.87 22.1 78.87 22.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "78.87 22.79 69.27 26.32 69.16 26.01 78.87 22.45 78.87 22.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "78.87 23.13 69.39 26.62 69.27 26.32 78.87 22.79 78.87 23.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "78.87 23.47 69.5 26.92 69.39 26.62 78.87 23.13 78.87 23.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "78.87 23.81 69.61 27.22 69.5 26.92 78.87 23.47 78.87 23.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "78.87 24.16 69.72 27.52 69.61 27.22 78.87 23.81 78.87 24.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "78.87 24.5 69.83 27.82 69.72 27.52 78.87 24.16 78.87 24.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "78.87 24.84 69.94 28.12 69.83 27.82 78.87 24.5 78.87 24.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "78.87 25.18 70.05 28.42 69.94 28.12 78.87 24.84 78.87 25.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "78.87 25.52 70.16 28.73 70.05 28.42 78.87 25.18 78.87 25.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "78.87 25.87 70.27 29.03 70.16 28.73 78.87 25.52 78.87 25.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "78.87 26.21 70.38 29.33 70.27 29.03 78.87 25.87 78.87 26.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "78.87 26.55 70.49 29.63 70.38 29.33 78.87 26.21 78.87 26.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "78.87 26.89 70.6 29.93 70.49 29.63 78.87 26.55 78.87 26.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "78.87 27.23 70.72 30.23 70.6 29.93 78.87 26.89 78.87 27.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "78.87 27.58 70.83 30.53 70.72 30.23 78.87 27.23 78.87 27.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "78.87 27.92 71.66 30.57 70.84 30.57 70.83 30.53 78.87 27.58 78.87 27.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "78.87 28.26 72.59 30.57 71.66 30.57 78.87 27.92 78.87 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "78.87 28.6 73.52 30.57 72.59 30.57 78.87 28.26 78.87 28.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "78.87 28.94 74.45 30.57 73.52 30.57 78.87 28.6 78.87 28.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "74.45 30.57 78.87 28.94 78.87 30.57 74.45 30.57"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "70.08 16.25 69.77 16.36 69.77 16.25 70.08 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "71.13 16.25 69.77 16.74 69.77 16.36 70.08 16.25 71.13 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "72.18 16.25 69.77 17.13 69.77 16.74 71.13 16.25 72.18 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "73.23 16.25 69.77 17.52 69.77 17.13 72.18 16.25 73.23 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "74.28 16.25 69.77 17.9 69.77 17.52 73.23 16.25 74.28 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "75.33 16.25 69.77 18.29 69.77 17.9 74.28 16.25 75.33 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "76.26 16.25 76.27 16.29 69.77 18.67 69.77 18.29 75.33 16.25 76.26 16.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "76.27 16.29 76.4 16.63 69.77 19.06 69.77 18.67 76.27 16.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "76.4 16.63 76.52 16.97 69.77 19.45 69.77 19.06 76.4 16.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "76.52 16.97 76.65 17.31 69.77 19.83 69.77 19.45 76.52 16.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "76.65 17.31 76.77 17.65 69.77 20.22 69.77 19.83 76.65 17.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "76.77 17.65 76.9 17.99 69.77 20.61 69.77 20.22 76.77 17.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "76.9 17.99 77.02 18.33 69.77 20.99 69.77 20.61 76.9 17.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "77.02 18.33 77.15 18.67 69.77 21.38 69.77 20.99 77.02 18.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "77.15 18.67 77.27 19.01 69.77 21.76 69.77 21.38 77.15 18.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "77.27 19.01 77.4 19.35 69.77 22.15 69.77 21.76 77.27 19.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "77.4 19.35 77.52 19.69 69.77 22.54 69.77 22.15 77.4 19.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "77.52 19.69 77.65 20.03 69.77 22.92 69.77 22.54 77.52 19.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "77.65 20.03 77.77 20.37 69.77 23.31 69.77 22.92 77.65 20.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "77.77 20.37 77.79 20.41 77.79 20.75 69.77 23.69 69.77 23.31 77.77 20.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "77.79 21.13 69.77 24.08 69.77 23.69 77.79 20.75 77.79 21.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "77.79 21.52 69.77 24.47 69.77 24.08 77.79 21.13 77.79 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "77.79 21.9 69.79 24.85 69.77 24.8 69.77 24.47 77.79 21.52 77.79 21.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "77.79 22.29 69.92 25.19 69.79 24.85 77.79 21.9 77.79 22.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "77.79 22.68 70.04 25.53 69.92 25.19 77.79 22.29 77.79 22.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "77.79 23.06 70.17 25.87 70.04 25.53 77.79 22.68 77.79 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "77.79 23.45 70.29 26.21 70.17 25.87 77.79 23.06 77.79 23.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "77.79 23.83 70.42 26.55 70.29 26.21 77.79 23.45 77.79 23.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "77.79 24.22 70.54 26.89 70.42 26.55 77.79 23.83 77.79 24.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "77.79 24.61 70.67 27.23 70.54 26.89 77.79 24.22 77.79 24.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "77.79 24.99 70.79 27.57 70.67 27.23 77.79 24.61 77.79 24.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "77.79 25.38 70.92 27.91 70.79 27.57 77.79 24.99 77.79 25.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "77.79 25.77 71.04 28.25 70.92 27.91 77.79 25.38 77.79 25.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "77.79 26.15 71.17 28.59 71.04 28.25 77.79 25.77 77.79 26.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "77.79 26.54 71.29 28.93 71.17 28.59 77.79 26.15 77.79 26.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "77.79 26.92 71.83 29.12 71.36 29.12 71.29 28.93 77.79 26.54 77.79 26.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.79 27.31 72.88 29.12 71.83 29.12 77.79 26.92 77.79 27.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "77.79 27.7 73.93 29.12 72.88 29.12 77.79 27.31 77.79 27.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "77.79 28.08 74.98 29.12 73.93 29.12 77.79 27.7 77.79 28.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "77.79 28.47 76.03 29.12 74.98 29.12 77.79 28.08 77.79 28.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "77.79 28.85 77.07 29.12 76.03 29.12 77.79 28.47 77.79 28.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "77.07 29.12 77.79 28.85 77.79 29.12 77.07 29.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "73.38 13.49 67.52 15.64 67.52 13.49 73.38 13.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "74.43 13.49 67.52 16.03 67.52 15.64 73.38 13.49 74.43 13.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "75.48 13.49 67.52 16.41 67.52 16.03 74.43 13.49 75.48 13.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "76.53 13.49 67.52 16.8 67.52 16.41 75.48 13.49 76.53 13.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "77.36 13.49 77.39 13.56 67.52 17.19 67.52 16.8 76.53 13.49 77.36 13.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "77.39 13.56 77.51 13.9 67.52 17.57 67.52 17.19 77.39 13.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "77.51 13.9 77.64 14.24 67.52 17.96 67.52 17.57 77.51 13.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "77.64 14.24 77.76 14.58 67.52 18.34 67.52 17.96 77.64 14.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "77.76 14.58 77.89 14.92 67.52 18.73 67.52 18.34 77.76 14.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "77.89 14.92 78.01 15.26 67.52 19.12 67.52 18.73 77.89 14.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "78.01 15.26 78.14 15.6 67.52 19.5 67.52 19.12 78.01 15.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "78.14 15.6 78.26 15.94 67.52 19.89 67.52 19.5 78.14 15.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "78.26 15.94 78.39 16.28 67.52 20.27 67.52 19.89 78.26 15.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "78.39 16.28 78.51 16.62 67.52 20.66 67.52 20.27 78.39 16.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "78.51 16.62 78.64 16.96 67.52 21.05 67.52 20.66 78.51 16.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "78.64 16.96 78.76 17.3 67.52 21.43 67.52 21.05 78.64 16.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "78.76 17.3 78.89 17.64 67.52 21.82 67.52 21.43 78.76 17.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "78.89 17.64 79.01 17.98 67.52 22.2 67.52 21.82 78.89 17.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "79.01 17.98 79.14 18.32 67.52 22.59 67.52 22.2 79.01 17.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "79.14 18.32 79.26 18.66 67.52 22.98 67.52 22.59 79.14 18.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "79.26 18.66 79.39 19 67.52 23.36 67.52 22.98 79.26 18.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "79.39 19 79.51 19.34 67.52 23.75 67.52 23.36 79.39 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "79.51 19.34 79.64 19.68 67.52 24.14 67.52 23.75 79.51 19.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "79.64 19.68 79.76 20.02 67.55 24.51 67.52 24.44 67.52 24.14 79.64 19.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 67.22,
    y: 22.25,
    width: 13.01,
    height: 0.36,
    transform: "translate(-3.21 26.82) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 67.34,
    y: 22.59,
    width: 13.01,
    height: 0.36,
    transform: "translate(-3.32 26.89) rotate(-20.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "80.01 20.7 80.04 20.78 80.04 21.08 67.93 25.53 67.8 25.19 80.01 20.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "80.04 21.46 68.05 25.87 67.93 25.53 80.04 21.08 80.04 21.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "80.04 21.85 68.18 26.21 68.05 25.87 80.04 21.46 80.04 21.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "80.04 22.23 68.3 26.55 68.18 26.21 80.04 21.85 80.04 22.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "80.04 22.62 68.43 26.89 68.3 26.55 80.04 22.23 80.04 22.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "80.04 23.01 68.55 27.23 68.43 26.89 80.04 22.62 80.04 23.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "80.04 23.39 68.68 27.57 68.55 27.23 80.04 23.01 80.04 23.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "80.04 23.78 68.8 27.91 68.68 27.57 80.04 23.39 80.04 23.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "80.04 24.17 68.93 28.25 68.8 27.91 80.04 23.78 80.04 24.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "80.04 24.55 69.05 28.59 68.93 28.25 80.04 24.17 80.04 24.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "80.04 24.94 69.18 28.93 69.05 28.59 80.04 24.55 80.04 24.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "80.04 25.32 69.3 29.27 69.18 28.93 80.04 24.94 80.04 25.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "80.04 25.71 69.43 29.61 69.3 29.27 80.04 25.32 80.04 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "80.04 26.1 69.55 29.95 69.43 29.61 80.04 25.71 80.04 26.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "80.04 26.48 69.68 30.29 69.55 29.95 80.04 26.1 80.04 26.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "80.04 26.87 69.8 30.63 69.68 30.29 80.04 26.48 80.04 26.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "80.04 27.25 69.98 30.95 69.92 30.95 69.8 30.63 80.04 26.87 80.04 27.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "80.04 27.64 71.03 30.95 69.98 30.95 80.04 27.25 80.04 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "80.04 28.03 72.08 30.95 71.03 30.95 80.04 27.64 80.04 28.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "80.04 28.41 73.13 30.95 72.08 30.95 80.04 28.03 80.04 28.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "80.04 28.8 74.18 30.95 73.13 30.95 80.04 28.41 80.04 28.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "80.04 29.18 75.23 30.95 74.18 30.95 80.04 28.8 80.04 29.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "80.04 29.57 76.28 30.95 75.23 30.95 80.04 29.18 80.04 29.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "76.28 30.95 80.04 29.57 80.04 30.95 76.28 30.95"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m73.29,25.63c.07-.12.13-.24.2-.37.06-.11.05-.22-.05-.4-.12-.24-.24-.46-.35-.68-.22-.45-.39-.91-.49-1.41-.12-.61-.02-.99.18-1.28l.58,1.57c.05.12.13.21.19.18l.25-.09c.06-.02.07-.14.03-.26l-.63-1.71.2-.07.63,1.71c.05.12.13.21.19.18l.25-.09c.06-.02.07-.14.03-.26l-.55-1.5h0c.27.1.53.31.77.7.29.47.47.98.61,1.52.07.25.12.5.18.76.04.19.11.28.22.33.13.05.26.1.38.14.12.04.17-.02.15-.22,0-.05-.01-.1-.02-.15-.13-.78-.34-1.54-.69-2.29-.24-.52-.52-1-.85-1.37-.41-.47-.83-.73-1.23-.82h-.05s-.28-.78-.28-.78c-.05-.12-.13-.21-.19-.18l-.25.09c-.06.02-.07.14-.03.26l.22.6-.2.07-.22-.6c-.05-.12-.13-.21-.19-.18l-.25.09c-.06.02-.07.14-.03.26l.27.73c-.07.09-.14.17-.21.27-.31.53-.4,1.28-.21,2.26.16.82.45,1.6.84,2.33.1.19.21.38.32.55.12.2.21.21.28.11h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-302"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "83.46 -8.89 83.85 -7.5 56.14 .33 56.14 -1.17 83.46 -8.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "83.85 -7.5 84.25 -6.12 56.14 1.83 56.14 .33 83.85 -7.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "84.25 -6.12 84.64 -4.73 56.14 3.33 56.14 1.83 84.25 -6.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "84.64 -4.73 85.03 -3.34 56.14 4.83 56.14 3.33 84.64 -4.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "85.03 -3.34 85.42 -1.95 56.14 6.33 56.14 4.83 85.03 -3.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "85.42 -1.95 85.82 -.56 56.14 7.83 56.14 6.33 85.42 -1.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "85.82 -.56 86.21 .83 56.14 9.33 56.14 7.83 85.82 -.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "86.21 .83 86.6 2.21 56.14 10.83 56.14 9.33 86.21 .83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "86.6 2.21 87 3.6 56.14 12.33 56.14 10.83 86.6 2.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "87 3.6 87.39 4.99 56.36 13.76 56.14 12.99 56.14 12.33 87 3.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 55.95,
    y: 9.35,
    width: 32.24,
    height: 1.44,
    transform: "translate(-.02 19.99) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 56.34,
    y: 10.74,
    width: 32.24,
    height: 1.44,
    transform: "translate(-.38 20.15) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 56.73,
    y: 12.13,
    width: 32.24,
    height: 1.44,
    transform: "translate(-.75 20.31) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 57.13,
    y: 13.51,
    width: 32.24,
    height: 1.44,
    transform: "translate(-1.11 20.47) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 57.52,
    y: 14.9,
    width: 32.24,
    height: 1.44,
    transform: "translate(-1.47 20.63) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 57.91,
    y: 16.29,
    width: 32.24,
    height: 1.44,
    transform: "translate(-1.84 20.79) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.31,
    y: 17.68,
    width: 32.24,
    height: 1.44,
    transform: "translate(-2.2 20.95) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 58.7,
    y: 19.07,
    width: 32.24,
    height: 1.44,
    transform: "translate(-2.56 21.11) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 59.09,
    y: 20.46,
    width: 32.24,
    height: 1.44,
    transform: "translate(-2.92 21.27) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 59.48,
    y: 21.84,
    width: 32.24,
    height: 1.44,
    transform: "translate(-3.29 21.43) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 59.88,
    y: 23.23,
    width: 32.24,
    height: 1.44,
    transform: "translate(-3.65 21.59) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 60.27,
    y: 24.62,
    width: 32.24,
    height: 1.44,
    transform: "translate(-4.01 21.75) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "92.1 21.65 92.11 21.68 92.11 23.15 61.47 31.81 61.07 30.42 92.1 21.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "92.11 24.65 61.86 33.2 61.47 31.81 92.11 23.15 92.11 24.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "92.11 26.15 62.25 34.59 61.86 33.2 92.11 24.65 92.11 26.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "92.11 27.64 62.64 35.98 62.25 34.59 92.11 26.15 92.11 27.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "92.11 29.14 63.04 37.37 62.64 35.98 92.11 27.64 92.11 29.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "92.11 30.64 63.43 38.75 63.04 37.37 92.11 29.14 92.11 30.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "92.11 32.14 63.82 40.14 63.43 38.75 92.11 30.64 92.11 32.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "92.11 33.64 64.21 41.53 63.82 40.14 92.11 32.14 92.11 33.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "92.11 35.14 64.61 42.92 64.21 41.53 92.11 33.64 92.11 35.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "92.11 36.64 65 44.31 64.61 42.92 92.11 35.14 92.11 36.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "92.11 38.14 65.39 45.7 65 44.31 92.11 36.64 92.11 38.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "92.11 39.64 65.78 47.08 65.39 45.7 92.11 38.14 92.11 39.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "92.11 41.14 66.18 48.47 65.78 47.08 92.11 39.64 92.11 41.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "92.11 42.64 66.57 49.86 66.18 48.47 92.11 41.14 92.11 42.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "92.11 44.14 66.96 51.25 66.57 49.86 92.11 42.64 92.11 44.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "92.11 45.64 67.36 52.64 66.96 51.25 92.11 44.14 92.11 45.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "92.11 47.14 67.75 54.02 67.36 52.64 92.11 45.64 92.11 47.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "92.11 48.63 68.14 55.41 67.75 54.02 92.11 47.14 92.11 48.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "92.11 50.13 71.75 55.89 68.28 55.89 68.14 55.41 92.11 48.63 92.11 50.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "71.75 55.89 92.11 50.13 92.11 55.89 71.75 55.89"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "76.37 -5.14 57.96 .06 57.96 -1.24 71.77 -5.14 76.37 -5.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "78.53 -5.14 78.71 -4.5 57.96 1.37 57.96 .06 76.37 -5.14 78.53 -5.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "78.71 -4.5 79.05 -3.3 57.96 2.67 57.96 1.37 78.71 -4.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "79.05 -3.3 79.39 -2.09 57.96 3.97 57.96 2.67 79.05 -3.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "79.39 -2.09 79.73 -.89 57.96 5.27 57.96 3.97 79.39 -2.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.73 -.89 80.08 .32 57.96 6.57 57.96 5.27 79.73 -.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "80.08 .32 80.42 1.52 57.96 7.87 57.96 6.57 80.08 .32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "80.42 1.52 80.76 2.73 57.96 9.18 57.96 7.87 80.42 1.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "80.76 2.73 81.1 3.93 57.96 10.48 57.96 9.18 80.76 2.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "81.1 3.93 81.44 5.14 57.96 11.78 57.96 10.48 81.1 3.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "81.44 5.14 81.78 6.35 57.96 13.08 57.96 11.78 81.44 5.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "81.78 6.35 82.12 7.55 57.96 14.38 57.96 13.08 81.78 6.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "82.12 7.55 82.46 8.76 58.28 15.6 57.96 14.46 57.96 14.38 82.12 7.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 57.98,
    y: 12.15,
    width: 25.13,
    height: 1.25,
    transform: "translate(-.82 19.68) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 58.32,
    y: 13.36,
    width: 25.13,
    height: 1.25,
    transform: "translate(-1.13 19.82) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 58.66,
    y: 14.56,
    width: 25.13,
    height: 1.25,
    transform: "translate(-1.45 19.96) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 59,
    y: 15.77,
    width: 25.13,
    height: 1.25,
    transform: "translate(-1.76 20.09) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 59.34,
    y: 16.97,
    width: 25.13,
    height: 1.25,
    transform: "translate(-2.08 20.23) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 59.68,
    y: 18.18,
    width: 25.13,
    height: 1.25,
    transform: "translate(-2.39 20.37) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 60.02,
    y: 19.39,
    width: 25.13,
    height: 1.25,
    transform: "translate(-2.71 20.51) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.36,
    y: 20.59,
    width: 25.13,
    height: 1.25,
    transform: "translate(-3.02 20.65) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 60.71,
    y: 21.8,
    width: 25.13,
    height: 1.25,
    transform: "translate(-3.34 20.79) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 61.05,
    y: 23,
    width: 25.13,
    height: 1.25,
    transform: "translate(-3.65 20.92) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 61.39,
    y: 24.21,
    width: 25.13,
    height: 1.25,
    transform: "translate(-3.97 21.06) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 61.73,
    y: 25.41,
    width: 25.13,
    height: 1.25,
    transform: "translate(-4.28 21.2) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "86.55 23.22 86.63 23.48 86.63 24.5 62.71 31.27 62.37 30.06 86.55 23.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "86.63 25.81 63.05 32.47 62.71 31.27 86.63 24.5 86.63 25.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "86.63 27.11 63.4 33.68 63.05 32.47 86.63 25.81 86.63 27.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "86.63 28.41 63.74 34.88 63.4 33.68 86.63 27.11 86.63 28.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "86.63 29.71 64.08 36.09 63.74 34.88 86.63 28.41 86.63 29.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "86.63 31.01 64.42 37.29 64.08 36.09 86.63 29.71 86.63 31.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "86.63 32.32 64.76 38.5 64.42 37.29 86.63 31.01 86.63 32.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "86.63 33.62 65.1 39.71 64.76 38.5 86.63 32.32 86.63 33.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "86.63 34.92 65.44 40.91 65.1 39.71 86.63 33.62 86.63 34.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "86.63 36.22 65.78 42.12 65.44 40.91 86.63 34.92 86.63 36.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "86.63 37.52 66.12 43.32 65.78 42.12 86.63 36.22 86.63 37.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "86.63 38.82 66.46 44.53 66.12 43.32 86.63 37.52 86.63 38.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "86.63 40.13 66.81 45.73 66.46 44.53 86.63 38.82 86.63 40.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "86.63 41.43 67.15 46.94 66.81 45.73 86.63 40.13 86.63 41.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.63 42.73 67.49 48.14 67.15 46.94 86.63 41.43 86.63 42.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "86.63 44.03 67.83 49.35 67.49 48.14 86.63 42.73 86.63 44.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "86.63 45.33 68.17 50.55 67.83 49.35 86.63 44.03 86.63 45.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "86.63 46.64 68.51 51.76 68.17 50.55 86.63 45.33 86.63 46.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "86.63 47.94 68.85 52.97 68.51 51.76 86.63 46.64 86.63 47.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "86.63 49.24 72.2 53.32 68.95 53.32 68.85 52.97 86.63 47.94 86.63 49.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "72.2 53.32 86.63 49.24 86.63 53.32 72.2 53.32"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "64.14 7.04 60.7 8.02 60.7 7.04 64.14 7.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "67.59 7.04 60.7 8.99 60.7 8.02 64.14 7.04 67.59 7.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "71.04 7.04 60.7 9.97 60.7 8.99 67.59 7.04 71.04 7.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "74.48 7.04 60.7 10.94 60.7 9.97 71.04 7.04 74.48 7.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "76.53 7.04 76.63 7.41 60.7 11.92 60.7 10.94 74.48 7.04 76.53 7.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "76.63 7.41 76.89 8.31 60.7 12.89 60.7 11.92 76.63 7.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "76.89 8.31 77.14 9.21 60.7 13.87 60.7 12.89 76.89 8.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "77.14 9.21 77.4 10.12 60.7 14.84 60.7 13.87 77.14 9.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.4 10.12 77.66 11.02 60.7 15.81 60.7 14.84 77.4 10.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "77.66 11.02 77.91 11.92 60.7 16.79 60.7 15.81 77.66 11.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "77.91 11.92 78.17 12.82 60.7 17.76 60.7 16.79 77.91 11.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "78.17 12.82 78.42 13.73 60.7 18.74 60.7 17.76 78.17 12.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "78.42 13.73 78.68 14.63 60.7 19.71 60.7 18.74 78.42 13.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "78.68 14.63 78.93 15.53 60.7 20.69 60.7 19.71 78.68 14.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "78.93 15.53 79.19 16.43 60.7 21.66 60.7 20.69 78.93 15.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "79.19 16.43 79.44 17.34 60.7 22.64 60.7 21.66 79.19 16.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "79.44 17.34 79.7 18.24 60.79 23.58 60.7 23.25 60.7 22.64 79.44 17.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 60.55,
    y: 20.89,
    width: 19.65,
    height: 0.94,
    transform: "translate(-3.16 19.96) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 60.8,
    y: 21.8,
    width: 19.65,
    height: 0.94,
    transform: "translate(-3.39 20.06) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 61.06,
    y: 22.7,
    width: 19.65,
    height: 0.94,
    transform: "translate(-3.63 20.16) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 61.32,
    y: 23.6,
    width: 19.65,
    height: 0.94,
    transform: "translate(-3.87 20.27) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 61.57,
    y: 24.5,
    width: 19.65,
    height: 0.94,
    transform: "translate(-4.1 20.37) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 61.83,
    y: 25.41,
    width: 19.65,
    height: 0.94,
    transform: "translate(-4.34 20.48) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.08,
    y: 26.31,
    width: 19.65,
    height: 0.94,
    transform: "translate(-4.57 20.58) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 62.34,
    y: 27.21,
    width: 19.65,
    height: 0.94,
    transform: "translate(-4.81 20.68) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 62.59,
    y: 28.11,
    width: 19.65,
    height: 0.94,
    transform: "translate(-5.05 20.79) rotate(-15.79)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "81.99 26.36 82.16 26.94 82.16 27.29 63.34 32.61 63.09 31.71 81.99 26.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "82.16 28.26 63.6 33.51 63.34 32.61 82.16 27.29 82.16 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "82.16 29.24 63.86 34.41 63.6 33.51 82.16 28.26 82.16 29.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "82.16 30.21 64.11 35.32 63.86 34.41 82.16 29.24 82.16 30.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "82.16 31.19 64.37 36.22 64.11 35.32 82.16 30.21 82.16 31.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "82.16 32.16 64.62 37.12 64.37 36.22 82.16 31.19 82.16 32.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "82.16 33.14 64.88 38.02 64.62 37.12 82.16 32.16 82.16 33.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "82.16 34.11 65.13 38.93 64.88 38.02 82.16 33.14 82.16 34.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "82.16 35.09 65.39 39.83 65.13 38.93 82.16 34.11 82.16 35.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "82.16 36.06 65.64 40.73 65.39 39.83 82.16 35.09 82.16 36.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "82.16 37.03 65.9 41.63 65.64 40.73 82.16 36.06 82.16 37.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "82.16 38.01 66.15 42.54 65.9 41.63 82.16 37.03 82.16 38.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "82.16 38.98 66.41 43.44 66.15 42.54 82.16 38.01 82.16 38.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "82.16 39.96 66.66 44.34 66.41 43.44 82.16 38.98 82.16 39.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "82.16 40.93 66.92 45.24 66.66 44.34 82.16 39.96 82.16 40.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "82.16 41.91 67.17 46.15 66.92 45.24 82.16 40.93 82.16 41.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "82.16 42.88 67.43 47.05 67.17 46.15 82.16 41.91 82.16 42.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "82.16 43.86 67.68 47.95 67.43 47.05 82.16 42.88 82.16 43.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "82.16 44.83 67.94 48.85 67.68 47.95 82.16 43.86 82.16 44.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "82.16 45.81 68.19 49.76 67.94 48.85 82.16 44.83 82.16 45.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "82.16 46.78 68.45 50.66 68.19 49.76 82.16 45.81 82.16 46.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "82.16 47.76 71.36 50.81 68.49 50.81 68.45 50.66 82.16 46.78 82.16 47.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "71.36 50.81 82.16 47.76 82.16 50.81 71.36 50.81"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "3.27 57.22 -2.06 64.75 -2.06 57.22 3.27 57.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "4 57.22 -2.06 65.78 -2.06 64.75 3.27 57.22 4 57.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "4.73 57.22 -2.06 66.8 -2.06 65.78 4 57.22 4.73 57.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "5.46 57.22 -2.06 67.83 -2.06 66.8 4.73 57.22 5.46 57.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "6.14 57.22 6.17 57.24 -2.06 68.86 -2.06 67.83 5.46 57.22 6.14 57.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "6.17 57.24 6.65 57.58 -2.06 69.88 -2.06 68.86 6.17 57.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "6.65 57.58 7.14 57.92 -2.06 70.91 -2.06 69.88 6.65 57.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "7.14 57.92 7.62 58.27 -2.06 71.94 -2.06 70.91 7.14 57.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "7.62 58.27 8.11 58.61 -2.06 72.96 -2.06 71.94 7.62 58.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "8.11 58.61 8.59 58.95 -2.06 73.99 -2.06 72.96 8.11 58.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "8.59 58.95 9.08 59.3 -1.74 74.56 -2.06 74.33 -2.06 73.99 8.59 58.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: -5.44,
    y: 66.8,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.1 31.51) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: -4.96,
    y: 67.15,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.18 32.05) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -4.47,
    y: 67.49,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.25 32.59) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: -3.99,
    y: 67.83,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.33 33.13) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: -3.5,
    y: 68.18,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.41 33.67) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: -3.02,
    y: 68.52,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.48 34.21) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: -2.54,
    y: 68.86,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.56 34.75) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -2.05,
    y: 69.2,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.63 35.29) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: -1.57,
    y: 69.55,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.71 35.83) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: -1.08,
    y: 69.89,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.78 36.37) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: -0.6,
    y: 70.23,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.86 36.91) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: -0.11,
    y: 70.58,
    width: 18.71,
    height: 0.59,
    transform: "translate(-53.94 37.45) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 0.37,
    y: 70.92,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.01 37.99) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 0.85,
    y: 71.26,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.09 38.53) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 1.34,
    y: 71.61,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.16 39.07) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1.82,
    y: 71.95,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.24 39.61) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2.31,
    y: 72.29,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.31 40.15) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2.79,
    y: 72.64,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.39 40.69) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 3.28,
    y: 72.98,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.46 41.23) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 3.76,
    y: 73.32,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.54 41.77) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 4.24,
    y: 73.66,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.62 42.31) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 4.73,
    y: 74.01,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.69 42.85) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 5.21,
    y: 74.35,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.77 43.39) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 5.7,
    y: 74.69,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.84 43.93) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 6.18,
    y: 75.04,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.92 44.47) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 6.67,
    y: 75.38,
    width: 18.71,
    height: 0.59,
    transform: "translate(-54.99 45.01) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 7.15,
    y: 75.72,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.07 45.55) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 7.64,
    y: 76.07,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.14 46.09) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 8.12,
    y: 76.41,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.22 46.63) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 8.6,
    y: 76.75,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.3 47.17) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 9.09,
    y: 77.1,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.37 47.71) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 9.57,
    y: 77.44,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.45 48.25) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 10.06,
    y: 77.78,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.52 48.79) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 10.54,
    y: 78.12,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.6 49.33) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 11.03,
    y: 78.47,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.67 49.87) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 11.51,
    y: 78.81,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.75 50.41) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 11.99,
    y: 79.15,
    width: 18.71,
    height: 0.59,
    transform: "translate(-55.82 50.95) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "27 71.99 27.48 72.33 16.76 87.47 16.49 87.47 16.18 87.25 27 71.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "27.48 72.33 27.96 72.68 17.48 87.47 16.76 87.47 27.48 72.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "27.96 72.68 28.45 73.02 18.21 87.47 17.48 87.47 27.96 72.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "28.45 73.02 28.93 73.36 18.94 87.47 18.21 87.47 28.45 73.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "28.93 73.36 29.42 73.71 19.67 87.47 18.94 87.47 28.93 73.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "29.42 73.71 29.9 74.05 20.39 87.47 19.67 87.47 29.42 73.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "29.9 74.05 30.39 74.39 21.12 87.47 20.39 87.47 29.9 74.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "30.39 74.39 30.87 74.73 21.85 87.47 21.12 87.47 30.39 74.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "30.87 74.73 31.36 75.08 22.58 87.47 21.85 87.47 30.87 74.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "31.36 75.08 31.83 75.41 31.83 75.43 23.3 87.47 22.58 87.47 31.36 75.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "31.83 76.46 24.03 87.47 23.3 87.47 31.83 75.43 31.83 76.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "31.83 77.49 24.76 87.47 24.03 87.47 31.83 76.46 31.83 77.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "31.83 78.52 25.49 87.47 24.76 87.47 31.83 77.49 31.83 78.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "31.83 79.54 26.21 87.47 25.49 87.47 31.83 78.52 31.83 79.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "26.21 87.47 31.83 79.54 31.83 87.47 26.21 87.47"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-10.65 70.07 -11.3 69.57 .13 51.99 .78 52.49 -10.65 70.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-9.46 70.99 -10.11 70.48 1.31 52.9 1.97 53.41 -9.46 70.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-8.28 71.9 -8.93 71.4 2.5 53.82 3.15 54.32 -8.28 71.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-7.09 72.82 -7.74 72.31 3.68 54.73 4.34 55.24 -7.09 72.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-5.91 73.73 -6.56 73.23 4.87 55.65 5.52 56.15 -5.91 73.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-4.72 74.65 -5.37 74.14 6.05 56.56 6.71 57.07 -4.72 74.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-3.54 75.56 -4.19 75.06 7.24 57.48 7.89 57.98 -3.54 75.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-2.35 76.48 -3 75.97 8.43 58.39 9.08 58.9 -2.35 76.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-1.16 77.39 -1.82 76.89 9.61 59.31 10.26 59.81 -1.16 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: ".02 78.31 -.63 77.8 10.8 60.22 11.45 60.73 .02 78.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "1.21 79.22 .55 78.72 11.98 61.14 12.63 61.64 1.21 79.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "2.39 80.14 1.74 79.63 13.17 62.05 13.82 62.56 2.39 80.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "3.58 81.05 2.92 80.55 14.35 62.97 15 63.47 3.58 81.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "4.76 81.97 4.11 81.46 15.54 63.88 16.19 64.39 4.76 81.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "5.95 82.88 5.29 82.38 16.72 64.8 17.37 65.3 5.95 82.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "7.13 83.8 6.48 83.29 17.91 65.71 18.56 66.22 7.13 83.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "8.31 84.71 7.66 84.21 19.09 66.62 19.74 67.13 8.31 84.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "9.5 85.62 8.85 85.12 20.27 67.54 20.93 68.04 9.5 85.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "10.68 86.54 10.03 86.03 21.46 68.45 22.11 68.96 10.68 86.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "11.87 87.45 11.22 86.95 22.64 69.37 23.3 69.87 11.87 87.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "13.05 88.37 12.4 87.86 23.83 70.28 24.48 70.79 13.05 88.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "14.24 89.28 13.59 88.78 25.01 71.2 25.67 71.7 14.24 89.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "15.42 90.2 14.77 89.69 26.2 72.11 26.85 72.62 15.42 90.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "16.61 91.11 15.96 90.61 27.39 73.03 28.04 73.53 16.61 91.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "17.8 92.03 17.14 91.52 28.57 73.94 29.22 74.45 17.8 92.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "18.98 92.94 18.33 92.44 29.76 74.86 30.41 75.36 18.98 92.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "20.17 93.86 19.51 93.35 30.94 75.77 31.59 76.28 20.17 93.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "21.35 94.77 20.7 94.27 32.13 76.69 32.78 77.19 21.35 94.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "22.54 95.69 21.88 95.18 33.31 77.6 33.96 78.11 22.54 95.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "23.72 96.6 23.07 96.1 34.5 78.52 35.15 79.02 23.72 96.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "24.91 97.52 24.25 97.01 35.68 79.43 36.33 79.94 24.91 97.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "26.09 98.43 25.44 97.93 36.87 80.35 37.52 80.85 26.09 98.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "27.28 99.35 26.63 98.84 38.05 81.26 38.7 81.77 27.28 99.35"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "7.58 54.7 2.41 62 2.41 54.7 7.58 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "8.39 54.7 2.41 63.15 2.41 62 7.58 54.7 8.39 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "9.21 54.7 2.41 64.3 2.41 63.15 8.39 54.7 9.21 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "10.02 54.7 2.41 65.45 2.41 64.3 9.21 54.7 10.02 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "10.84 54.7 2.41 66.6 2.41 65.45 10.02 54.7 10.84 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "11.65 54.7 2.41 67.75 2.41 66.6 10.84 54.7 11.65 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "12.47 54.7 2.41 68.9 2.41 67.75 11.65 54.7 12.47 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "13.28 54.7 2.41 70.05 2.41 68.9 12.47 54.7 13.28 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "14.1 54.7 2.93 70.47 2.41 70.11 2.41 70.05 13.28 54.7 14.1 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14.91 54.7 3.47 70.86 2.93 70.47 14.1 54.7 14.91 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "15.73 54.7 4.01 71.24 3.47 70.86 14.91 54.7 15.73 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "16.08 54.7 16.39 54.92 4.56 71.63 4.01 71.24 15.73 54.7 16.08 54.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 0.51,
    y: 63.13,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.26 35.55) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 1.05,
    y: 63.52,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.34 36.15) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 1.6,
    y: 63.9,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.43 36.76) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2.14,
    y: 64.29,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.51 37.37) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 2.68,
    y: 64.67,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.59 37.97) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 3.22,
    y: 65.06,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.68 38.58) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 3.77,
    y: 65.44,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.76 39.18) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 4.31,
    y: 65.83,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.85 39.79) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 4.85,
    y: 66.21,
    width: 20.47,
    height: 0.67,
    transform: "translate(-47.93 40.39) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 5.4,
    y: 66.6,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.02 41) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 5.94,
    y: 66.98,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.1 41.6) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 6.48,
    y: 67.36,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.19 42.21) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7.02,
    y: 67.75,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.27 42.81) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 7.57,
    y: 68.13,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.36 43.42) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 8.11,
    y: 68.52,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.44 44.02) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 8.65,
    y: 68.9,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.53 44.63) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 9.2,
    y: 69.29,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.61 45.23) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 9.74,
    y: 69.67,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.7 45.84) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 10.28,
    y: 70.06,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.78 46.44) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 10.82,
    y: 70.44,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.87 47.05) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 11.37,
    y: 70.83,
    width: 20.47,
    height: 0.67,
    transform: "translate(-48.95 47.66) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 11.91,
    y: 71.21,
    width: 20.47,
    height: 0.67,
    transform: "translate(-49.04 48.26) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 12.45,
    y: 71.59,
    width: 20.47,
    height: 0.67,
    transform: "translate(-49.12 48.87) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 13,
    y: 71.98,
    width: 20.47,
    height: 0.67,
    transform: "translate(-49.2 49.47) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 13.54,
    y: 72.36,
    width: 20.47,
    height: 0.67,
    transform: "translate(-49.29 50.08) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 14.08,
    y: 72.75,
    width: 20.47,
    height: 0.67,
    transform: "translate(-49.37 50.68) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "30.51 64.92 31.05 65.31 19.33 81.84 18.98 81.84 18.67 81.63 30.51 64.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "31.05 65.31 31.59 65.69 20.15 81.84 19.33 81.84 31.05 65.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "31.59 65.69 32.13 66.07 20.96 81.84 20.15 81.84 31.59 65.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "32.13 66.07 32.65 66.44 32.65 66.49 21.78 81.84 20.96 81.84 32.13 66.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "32.65 67.64 22.6 81.84 21.78 81.84 32.65 66.49 32.65 67.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "32.65 68.8 23.41 81.84 22.6 81.84 32.65 67.64 32.65 68.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "32.65 69.95 24.23 81.84 23.41 81.84 32.65 68.8 32.65 69.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "32.65 71.1 25.04 81.84 24.23 81.84 32.65 69.95 32.65 71.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "32.65 72.25 25.86 81.84 25.04 81.84 32.65 71.1 32.65 72.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "32.65 73.4 26.67 81.84 25.86 81.84 32.65 72.25 32.65 73.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "32.65 74.55 27.49 81.84 26.67 81.84 32.65 73.4 32.65 74.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "27.49 81.84 32.65 74.55 32.65 81.84 27.49 81.84"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-306"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "5.16 58.4 5.01 58.62 5.01 58.4 5.16 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "6.09 58.4 5.01 59.92 5.01 58.62 5.16 58.4 6.09 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "7.01 58.4 5.01 61.22 5.01 59.92 6.09 58.4 7.01 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "7.93 58.4 5.01 62.52 5.01 61.22 7.01 58.4 7.93 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "8.85 58.4 5.01 63.82 5.01 62.52 7.93 58.4 8.85 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "9.77 58.4 5.01 65.12 5.01 63.82 8.85 58.4 9.77 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "10.7 58.4 5.01 66.43 5.01 65.12 9.77 58.4 10.7 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "11.62 58.4 5.01 67.73 5.01 66.43 10.7 58.4 11.62 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "12.54 58.4 5.01 69.03 5.01 67.73 11.62 58.4 12.54 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "13.46 58.4 5.54 69.59 5.01 69.22 5.01 69.03 12.54 58.4 13.46 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "14.38 58.4 6.15 70.03 5.54 69.59 13.46 58.4 14.38 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "15.3 58.4 6.76 70.46 6.15 70.03 14.38 58.4 15.3 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "16.23 58.4 7.38 70.9 6.76 70.46 15.3 58.4 16.23 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "17.15 58.4 7.99 71.33 7.38 70.9 16.23 58.4 17.15 58.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "17.41 58.4 17.85 58.72 8.61 71.77 7.99 71.33 17.15 58.4 17.41 58.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 5.54,
    y: 65.08,
    width: 15.99,
    height: 0.75,
    transform: "translate(-47.7 38.67) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 6.15,
    y: 65.52,
    width: 15.99,
    height: 0.75,
    transform: "translate(-47.8 39.35) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 6.77,
    y: 65.95,
    width: 15.99,
    height: 0.75,
    transform: "translate(-47.9 40.03) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 7.38,
    y: 66.39,
    width: 15.99,
    height: 0.75,
    transform: "translate(-47.99 40.72) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 7.99,
    y: 66.82,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.09 41.4) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 8.61,
    y: 67.26,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.18 42.09) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 9.22,
    y: 67.69,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.28 42.77) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.84,
    y: 68.13,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.37 43.46) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 10.45,
    y: 68.56,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.47 44.14) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 11.06,
    y: 69,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.57 44.82) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 11.68,
    y: 69.43,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.66 45.51) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 12.29,
    y: 69.87,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.76 46.19) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 12.9,
    y: 70.3,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.85 46.88) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 13.52,
    y: 70.73,
    width: 15.99,
    height: 0.75,
    transform: "translate(-48.95 47.56) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 14.13,
    y: 71.17,
    width: 15.99,
    height: 0.75,
    transform: "translate(-49.04 48.25) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "27.06 65.24 27.67 65.67 18.53 78.58 18.22 78.58 17.81 78.29 27.06 65.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "27.67 65.67 28.28 66.11 19.45 78.58 18.53 78.58 27.67 65.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "28.28 66.11 28.9 66.54 20.37 78.58 19.45 78.58 28.28 66.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "28.9 66.54 29.51 66.98 21.29 78.58 20.37 78.58 28.9 66.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "29.51 66.98 30.05 67.36 30.05 67.52 22.22 78.58 21.29 78.58 29.51 66.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "30.05 68.82 23.14 78.58 22.22 78.58 30.05 67.52 30.05 68.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "30.05 70.12 24.06 78.58 23.14 78.58 30.05 68.82 30.05 70.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.05 71.42 24.98 78.58 24.06 78.58 30.05 70.12 30.05 71.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "30.05 72.73 25.9 78.58 24.98 78.58 30.05 71.42 30.05 72.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "30.05 74.03 26.83 78.58 25.9 78.58 30.05 72.73 30.05 74.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "30.05 75.33 27.75 78.58 26.83 78.58 30.05 74.03 30.05 75.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "30.05 76.63 28.67 78.58 27.75 78.58 30.05 75.33 30.05 76.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "30.05 77.93 29.59 78.58 28.67 78.58 30.05 76.63 30.05 77.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "29.59 78.58 30.05 77.93 30.05 78.58 29.59 78.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "5.76 53.66 -.02 61.81 -.02 53.66 5.76 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "6.68 53.66 -.02 63.12 -.02 61.81 5.76 53.66 6.68 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "7.6 53.66 -.02 64.42 -.02 63.12 6.68 53.66 7.6 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "8.52 53.66 -.02 65.72 -.02 64.42 7.6 53.66 8.52 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "9.45 53.66 -.02 67.02 -.02 65.72 8.52 53.66 9.45 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "10.37 53.66 -.02 68.32 -.02 67.02 9.45 53.66 10.37 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "11.29 53.66 -.02 69.62 -.02 68.32 10.37 53.66 11.29 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "12.21 53.66 .05 70.83 -.02 70.78 -.02 69.62 11.29 53.66 12.21 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "13.13 53.66 .66 71.27 .05 70.83 12.21 53.66 13.13 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "14.05 53.66 1.28 71.7 .66 71.27 13.13 53.66 14.05 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "14.98 53.66 1.89 72.14 1.28 71.7 14.05 53.66 14.98 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "15.9 53.66 2.5 72.57 1.89 72.14 14.98 53.66 15.9 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "16.82 53.66 3.12 73.01 2.5 72.57 15.9 53.66 16.82 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "17.74 53.66 3.73 73.44 3.12 73.01 16.82 53.66 17.74 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "18.06 53.66 18.46 53.95 4.35 73.87 3.73 73.44 17.74 53.66 18.06 53.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: -0.5,
    y: 63.75,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.39 36.62) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 0.11,
    y: 64.19,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.48 37.3) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 0.73,
    y: 64.62,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.58 37.98) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 1.34,
    y: 65.06,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.68 38.67) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1.96,
    y: 65.49,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.77 39.35) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 2.57,
    y: 65.93,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.87 40.04) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 3.18,
    y: 66.36,
    width: 24.42,
    height: 0.75,
    transform: "translate(-47.96 40.72) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 3.8,
    y: 66.8,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.06 41.41) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 4.41,
    y: 67.23,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.16 42.09) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 5.03,
    y: 67.67,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.25 42.78) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.64,
    y: 68.1,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.35 43.46) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 6.25,
    y: 68.54,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.44 44.14) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 6.87,
    y: 68.97,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.54 44.83) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 7.48,
    y: 69.41,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.63 45.51) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 8.09,
    y: 69.84,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.73 46.2) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 8.71,
    y: 70.28,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.83 46.88) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 9.32,
    y: 70.71,
    width: 24.42,
    height: 0.75,
    transform: "translate(-48.92 47.57) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 9.94,
    y: 71.14,
    width: 24.42,
    height: 0.75,
    transform: "translate(-49.02 48.25) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 10.55,
    y: 71.58,
    width: 24.42,
    height: 0.75,
    transform: "translate(-49.11 48.94) rotate(-54.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "30.12 62.21 30.74 62.64 16.81 82.31 16.25 82.31 16.01 82.14 30.12 62.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "30.74 62.64 31.35 63.08 17.73 82.31 16.81 82.31 30.74 62.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "31.35 63.08 31.97 63.51 18.65 82.31 17.73 82.31 31.35 63.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "31.97 63.51 32.58 63.95 19.57 82.31 18.65 82.31 31.97 63.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "32.58 63.95 33.19 64.38 20.5 82.31 19.57 82.31 32.58 63.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "33.19 64.38 33.81 64.82 21.42 82.31 20.5 82.31 33.19 64.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.81 64.82 34.42 65.25 22.34 82.31 21.42 82.31 33.81 64.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "34.42 65.25 35.03 65.69 23.26 82.31 22.34 82.31 34.42 65.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "35.03 65.69 35.08 65.72 35.08 66.93 24.18 82.31 23.26 82.31 35.03 65.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "35.08 68.23 25.11 82.31 24.18 82.31 35.08 66.93 35.08 68.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "35.08 69.53 26.03 82.31 25.11 82.31 35.08 68.23 35.08 69.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "35.08 70.83 26.95 82.31 26.03 82.31 35.08 69.53 35.08 70.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "35.08 72.13 27.87 82.31 26.95 82.31 35.08 70.83 35.08 72.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "35.08 73.43 28.79 82.31 27.87 82.31 35.08 72.13 35.08 73.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "35.08 74.73 29.71 82.31 28.79 82.31 35.08 73.43 35.08 74.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "29.71 82.31 35.08 74.73 35.08 82.31 29.71 82.31"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m20.15,74.35c-.01-.3-.05-.6-.08-.91-.03-.28-.17-.45-.53-.67-.47-.28-.92-.53-1.36-.8-.88-.54-1.69-1.16-2.42-1.93-.91-.96-1.17-1.77-1.17-2.54l2.74,2.11c.22.17.45.21.53.09l.31-.47c.08-.12-.04-.35-.25-.52l-2.99-2.31.25-.38,2.99,2.31c.22.17.45.21.53.09l.3-.47c.08-.12-.04-.35-.25-.52l-2.62-2.02h0c.57-.16,1.24-.11,2.09.3,1.01.49,1.9,1.19,2.74,1.98.4.37.77.77,1.16,1.15.29.28.5.37.74.31.27-.06.54-.15.79-.22.25-.08.25-.25,0-.59-.06-.08-.13-.16-.19-.25-1.1-1.25-2.32-2.35-3.75-3.28-.99-.64-2.01-1.16-2.98-1.42-1.22-.34-2.19-.29-2.98.06l-.09.04-1.35-1.04c-.22-.17-.45-.21-.53-.09l-.3.47c-.08.12.04.35.25.52l1.06.82-.25.38-1.06-.82c-.22-.17-.45-.21-.53-.09l-.3.47c-.08.12.04.35.25.52l1.27.98c-.01.25-.05.48-.04.74.09,1.35.79,2.81,2.23,4.35,1.2,1.28,2.57,2.33,4.05,3.17.39.22.78.43,1.17.6.43.2.6.12.59-.14h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: ".19 28.26 -30.15 64.79 -32.47 62.86 -3.73 28.26 .19 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "4.11 28.26 -27.83 66.71 -30.15 64.79 .19 28.26 4.11 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "8.03 28.26 -25.51 68.64 -27.83 66.71 4.11 28.26 8.03 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "11.95 28.26 -23.19 70.57 -25.51 68.64 8.03 28.26 11.95 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "15.87 28.26 -20.87 72.49 -23.19 70.57 11.95 28.26 15.87 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "19.79 28.26 -18.55 74.42 -20.87 72.49 15.87 28.26 19.79 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "23.71 28.26 -16.23 76.35 -18.55 74.42 19.79 28.26 23.71 28.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "24.37 28.26 26.3 29.86 -13.92 78.27 -16.23 76.35 23.71 28.26 24.37 28.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: -24.12,
    y: 53.52,
    width: 62.94,
    height: 3.02,
    transform: "translate(-39.68 25.52) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: -21.8,
    y: 55.45,
    width: 62.94,
    height: 3.02,
    transform: "translate(-40.32 28) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -19.48,
    y: 57.37,
    width: 62.94,
    height: 3.02,
    transform: "translate(-40.97 30.48) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -17.16,
    y: 59.3,
    width: 62.94,
    height: 3.02,
    transform: "translate(-41.61 32.96) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: -14.84,
    y: 61.23,
    width: 62.94,
    height: 3.02,
    transform: "translate(-42.26 35.44) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: -12.52,
    y: 63.15,
    width: 62.94,
    height: 3.02,
    transform: "translate(-42.9 37.92) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: -10.2,
    y: 65.08,
    width: 62.94,
    height: 3.02,
    transform: "translate(-43.54 40.4) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: -7.88,
    y: 67.01,
    width: 62.94,
    height: 3.02,
    transform: "translate(-44.19 42.88) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: -5.56,
    y: 68.93,
    width: 62.94,
    height: 3.02,
    transform: "translate(-44.83 45.37) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: -3.24,
    y: 70.86,
    width: 62.94,
    height: 3.02,
    transform: "translate(-45.48 47.85) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: -0.92,
    y: 72.79,
    width: 62.94,
    height: 3.02,
    transform: "translate(-46.12 50.33) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1.4,
    y: 74.71,
    width: 62.94,
    height: 3.02,
    transform: "translate(-46.77 52.81) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 3.72,
    y: 76.64,
    width: 62.94,
    height: 3.02,
    transform: "translate(-47.41 55.29) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 6.04,
    y: 78.57,
    width: 62.94,
    height: 3.02,
    transform: "translate(-48.06 57.77) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 8.36,
    y: 80.49,
    width: 62.94,
    height: 3.02,
    transform: "translate(-48.7 60.25) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 10.68,
    y: 82.42,
    width: 62.94,
    height: 3.02,
    transform: "translate(-49.34 62.73) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 13,
    y: 84.35,
    width: 62.94,
    height: 3.02,
    transform: "translate(-49.99 65.21) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 15.32,
    y: 86.27,
    width: 62.94,
    height: 3.02,
    transform: "translate(-50.63 67.69) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "68.05 64.53 69.88 66.05 69.88 67.06 30.16 114.88 27.84 112.95 68.05 64.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "69.88 71.78 32.48 116.81 30.16 114.88 69.88 67.06 69.88 71.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "69.88 76.5 34.8 118.73 32.48 116.81 69.88 71.78 69.88 76.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "69.88 81.22 37.12 120.66 34.8 118.73 69.88 76.5 69.88 81.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "69.88 85.93 39.44 122.58 37.12 120.66 69.88 81.22 69.88 85.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "69.88 90.65 41.76 124.51 39.44 122.58 69.88 85.93 69.88 90.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "69.88 95.37 44.08 126.44 41.76 124.51 69.88 90.65 69.88 95.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "69.88 100.09 46.4 128.36 44.08 126.44 69.88 95.37 69.88 100.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "69.88 104.81 48.71 130.29 46.4 128.36 69.88 100.09 69.88 104.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "69.88 109.53 52.09 130.94 49.5 130.94 48.71 130.29 69.88 104.81 69.88 109.53"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: ".5 37.77 -23.63 66.83 -25.65 65.16 -2.9 37.77 .5 37.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "3.9 37.77 -21.62 68.5 -23.63 66.83 .5 37.77 3.9 37.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "7.3 37.77 -19.61 70.17 -21.62 68.5 3.9 37.77 7.3 37.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "10.7 37.77 -17.59 71.84 -19.61 70.17 7.3 37.77 10.7 37.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "14.11 37.77 -15.58 73.52 -17.59 71.84 10.7 37.77 14.11 37.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "16.68 37.77 17.17 38.18 -13.57 75.19 -15.58 73.52 14.11 37.77 16.68 37.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: -21.25,
    y: 56.21,
    width: 48.11,
    height: 2.62,
    transform: "translate(-43.24 22.93) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: -19.23,
    y: 57.88,
    width: 48.11,
    height: 2.62,
    transform: "translate(-43.79 25.08) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: -17.22,
    y: 59.56,
    width: 48.11,
    height: 2.62,
    transform: "translate(-44.35 27.23) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: -15.21,
    y: 61.23,
    width: 48.11,
    height: 2.62,
    transform: "translate(-44.91 29.39) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: -13.19,
    y: 62.9,
    width: 48.11,
    height: 2.62,
    transform: "translate(-45.47 31.54) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -11.18,
    y: 64.57,
    width: 48.11,
    height: 2.62,
    transform: "translate(-46.03 33.69) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -9.17,
    y: 66.25,
    width: 48.11,
    height: 2.62,
    transform: "translate(-46.59 35.84) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: -7.15,
    y: 67.92,
    width: 48.11,
    height: 2.62,
    transform: "translate(-47.15 38) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: -5.14,
    y: 69.59,
    width: 48.11,
    height: 2.62,
    transform: "translate(-47.71 40.15) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: -3.13,
    y: 71.26,
    width: 48.11,
    height: 2.62,
    transform: "translate(-48.27 42.3) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: -1.11,
    y: 72.93,
    width: 48.11,
    height: 2.62,
    transform: "translate(-48.83 44.45) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 0.9,
    y: 74.61,
    width: 48.11,
    height: 2.62,
    transform: "translate(-49.39 46.61) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 2.91,
    y: 76.28,
    width: 48.11,
    height: 2.62,
    transform: "translate(-49.95 48.76) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 4.93,
    y: 77.95,
    width: 48.11,
    height: 2.62,
    transform: "translate(-50.51 50.91) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 6.94,
    y: 79.62,
    width: 48.11,
    height: 2.62,
    transform: "translate(-51.07 53.06) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 8.95,
    y: 81.29,
    width: 48.11,
    height: 2.62,
    transform: "translate(-51.63 55.22) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 10.97,
    y: 82.97,
    width: 48.11,
    height: 2.62,
    transform: "translate(-52.19 57.37) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 12.98,
    y: 84.64,
    width: 48.11,
    height: 2.62,
    transform: "translate(-52.74 59.52) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 14.99,
    y: 86.31,
    width: 48.11,
    height: 2.62,
    transform: "translate(-53.3 61.67) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 17,
    y: 87.98,
    width: 48.11,
    height: 2.62,
    transform: "translate(-53.86 63.83) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 19.02,
    y: 89.65,
    width: 48.11,
    height: 2.62,
    transform: "translate(-54.42 65.98) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 21.03,
    y: 91.33,
    width: 48.11,
    height: 2.62,
    transform: "translate(-54.98 68.13) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "61.46 74.97 62.8 76.08 62.8 77.45 32.74 113.65 30.72 111.97 61.46 74.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "62.8 81.54 34.75 115.32 32.74 113.65 62.8 77.45 62.8 81.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "62.8 85.64 36.76 116.99 34.75 115.32 62.8 81.54 62.8 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "62.8 89.74 38.78 118.66 36.76 116.99 62.8 85.64 62.8 89.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "62.8 93.83 40.79 120.34 38.78 118.66 62.8 89.74 62.8 93.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "62.8 97.93 42.8 122.01 40.79 120.34 62.8 93.83 62.8 97.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "62.8 102.02 44.82 123.68 42.8 122.01 62.8 97.93 62.8 102.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "62.8 106.12 46.83 125.35 44.82 123.68 62.8 102.02 62.8 106.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "62.8 110.22 49.9 125.75 47.3 125.75 46.83 125.35 62.8 106.12 62.8 110.22"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1.02 56.4 -14.19 74.71 -15.7 73.46 -1.52 56.4 1.02 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "3.57 56.4 -12.68 75.97 -14.19 74.71 1.02 56.4 3.57 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "6.12 56.4 -11.18 77.22 -12.68 75.97 3.57 56.4 6.12 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "8.66 56.4 -9.67 78.47 -11.18 77.22 6.12 56.4 8.66 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "11.21 56.4 -8.16 79.72 -9.67 78.47 8.66 56.4 11.21 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "13.76 56.4 -6.66 80.97 -8.16 79.72 11.21 56.4 13.76 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "16.3 56.4 -5.15 82.22 -6.66 80.97 13.76 56.4 16.3 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "18.85 56.4 -3.64 83.48 -5.15 82.22 16.3 56.4 18.85 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "21.4 56.4 -2.13 84.73 -3.64 83.48 18.85 56.4 21.4 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "21.43 56.4 22.92 57.63 -.63 85.98 -2.13 84.73 21.4 56.4 21.43 56.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: -6.53,
    y: 71.45,
    width: 36.85,
    height: 1.96,
    transform: "translate(-51.42 35.31) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: -5.02,
    y: 72.71,
    width: 36.85,
    height: 1.96,
    transform: "translate(-51.84 36.92) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: -3.51,
    y: 73.96,
    width: 36.85,
    height: 1.96,
    transform: "translate(-52.26 38.53) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: -2,
    y: 75.21,
    width: 36.85,
    height: 1.96,
    transform: "translate(-52.68 40.14) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -0.5,
    y: 76.46,
    width: 36.85,
    height: 1.96,
    transform: "translate(-53.1 41.75) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.01,
    y: 77.71,
    width: 36.85,
    height: 1.96,
    transform: "translate(-53.52 43.36) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 2.52,
    y: 78.96,
    width: 36.85,
    height: 1.96,
    transform: "translate(-53.94 44.97) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 4.02,
    y: 80.22,
    width: 36.85,
    height: 1.96,
    transform: "translate(-54.36 46.59) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 5.53,
    y: 81.47,
    width: 36.85,
    height: 1.96,
    transform: "translate(-54.77 48.2) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 7.04,
    y: 82.72,
    width: 36.85,
    height: 1.96,
    transform: "translate(-55.19 49.81) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 8.55,
    y: 83.97,
    width: 36.85,
    height: 1.96,
    transform: "translate(-55.61 51.42) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 10.05,
    y: 85.22,
    width: 36.85,
    height: 1.96,
    transform: "translate(-56.03 53.03) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 11.56,
    y: 86.47,
    width: 36.85,
    height: 1.96,
    transform: "translate(-56.45 54.64) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 13.07,
    y: 87.73,
    width: 36.85,
    height: 1.96,
    transform: "translate(-56.87 56.25) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 14.57,
    y: 88.98,
    width: 36.85,
    height: 1.96,
    transform: "translate(-57.29 57.87) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 16.08,
    y: 90.23,
    width: 36.85,
    height: 1.96,
    transform: "translate(-57.71 59.48) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 17.59,
    y: 91.48,
    width: 36.85,
    height: 1.96,
    transform: "translate(-58.12 61.09) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 19.09,
    y: 92.73,
    width: 36.85,
    height: 1.96,
    transform: "translate(-58.54 62.7) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 20.6,
    y: 93.98,
    width: 36.85,
    height: 1.96,
    transform: "translate(-58.96 64.31) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 22.11,
    y: 95.24,
    width: 36.85,
    height: 1.96,
    transform: "translate(-59.38 65.92) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 23.62,
    y: 96.49,
    width: 36.85,
    height: 1.96,
    transform: "translate(-59.8 67.53) rotate(-50.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "54.56 83.92 55.3 84.53 55.3 86.1 32.53 113.52 31.02 112.27 54.56 83.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "55.3 89.16 34.04 114.77 32.53 113.52 55.3 86.1 55.3 89.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "55.3 92.23 35.54 116.02 34.04 114.77 55.3 89.16 55.3 92.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "55.3 95.3 37.05 117.27 35.54 116.02 55.3 92.23 55.3 95.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "55.3 98.36 38.56 118.52 37.05 117.27 55.3 95.3 55.3 98.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "55.3 101.43 40.06 119.78 38.56 118.52 55.3 98.36 55.3 101.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "55.3 104.5 41.57 121.03 40.06 119.78 55.3 101.43 55.3 104.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "55.3 107.56 43.1 122.25 43.05 122.25 41.57 121.03 55.3 104.5 55.3 107.56"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m35.01,23.01c-1.57-1.63-.41-4.59,1.59-5.35,1.87-.86,4.36-.61,5.69.99-.97-.18-1.82-.19-2.67-.1-2.48.2-4.8,1.68-4.61,4.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m51.63,26.88c-1.94-4.92,1.82-8.01,6.56-6.94.53.11,1.05.22,1.58.41-1.03.36-2.15.5-3.1.68-1.82.38-3.55,1.06-4.26,2.86-.34.81-.4,1.95-.77,2.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m70.77,34.13c1.25-4.76,7.22-6.84,11.65-5.51-4.28,1.14-8.45,2.25-11.65,5.51h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-305",
    x: 17.04,
    y: 18.27,
    width: 82.15,
    height: 52.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-305",
    x: 17.04,
    y: 70.96,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 17.04,
    y: 71.42,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 17.04,
    y: 71.88,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 17.04,
    y: 72.34,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 17.04,
    y: 72.8,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 17.04,
    y: 73.26,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 17.04,
    y: 73.72,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 17.04,
    y: 74.18,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 17.04,
    y: 74.64,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.04,
    y: 75.1,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 17.04,
    y: 75.56,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 17.04,
    y: 76.02,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 17.04,
    y: 76.48,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 17.04,
    y: 76.94,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 17.04,
    y: 77.4,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 17.04,
    y: 77.86,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 17.04,
    y: 78.32,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 17.04,
    y: 78.78,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 17.04,
    y: 79.24,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 17.04,
    y: 79.7,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 17.04,
    y: 80.16,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 17.04,
    y: 80.62,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 17.04,
    y: 81.08,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 17.04,
    y: 81.54,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 17.04,
    y: 82,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 17.04,
    y: 82.46,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 17.04,
    y: 82.92,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 17.04,
    y: 83.38,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 17.04,
    y: 83.84,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-255",
    x: 17.04,
    y: 84.3,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-296",
    x: 17.04,
    y: 84.76,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 17.04,
    y: 85.22,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 17.04,
    y: 85.68,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 17.04,
    y: 86.14,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 17.04,
    y: 86.6,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 17.04,
    y: 87.06,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 17.04,
    y: 87.52,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.04,
    y: 87.99,
    width: 82.15,
    height: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.04,
    y: 88.45,
    width: 82.15,
    height: 5.35
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "101.53 96.28 101.68 96.14 101.68 96.28 101.53 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "99.5 96.28 101.68 94.11 101.68 96.14 101.53 96.28 99.5 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "97.46 96.28 101.68 92.09 101.68 94.11 99.5 96.28 97.46 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "95.43 96.28 101.68 90.07 101.68 92.09 97.46 96.28 95.43 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "93.4 96.28 101.68 88.05 101.68 90.07 95.43 96.28 93.4 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "91.37 96.28 101.68 86.03 101.68 88.05 93.4 96.28 91.37 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "89.33 96.28 101.68 84.01 101.68 86.03 91.37 96.28 89.33 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "87.3 96.28 101.68 81.98 101.68 84.01 89.33 96.28 87.3 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "85.27 96.28 101.68 79.96 101.68 81.98 87.3 96.28 85.27 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "83.24 96.28 101.68 77.94 101.68 79.96 85.27 96.28 83.24 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "81.2 96.28 101.68 75.92 101.68 77.94 83.24 96.28 81.2 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "79.17 96.28 101.68 73.9 101.68 75.92 81.2 96.28 79.17 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "77.14 96.28 101.68 71.88 101.68 73.9 79.17 96.28 77.14 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "75.1 96.28 101.68 69.86 101.68 71.88 77.14 96.28 75.1 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "73.07 96.28 101.68 67.83 101.68 69.86 75.1 96.28 73.07 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "71.04 96.28 101.68 65.81 101.68 67.83 73.07 96.28 71.04 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "69.01 96.28 101.68 63.79 101.68 65.81 71.04 96.28 69.01 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "66.97 96.28 101.68 61.77 101.68 63.79 69.01 96.28 66.97 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "64.94 96.28 101.68 59.75 101.68 61.77 66.97 96.28 64.94 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "62.91 96.28 101.68 57.73 101.68 59.75 64.94 96.28 62.91 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "60.88 96.28 101.68 55.7 101.68 57.73 62.91 96.28 60.88 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "58.84 96.28 101.68 53.68 101.68 55.7 60.88 96.28 58.84 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "56.81 96.28 101.68 51.66 101.68 53.68 58.84 96.28 56.81 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "54.78 96.28 101.68 49.64 101.68 51.66 56.81 96.28 54.78 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "52.74 96.28 101.68 47.62 101.68 49.64 54.78 96.28 52.74 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "50.71 96.28 101.68 45.6 101.68 47.62 52.74 96.28 50.71 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "48.68 96.28 101.68 43.57 101.68 45.6 50.71 96.28 48.68 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "46.65 96.28 101.68 41.55 101.68 43.57 48.68 96.28 46.65 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "44.61 96.28 101.68 39.53 101.68 41.55 46.65 96.28 44.61 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "42.58 96.28 101.68 37.51 101.68 39.53 44.61 96.28 42.58 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "40.55 96.28 101.68 35.49 101.68 37.51 42.58 96.28 40.55 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "38.51 96.28 101.68 33.47 101.68 35.49 40.55 96.28 38.51 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "36.48 96.28 100.99 32.13 101.68 32.82 101.68 33.47 38.51 96.28 36.48 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "34.45 96.28 99.98 31.11 100.99 32.13 36.48 96.28 34.45 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "32.42 96.28 98.97 30.1 99.98 31.11 34.45 96.28 32.42 96.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "30.75 96.28 30.57 96.1 97.96 29.08 98.97 30.1 32.42 96.28 30.75 96.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 16.24,
    y: 61.36,
    width: 95.04,
    height: 1.43,
    transform: "translate(-25.23 63.02) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 15.23,
    y: 60.35,
    width: 95.04,
    height: 1.43,
    transform: "translate(-24.8 62.01) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 14.22,
    y: 59.33,
    width: 95.04,
    height: 1.43,
    transform: "translate(-24.38 61) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 13.21,
    y: 58.31,
    width: 95.04,
    height: 1.43,
    transform: "translate(-23.96 60) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 12.2,
    y: 57.3,
    width: 95.04,
    height: 1.43,
    transform: "translate(-23.54 58.99) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 11.18,
    y: 56.28,
    width: 95.04,
    height: 1.43,
    transform: "translate(-23.11 57.98) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 10.17,
    y: 55.27,
    width: 95.04,
    height: 1.43,
    transform: "translate(-22.69 56.97) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 9.16,
    y: 54.25,
    width: 95.04,
    height: 1.43,
    transform: "translate(-22.27 55.96) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 8.15,
    y: 53.23,
    width: 95.04,
    height: 1.43,
    transform: "translate(-21.85 54.95) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 7.14,
    y: 52.22,
    width: 95.04,
    height: 1.43,
    transform: "translate(-21.42 53.95) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 6.13,
    y: 51.2,
    width: 95.04,
    height: 1.43,
    transform: "translate(-21 52.94) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 5.12,
    y: 50.18,
    width: 95.04,
    height: 1.43,
    transform: "translate(-20.58 51.93) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 4.11,
    y: 49.17,
    width: 95.04,
    height: 1.43,
    transform: "translate(-20.15 50.92) rotate(-44.84)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "17.43 82.88 16.42 81.87 82.87 15.78 84.73 15.78 84.82 15.87 17.43 82.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "16.42 81.87 15.41 80.85 80.84 15.78 82.87 15.78 16.42 81.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "15.41 80.85 14.55 79.99 14.55 79.68 78.8 15.78 80.84 15.78 15.41 80.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "14.55 77.66 76.77 15.78 78.8 15.78 14.55 79.68 14.55 77.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "14.55 75.63 74.74 15.78 76.77 15.78 14.55 77.66 14.55 75.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "14.55 73.61 72.7 15.78 74.74 15.78 14.55 75.63 14.55 73.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "14.55 71.59 70.67 15.78 72.7 15.78 14.55 73.61 14.55 71.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "14.55 69.57 68.64 15.78 70.67 15.78 14.55 71.59 14.55 69.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "14.55 67.55 66.61 15.78 68.64 15.78 14.55 69.57 14.55 67.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "14.55 65.53 64.57 15.78 66.61 15.78 14.55 67.55 14.55 65.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "14.55 63.51 62.54 15.78 64.57 15.78 14.55 65.53 14.55 63.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "14.55 61.48 60.51 15.78 62.54 15.78 14.55 63.51 14.55 61.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "14.55 59.46 58.48 15.78 60.51 15.78 14.55 61.48 14.55 59.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "14.55 57.44 56.44 15.78 58.48 15.78 14.55 59.46 14.55 57.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "14.55 55.42 54.41 15.78 56.44 15.78 14.55 57.44 14.55 55.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "14.55 53.4 52.38 15.78 54.41 15.78 14.55 55.42 14.55 53.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "14.55 51.38 50.34 15.78 52.38 15.78 14.55 53.4 14.55 51.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "14.55 49.35 48.31 15.78 50.34 15.78 14.55 51.38 14.55 49.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "14.55 47.33 46.28 15.78 48.31 15.78 14.55 49.35 14.55 47.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "14.55 45.31 44.25 15.78 46.28 15.78 14.55 47.33 14.55 45.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "14.55 43.29 42.21 15.78 44.25 15.78 14.55 45.31 14.55 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "14.55 41.27 40.18 15.78 42.21 15.78 14.55 43.29 14.55 41.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "14.55 39.25 38.15 15.78 40.18 15.78 14.55 41.27 14.55 39.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "14.55 37.22 36.12 15.78 38.15 15.78 14.55 39.25 14.55 37.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "14.55 35.2 34.08 15.78 36.12 15.78 14.55 37.22 14.55 35.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "14.55 33.18 32.05 15.78 34.08 15.78 14.55 35.2 14.55 33.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "14.55 31.16 30.02 15.78 32.05 15.78 14.55 33.18 14.55 31.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "14.55 29.14 27.98 15.78 30.02 15.78 14.55 31.16 14.55 29.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "14.55 27.12 25.95 15.78 27.98 15.78 14.55 29.14 14.55 27.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "14.55 25.1 23.92 15.78 25.95 15.78 14.55 27.12 14.55 25.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "14.55 23.07 21.89 15.78 23.92 15.78 14.55 25.1 14.55 23.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "14.55 21.05 19.85 15.78 21.89 15.78 14.55 23.07 14.55 21.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "14.55 19.03 17.82 15.78 19.85 15.78 14.55 21.05 14.55 19.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "14.55 17.01 15.79 15.78 17.82 15.78 14.55 19.03 14.55 17.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "15.79 15.78 14.55 17.01 14.55 15.78 15.79 15.78"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-279"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "17.04 93.22 69.67 93.79 17.04 93.79 17.04 93.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "17.04 92.45 99.2 93.34 99.2 93.79 69.67 93.79 17.04 93.22 17.04 92.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "17.04 91.68 99.2 92.57 99.2 93.34 17.04 92.45 17.04 91.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "17.04 90.91 99.2 91.8 99.2 92.57 17.04 91.68 17.04 90.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "17.04 90.14 99.2 91.03 99.2 91.8 17.04 90.91 17.04 90.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "17.04 89.37 99.2 90.26 99.2 91.03 17.04 90.14 17.04 89.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "17.04 88.6 99.2 89.49 99.2 90.26 17.04 89.37 17.04 88.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "17.04 87.82 99.2 88.72 99.2 89.49 17.04 88.6 17.04 87.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "17.04 87.05 99.2 87.95 99.2 88.72 17.04 87.82 17.04 87.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "17.04 86.28 99.2 87.18 99.2 87.95 17.04 87.05 17.04 86.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "17.04 85.51 99.2 86.41 99.2 87.18 17.04 86.28 17.04 85.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "17.04 84.74 99.2 85.63 99.2 86.41 17.04 85.51 17.04 84.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "17.04 83.97 99.2 84.86 99.2 85.63 17.04 84.74 17.04 83.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "17.04 83.2 99.2 84.09 99.2 84.86 17.04 83.97 17.04 83.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "17.04 82.43 99.2 83.32 99.2 84.09 17.04 83.2 17.04 82.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "17.04 81.66 99.2 82.55 99.2 83.32 17.04 82.43 17.04 81.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "17.04 80.89 99.2 81.78 99.2 82.55 17.04 81.66 17.04 80.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "17.04 80.12 99.2 81.01 99.2 81.78 17.04 80.89 17.04 80.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "17.04 79.35 99.2 80.24 99.2 81.01 17.04 80.12 17.04 79.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "17.04 78.58 99.2 79.47 99.2 80.24 17.04 79.35 17.04 78.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "17.04 77.81 99.2 78.7 99.2 79.47 17.04 78.58 17.04 77.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "17.04 77.03 99.2 77.93 99.2 78.7 17.04 77.81 17.04 77.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "17.04 76.26 99.2 77.16 99.2 77.93 17.04 77.03 17.04 76.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "17.04 75.49 99.2 76.39 99.2 77.16 17.04 76.26 17.04 75.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "17.04 74.72 99.2 75.62 99.2 76.39 17.04 75.49 17.04 74.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "17.04 73.95 99.2 74.84 99.2 75.62 17.04 74.72 17.04 73.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "17.04 73.18 99.2 74.07 99.2 74.84 17.04 73.95 17.04 73.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "17.04 72.41 99.2 73.3 99.2 74.07 17.04 73.18 17.04 72.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "17.04 71.64 99.2 72.53 99.2 73.3 17.04 72.41 17.04 71.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "17.04 70.87 99.2 71.76 99.2 72.53 17.04 71.64 17.04 70.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "17.04 70.1 99.2 70.99 99.2 71.76 17.04 70.87 17.04 70.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "17.04 69.33 99.2 70.22 99.2 70.99 17.04 70.1 17.04 69.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "17.04 68.56 99.2 69.45 99.2 70.22 17.04 69.33 17.04 68.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "17.04 67.79 99.2 68.68 99.2 69.45 17.04 68.56 17.04 67.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "17.04 67.01 99.2 67.91 99.2 68.68 17.04 67.79 17.04 67.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "17.04 66.24 99.2 67.14 99.2 67.91 17.04 67.01 17.04 66.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "17.04 65.47 99.2 66.37 99.2 67.14 17.04 66.24 17.04 65.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "17.04 64.7 99.2 65.6 99.2 66.37 17.04 65.47 17.04 64.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "17.04 63.93 99.2 64.82 99.2 65.6 17.04 64.7 17.04 63.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "17.04 63.16 99.2 64.05 99.2 64.82 17.04 63.93 17.04 63.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "17.04 62.39 99.2 63.28 99.2 64.05 17.04 63.16 17.04 62.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "17.04 61.62 99.2 62.51 99.2 63.28 17.04 62.39 17.04 61.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "17.04 60.85 99.2 61.74 99.2 62.51 17.04 61.62 17.04 60.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "17.04 60.08 99.2 60.97 99.2 61.74 17.04 60.85 17.04 60.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "17.04 59.31 99.2 60.2 99.2 60.97 17.04 60.08 17.04 59.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "17.04 58.54 99.2 59.43 99.2 60.2 17.04 59.31 17.04 58.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "17.04 57.77 99.2 58.66 99.2 59.43 17.04 58.54 17.04 57.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "17.04 56.99 99.2 57.89 99.2 58.66 17.04 57.77 17.04 56.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "17.04 56.22 99.2 57.12 99.2 57.89 17.04 56.99 17.04 56.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "17.04 55.45 99.2 56.35 99.2 57.12 17.04 56.22 17.04 55.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "17.04 54.68 99.2 55.58 99.2 56.35 17.04 55.45 17.04 54.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "17.04 53.91 99.2 54.8 99.2 55.58 17.04 54.68 17.04 53.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "17.04 53.14 99.2 54.03 99.2 54.8 17.04 53.91 17.04 53.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "17.04 52.37 99.2 53.26 99.2 54.03 17.04 53.14 17.04 52.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "17.04 51.6 99.2 52.49 99.2 53.26 17.04 52.37 17.04 51.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "17.04 50.83 99.2 51.72 99.2 52.49 17.04 51.6 17.04 50.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "17.04 50.06 99.2 50.95 99.2 51.72 17.04 50.83 17.04 50.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "17.04 49.29 99.2 50.18 99.2 50.95 17.04 50.06 17.04 49.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "17.04 48.52 99.2 49.41 99.2 50.18 17.04 49.29 17.04 48.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "17.04 47.75 99.2 48.64 99.2 49.41 17.04 48.52 17.04 47.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "17.04 46.98 99.2 47.87 99.2 48.64 17.04 47.75 17.04 46.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "17.04 46.2 99.2 47.1 99.2 47.87 17.04 46.98 17.04 46.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "17.04 45.43 99.2 46.33 99.2 47.1 17.04 46.2 17.04 45.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "17.04 44.66 99.2 45.56 99.2 46.33 17.04 45.43 17.04 44.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "17.04 43.89 99.2 44.79 99.2 45.56 17.04 44.66 17.04 43.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "17.04 43.12 99.2 44.01 99.2 44.79 17.04 43.89 17.04 43.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "17.04 42.35 99.2 43.24 99.2 44.01 17.04 43.12 17.04 42.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "17.04 41.58 99.2 42.47 99.2 43.24 17.04 42.35 17.04 41.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "17.04 40.81 99.2 41.7 99.2 42.47 17.04 41.58 17.04 40.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "17.04 40.04 99.2 40.93 99.2 41.7 17.04 40.81 17.04 40.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "17.04 39.27 99.2 40.16 99.2 40.93 17.04 40.04 17.04 39.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "17.04 38.5 99.2 39.39 99.2 40.16 17.04 39.27 17.04 38.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "17.04 37.73 99.2 38.62 99.2 39.39 17.04 38.5 17.04 37.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "17.04 36.96 99.2 37.85 99.2 38.62 17.04 37.73 17.04 36.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "17.04 36.18 99.2 37.08 99.2 37.85 17.04 36.96 17.04 36.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "17.04 35.41 99.2 36.31 99.2 37.08 17.04 36.18 17.04 35.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "17.04 34.64 99.2 35.54 99.2 36.31 17.04 35.41 17.04 34.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "17.04 33.87 99.2 34.77 99.2 35.54 17.04 34.64 17.04 33.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "17.04 33.1 99.2 33.99 99.2 34.77 17.04 33.87 17.04 33.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "17.04 32.33 99.2 33.22 99.2 33.99 17.04 33.1 17.04 32.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "17.04 31.56 99.2 32.45 99.2 33.22 17.04 32.33 17.04 31.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "17.04 30.79 99.2 31.68 99.2 32.45 17.04 31.56 17.04 30.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "17.04 30.02 99.2 30.91 99.2 31.68 17.04 30.79 17.04 30.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "17.04 29.25 99.2 30.14 99.2 30.91 17.04 30.02 17.04 29.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "17.04 28.48 99.2 29.37 99.2 30.14 17.04 29.25 17.04 28.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "17.04 27.71 99.2 28.6 99.2 29.37 17.04 28.48 17.04 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "17.04 26.94 99.2 27.83 99.2 28.6 17.04 27.71 17.04 26.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "17.04 26.17 99.2 27.06 99.2 27.83 17.04 26.94 17.04 26.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "99.2 27.06 17.04 26.17 17.04 18.27 99.2 18.27 99.2 27.06"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "17.87 92.4 69.2 92.96 17.87 92.96 17.87 92.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "17.87 91.65 98.35 92.53 98.35 92.96 69.2 92.96 17.87 92.4 17.87 91.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "17.87 90.9 98.35 91.77 98.35 92.53 17.87 91.65 17.87 90.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "17.87 90.14 98.35 91.02 98.35 91.77 17.87 90.9 17.87 90.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "17.87 89.39 98.35 90.26 98.35 91.02 17.87 90.14 17.87 89.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "17.87 88.64 98.35 89.51 98.35 90.26 17.87 89.39 17.87 88.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "17.87 87.88 98.35 88.76 98.35 89.51 17.87 88.64 17.87 87.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "17.87 87.13 98.35 88 98.35 88.76 17.87 87.88 17.87 87.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "17.87 86.37 98.35 87.25 98.35 88 17.87 87.13 17.87 86.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "17.87 85.62 98.35 86.49 98.35 87.25 17.87 86.37 17.87 85.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "17.87 84.87 98.35 85.74 98.35 86.49 17.87 85.62 17.87 84.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "17.87 84.11 98.35 84.99 98.35 85.74 17.87 84.87 17.87 84.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "17.87 83.36 98.35 84.23 98.35 84.99 17.87 84.11 17.87 83.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "17.87 82.61 98.35 83.48 98.35 84.23 17.87 83.36 17.87 82.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "17.87 81.85 98.35 82.73 98.35 83.48 17.87 82.61 17.87 81.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "17.87 81.1 98.35 81.97 98.35 82.73 17.87 81.85 17.87 81.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "17.87 80.34 98.35 81.22 98.35 81.97 17.87 81.1 17.87 80.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "17.87 79.59 98.35 80.46 98.35 81.22 17.87 80.34 17.87 79.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "17.87 78.84 98.35 79.71 98.35 80.46 17.87 79.59 17.87 78.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "17.87 78.08 98.35 78.96 98.35 79.71 17.87 78.84 17.87 78.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "17.87 77.33 98.35 78.2 98.35 78.96 17.87 78.08 17.87 77.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "17.87 76.57 98.35 77.45 98.35 78.2 17.87 77.33 17.87 76.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "17.87 75.82 98.35 76.7 98.35 77.45 17.87 76.57 17.87 75.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "17.87 75.07 98.35 75.94 98.35 76.7 17.87 75.82 17.87 75.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "17.87 74.31 98.35 75.19 98.35 75.94 17.87 75.07 17.87 74.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "17.87 73.56 98.35 74.43 98.35 75.19 17.87 74.31 17.87 73.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "17.87 72.81 98.35 73.68 98.35 74.43 17.87 73.56 17.87 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "17.87 72.05 98.35 72.93 98.35 73.68 17.87 72.81 17.87 72.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "17.87 71.3 98.35 72.17 98.35 72.93 17.87 72.05 17.87 71.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "17.87 70.54 98.35 71.42 98.35 72.17 17.87 71.3 17.87 70.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "17.87 69.79 98.35 70.67 98.35 71.42 17.87 70.54 17.87 69.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "17.87 69.04 98.35 69.91 98.35 70.67 17.87 69.79 17.87 69.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "17.87 68.28 98.35 69.16 98.35 69.91 17.87 69.04 17.87 68.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "17.87 67.53 98.35 68.4 98.35 69.16 17.87 68.28 17.87 67.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "17.87 66.78 98.35 67.65 98.35 68.4 17.87 67.53 17.87 66.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "17.87 66.02 98.35 66.9 98.35 67.65 17.87 66.78 17.87 66.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "17.87 65.27 98.35 66.14 98.35 66.9 17.87 66.02 17.87 65.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "17.87 64.51 98.35 65.39 98.35 66.14 17.87 65.27 17.87 64.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "17.87 63.76 98.35 64.64 98.35 65.39 17.87 64.51 17.87 63.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "17.87 63.01 98.35 63.88 98.35 64.64 17.87 63.76 17.87 63.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "17.87 62.25 98.35 63.13 98.35 63.88 17.87 63.01 17.87 62.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "17.87 61.5 98.35 62.37 98.35 63.13 17.87 62.25 17.87 61.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "17.87 60.75 98.35 61.62 98.35 62.37 17.87 61.5 17.87 60.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "17.87 59.99 98.35 60.87 98.35 61.62 17.87 60.75 17.87 59.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "17.87 59.24 98.35 60.11 98.35 60.87 17.87 59.99 17.87 59.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "17.87 58.48 98.35 59.36 98.35 60.11 17.87 59.24 17.87 58.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "17.87 57.73 98.35 58.61 98.35 59.36 17.87 58.48 17.87 57.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "17.87 56.98 98.35 57.85 98.35 58.61 17.87 57.73 17.87 56.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "17.87 56.22 98.35 57.1 98.35 57.85 17.87 56.98 17.87 56.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "17.87 55.47 98.35 56.34 98.35 57.1 17.87 56.22 17.87 55.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "17.87 54.72 98.35 55.59 98.35 56.34 17.87 55.47 17.87 54.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "17.87 53.96 98.35 54.84 98.35 55.59 17.87 54.72 17.87 53.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "17.87 53.21 98.35 54.08 98.35 54.84 17.87 53.96 17.87 53.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "17.87 52.45 98.35 53.33 98.35 54.08 17.87 53.21 17.87 52.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "17.87 51.7 98.35 52.58 98.35 53.33 17.87 52.45 17.87 51.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "17.87 50.95 98.35 51.82 98.35 52.58 17.87 51.7 17.87 50.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "17.87 50.19 98.35 51.07 98.35 51.82 17.87 50.95 17.87 50.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "17.87 49.44 98.35 50.31 98.35 51.07 17.87 50.19 17.87 49.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "17.87 48.69 98.35 49.56 98.35 50.31 17.87 49.44 17.87 48.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "17.87 47.93 98.35 48.81 98.35 49.56 17.87 48.69 17.87 47.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "17.87 47.18 98.35 48.05 98.35 48.81 17.87 47.93 17.87 47.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "17.87 46.42 98.35 47.3 98.35 48.05 17.87 47.18 17.87 46.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "17.87 45.67 98.35 46.54 98.35 47.3 17.87 46.42 17.87 45.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "17.87 44.92 98.35 45.79 98.35 46.54 17.87 45.67 17.87 44.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "17.87 44.16 98.35 45.04 98.35 45.79 17.87 44.92 17.87 44.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "17.87 43.41 98.35 44.28 98.35 45.04 17.87 44.16 17.87 43.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "17.87 42.66 98.35 43.53 98.35 44.28 17.87 43.41 17.87 42.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "17.87 41.9 98.35 42.78 98.35 43.53 17.87 42.66 17.87 41.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "17.87 41.15 98.35 42.02 98.35 42.78 17.87 41.9 17.87 41.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "17.87 40.39 98.35 41.27 98.35 42.02 17.87 41.15 17.87 40.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "17.87 39.64 98.35 40.51 98.35 41.27 17.87 40.39 17.87 39.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "17.87 38.89 98.35 39.76 98.35 40.51 17.87 39.64 17.87 38.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "17.87 38.13 98.35 39.01 98.35 39.76 17.87 38.89 17.87 38.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "17.87 37.38 98.35 38.25 98.35 39.01 17.87 38.13 17.87 37.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "17.87 36.62 98.35 37.5 98.35 38.25 17.87 37.38 17.87 36.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "17.87 35.87 98.35 36.75 98.35 37.5 17.87 36.62 17.87 35.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "17.87 35.12 98.35 35.99 98.35 36.75 17.87 35.87 17.87 35.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "17.87 34.36 98.35 35.24 98.35 35.99 17.87 35.12 17.87 34.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "17.87 33.61 98.35 34.48 98.35 35.24 17.87 34.36 17.87 33.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "17.87 32.86 98.35 33.73 98.35 34.48 17.87 33.61 17.87 32.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "17.87 32.1 98.35 32.98 98.35 33.73 17.87 32.86 17.87 32.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "17.87 31.35 98.35 32.22 98.35 32.98 17.87 32.1 17.87 31.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "17.87 30.59 98.35 31.47 98.35 32.22 17.87 31.35 17.87 30.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "17.87 29.84 98.35 30.72 98.35 31.47 17.87 30.59 17.87 29.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "17.87 29.09 98.35 29.96 98.35 30.72 17.87 29.84 17.87 29.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "17.87 28.33 98.35 29.21 98.35 29.96 17.87 29.09 17.87 28.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "17.87 27.58 98.35 28.45 98.35 29.21 17.87 28.33 17.87 27.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "17.87 26.83 98.35 27.7 98.35 28.45 17.87 27.58 17.87 26.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "98.35 27.7 17.87 26.83 17.87 19.1 98.35 19.1 98.35 27.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m48.33,68c-.08-.83-.19-1.56-.34-2.18-.16-.64-.38-1.22-.67-1.71-.29-.51-.66-.94-1.1-1.29-.43-.35-.94-.64-1.52-.87-.57-.23-1.22-.4-1.93-.51-.68-.11-1.49-.19-2.49-.25-1.95-.11-4.3-.13-6.41.01-.96.06-1.76.16-2.47.29-.73.14-1.39.33-1.99.59-.6.26-1.14.6-1.61.99-.48.41-.89.9-1.22,1.48-.32.56-.59,1.23-.8,1.99-.39,1.43-.58,3.37-.58,5.76,0,1.4.03,2.49.09,3.43.07,1.06.17,1.94.3,2.68.13.76.33,1.47.58,2.12.27.67.58,1.21.95,1.66.38.47.85.88,1.41,1.22.54.32,1.16.58,1.85.77.69.19,1.48.33,2.35.41.88.09,1.88.14,2.98.14s2.09-.02,3.09-.05c.85-.03,1.63-.08,2.31-.16.67-.07,1.24-.17,1.74-.3.55-.14.99-.31,1.36-.51.39-.21.74-.47,1.05-.8.19-.19.35-.4.51-.64.17-.26.21-.56.13-.85-.08-.3-.28-.53-.56-.66l-1.42-.67c-.42-.2-.91-.1-1.22.25-.05.06-.11.11-.16.16-.13.11-.24.19-.35.25-.14.07-.3.14-.47.2-.16.05-.37.09-.63.13-.25.04-.53.07-.85.09-.33.03-.68.05-1.05.06-.39.01-.88.02-1.48.02-.5,0-1.21,0-2.12,0s-1.71-.04-2.4-.11c-.7-.08-1.26-.18-1.73-.32-.44-.13-.82-.31-1.14-.54-.3-.21-.54-.46-.73-.74-.2-.32-.36-.68-.48-1.07-.12-.4-.21-.86-.26-1.37-.06-.56-.1-1.25-.13-2.02-.03-.8-.04-1.77-.04-2.9,0-1.06.02-1.92.07-2.62.05-.7.12-1.33.22-1.86.09-.47.22-.88.39-1.22.14-.28.31-.53.51-.73l.1-.09c.23-.21.52-.39.89-.54.38-.16.83-.27,1.33-.35.53-.08,1.2-.15,1.99-.19.79-.04,1.7-.06,2.78-.06s2.05.02,2.83.05c.84.03,1.46.08,1.95.13.48.06.91.15,1.25.27.33.11.6.25.82.43.2.16.38.37.52.62.15.27.26.6.34.97.16.83.24,2.09.24,3.86,0,.82-.01,1.53-.04,2.12-.03.67-.07,1.11-.12,1.45-.05.33-.11.64-.2.89-.07.23-.16.35-.2.39-.13.15-.34.22-.63.22-.17,0-.29-.03-.36-.05-.06-.02-.1-.04-.12-.06-.07-.07-.11-.15-.13-.17-.03-.06-.06-.12-.06-.17-.02-.11-.03-.26-.05-.46-.02-.18-.04-.44-.06-.74v-7.25c0-.57-.46-1.04-1.03-1.04h-2.15c-.44,0-.82.27-.97.66-.01-.01-.03-.02-.04-.03-.23-.16-.46-.29-.67-.37-.22-.1-.47-.17-.75-.22-.24-.04-.5-.08-.77-.1-.28-.02-.58-.03-.9-.03-.71,0-1.34.08-1.87.23-.57.16-1.06.41-1.46.73-.39.32-.7.68-.96,1.11-.25.42-.43.89-.54,1.39-.1.45-.18.98-.24,1.6-.05.6-.08,1.25-.08,1.94s.03,1.3.08,1.87c.05.56.13,1.08.24,1.55.11.47.3.92.56,1.32.26.39.57.73.97,1.02.4.29.89.5,1.45.64.54.13,1.15.2,1.85.2.54,0,1.05-.04,1.52-.13.47-.08.9-.21,1.28-.39.4-.19.76-.46,1.07-.82.02-.02.04-.04.06-.06,0,0,0,0,0,0,.26.38.59.66.98.84.36.17.76.29,1.19.37.89.15,1.98.14,2.8.01.44-.07.82-.17,1.14-.31.34-.14.66-.35.95-.61.27-.25.51-.55.72-.9.19-.34.36-.73.49-1.16.12-.41.22-.88.3-1.44.07-.5.12-1.08.16-1.81.04-.71.05-1.48.05-2.28,0-1.04-.04-1.99-.11-2.82Zm-13.6,6.38c-.02-.28-.04-.59-.04-.96v-1.58c0-.48.04-.92.11-1.3.07-.33.15-.58.27-.75l.02-.04c.09-.11.23-.2.44-.27.3-.1.7-.15,1.2-.15.44,0,.81.05,1.1.14.24.08.43.19.57.35.14.16.25.38.33.67.09.33.14.73.14,1.19v1.36c0,.43-.01.82-.04,1.14-.03.31-.06.58-.12.8-.03.16-.1.3-.18.42-.06.09-.15.17-.25.24l-.08.04c-.15.09-.35.16-.6.21-.53.1-1.41.12-1.88,0-.19-.04-.35-.1-.45-.18-.12-.08-.21-.17-.27-.27-.07-.1-.11-.22-.15-.36-.04-.19-.07-.43-.09-.7Zm21.77-4.83h-5.06v-5.57h3.47c1.03,0,1.59-.56,1.59-1.59v-.95h7.37v22.92h-7.37v-14.81Zm29.57-2.1c.11,2.62-.72,4.77-2.9,5.46,2.44.56,3.9,2.54,3.78,5.46-.13,4.08-3.83,6.46-10.11,6.46s-9.98-2.38-10.11-6.46c-.11-2.92,1.34-4.9,3.78-5.46-2.18-.69-3.01-2.83-2.9-5.46.15-4.06,3.34-6.46,9.22-6.46s9.08,2.39,9.22,6.46Zm-9.22,12.12c1.97,0,2.9-.9,2.92-2.16,0-1.31-.9-2.15-2.92-2.15s-2.92.84-2.92,2.15c.02,1.28.9,2.16,2.92,2.16Zm0-9.03c1.87,0,2.64-.84,2.64-2.11-.02-1.36-.88-2.2-2.64-2.2s-2.62.88-2.62,2.2c-.02,1.28.77,2.11,2.62,2.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m29.87,58.09h-9.51V24.56h9.51v33.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m38.95,21.59c3.29.02,5.43,2.07,5.43,4.6s-2.14,4.63-5.43,4.63-5.5-2.07-5.5-4.63,2.16-4.6,5.5-4.6Zm4.74,36.49h-9.53v-25.33h9.53v25.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m50.34,58.09v-17.91h-3.73v-7.41h3.73v-3.29c0-3.22,2.44-5.41,6.65-5.41h8.93v6.54h-5.13c-1.31,0-1.75.6-1.75,1.4v.76h6.88v7.41h-6.88v17.91h-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m94.63,39.44c1.01,2.19,1.29,4.83,1.24,7.69h-18.37c.44,2.9,2.14,4.4,4.44,4.4,1.89,0,3.52-.85,4.03-3.04l9.74-.02c-.73,6.71-6.73,10.06-13.77,10.06-8.5,0-14.09-4.44-14.09-13.1s5.6-13.1,14.11-13.1c6.26,0,10.66,2.72,12.66,7.11Zm-8.52,3.2c-.05-.23-.09-.46-.16-.67-.58-1.93-2-2.92-3.98-2.92-2.14,0-3.64,1.2-4.26,3.59h8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m94.63,39.44c1.01,2.19,1.29,4.83,1.24,7.69h-18.37c.44,2.9,2.14,4.4,4.44,4.4,1.89,0,3.52-.85,4.03-3.04l9.74-.02c-.73,6.71-6.73,10.06-13.77,10.06-8.5,0-14.09-4.44-14.09-13.1s5.6-13.1,14.11-13.1c6.26,0,10.66,2.72,12.66,7.11Zm-8.52,3.2c-.05-.23-.09-.46-.16-.67-.58-1.93-2-2.92-3.98-2.92-2.14,0-3.64,1.2-4.26,3.59h8.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m20.99,38.66c-.86-4.71-.87-9.5-.78-14.27,1.38.05,3.53.15,4.91.27,1.38.13,2.75.28,4.13.55-2.65.5-5.57.69-8.26.79,0,0,.79-.79.79-.79.09,4.49,0,9-.79,13.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m38.95,21.59c3.29.02,5.43,2.07,5.43,4.6s-2.14,4.63-5.43,4.63-5.5-2.07-5.5-4.63,2.16-4.6,5.5-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m34.55,27.54c-1.57-1.63-.41-4.59,1.59-5.35,1.87-.86,4.36-.61,5.69.99-.97-.18-1.82-.19-2.67-.1-2.48.2-4.8,1.68-4.61,4.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "m50.34,58.09v-17.91h-3.73v-7.41h3.73v-3.29c0-3.22,2.44-5.41,6.65-5.41h8.93v6.54h-5.13c-1.31,0-1.75.6-1.75,1.4v.76h6.88v7.41h-6.88v17.91h-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m51.17,31.42c-1.94-4.91,1.82-8.01,6.56-6.94.53.11,1.05.22,1.58.41-1.03.36-2.15.5-3.1.68-1.82.38-3.55,1.06-4.26,2.86-.34.81-.4,1.95-.77,2.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m70.31,38.66c1.25-4.76,7.22-6.84,11.65-5.51-4.28,1.14-8.45,2.25-11.65,5.51h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -2.72,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 3.37,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 9.45,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.54,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 21.62,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 27.71,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 33.8,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 39.88,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 45.97,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 52.05,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 58.14,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64.23,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 70.31,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 76.4,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 82.48,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 88.57,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 94.66,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 100.74,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 106.83,
    y: -108.69,
    width: 6.09,
    height: 233.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -5.07,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 0.21,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 5.49,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 10.77,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 16.05,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 21.33,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 26.61,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 31.89,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 37.17,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 42.45,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 47.73,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 53.01,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 58.29,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 63.57,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 68.85,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.13,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 79.41,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 84.69,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.97,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 95.25,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 100.53,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 105.81,
    y: -60.58,
    width: 5.28,
    height: 175.56
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 0,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.28,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 13.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 17.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 21.14,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 25.09,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 29.05,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.95,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 40.91,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 44.86,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 48.81,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 52.76,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 56.72,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.67,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 64.62,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 68.57,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 72.53,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 76.48,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 80.43,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 84.38,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 88.34,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 92.29,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 96.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 100.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 104.15,
    y: -16.23,
    width: 3.95,
    height: 131.42
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -2.72,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 3.37,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 9.45,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.54,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 21.62,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 27.71,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 33.8,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 39.88,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 45.97,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 52.05,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 58.14,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64.23,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 70.31,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 76.4,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 82.48,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 88.57,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 94.66,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 100.74,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 106.83,
    y: -108.69,
    width: 6.09,
    height: 233.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -5.07,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 0.21,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 5.49,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 10.77,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 16.05,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 21.33,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 26.61,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 31.89,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 37.17,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 42.45,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 47.73,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 53.01,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 58.29,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 63.57,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 68.85,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.13,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 79.41,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 84.69,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.97,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 95.25,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 100.53,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 105.81,
    y: -60.58,
    width: 5.28,
    height: 175.56
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-300"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 0,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.28,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 13.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 17.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 21.14,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 25.09,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 29.05,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.95,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 40.91,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 44.86,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 48.81,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 52.76,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 56.72,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.67,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 64.62,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 68.57,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 72.53,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 76.48,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 80.43,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 84.38,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 88.34,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 92.29,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 96.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 100.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 104.15,
    y: -16.23,
    width: 3.95,
    height: 131.42
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-293"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -2.72,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 3.37,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 9.45,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.54,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 21.62,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 27.71,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 33.8,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 39.88,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 45.97,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 52.05,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 58.14,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64.23,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 70.31,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 76.4,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 82.48,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 88.57,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 94.66,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 100.74,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 106.83,
    y: -108.69,
    width: 6.09,
    height: 233.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -5.07,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 0.21,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 5.49,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 10.77,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 16.05,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 21.33,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 26.61,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 31.89,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 37.17,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 42.45,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 47.73,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 53.01,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 58.29,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 63.57,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 68.85,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.13,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 79.41,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 84.69,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.97,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 95.25,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 100.53,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 105.81,
    y: -60.58,
    width: 5.28,
    height: 175.56
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 0,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.28,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 13.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 17.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 21.14,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 25.09,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 29.05,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.95,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 40.91,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 44.86,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 48.81,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 52.76,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 56.72,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.67,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 64.62,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 68.57,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 72.53,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 76.48,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 80.43,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 84.38,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 88.34,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 92.29,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 96.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 100.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 104.15,
    y: -16.23,
    width: 3.95,
    height: 131.42
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -2.72,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 3.37,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 9.45,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.54,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 21.62,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 27.71,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 33.8,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 39.88,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 45.97,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 52.05,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 58.14,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64.23,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 70.31,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 76.4,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 82.48,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 88.57,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 94.66,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 100.74,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 106.83,
    y: -108.69,
    width: 6.09,
    height: 233.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -5.07,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 0.21,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 5.49,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 10.77,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 16.05,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 21.33,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 26.61,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 31.89,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 37.17,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 42.45,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 47.73,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 53.01,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 58.29,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 63.57,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 68.85,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.13,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 79.41,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 84.69,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.97,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 95.25,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 100.53,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 105.81,
    y: -60.58,
    width: 5.28,
    height: 175.56
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 0,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.28,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 13.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 17.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 21.14,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 25.09,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 29.05,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.95,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 40.91,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 44.86,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 48.81,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 52.76,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 56.72,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.67,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 64.62,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 68.57,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 72.53,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 76.48,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 80.43,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 84.38,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 88.34,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 92.29,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 96.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 100.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 104.15,
    y: -16.23,
    width: 3.95,
    height: 131.42
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -2.72,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 3.37,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 9.45,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.54,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 21.62,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 27.71,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 33.8,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 39.88,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 45.97,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 52.05,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 58.14,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64.23,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 70.31,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 76.4,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 82.48,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 88.57,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 94.66,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 100.74,
    y: -108.69,
    width: 6.09,
    height: 233.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 106.83,
    y: -108.69,
    width: 6.09,
    height: 233.8
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -5.07,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 0.21,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 5.49,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 10.77,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 16.05,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 21.33,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 26.61,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 31.89,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 37.17,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 42.45,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 47.73,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 53.01,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 58.29,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 63.57,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 68.85,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.13,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 79.41,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 84.69,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 89.97,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 95.25,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 100.53,
    y: -60.58,
    width: 5.28,
    height: 175.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 105.81,
    y: -60.58,
    width: 5.28,
    height: 175.56
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 0,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.28,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 13.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 17.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 21.14,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 25.09,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 29.05,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 33,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.95,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 40.91,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 44.86,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 48.81,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 52.76,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 56.72,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.67,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 64.62,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 68.57,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 72.53,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 76.48,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 80.43,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 84.38,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 88.34,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 92.29,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 96.24,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 100.19,
    y: -16.23,
    width: 3.95,
    height: 131.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 104.15,
    y: -16.23,
    width: 3.95,
    height: 131.42
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.19293135c4a5fd44b9216938bb8356e4.svg";
export { ForwardRef as ReactComponent };